/*
 * Tattup Studio – own custom-tattoo customizer (v2).
 * Renders into #czs (sections/cz-studio.liquid). Data: #czs-data (sizes, prices, texts),
 * #cz-mockups (body photos + skin masks + calibration), #cz-fonts (self-hosted fonts), #cz-inspo,
 * #czs-payments (payment icons).
 *
 * Canvas model: the design lives in "logical" space with LOGICAL px per cm (e.g. S 5 × 9 cm =
 * 200 × 360). The Fabric canvas fills the whole stage; the print area is drawn as a white sheet
 * via the viewport transform, everything outside it is dimmed (so handles stay reachable when an
 * element is larger than the sheet). Print files are rendered off-screen from the same objects at
 * 300 DPI. The skin view draws the design in true size on a calibrated body photo, masked to the
 * skin and wrapped around the limb.
 */
(function () {
  'use strict';

  var root = document.getElementById('czs');
  if (!root || !window.fabric) return;
  var F = window.fabric;

  function readJSON(id) { var el = document.getElementById(id); try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } }
  var DATA = readJSON('czs-data') || {};
  /* builder statistics (owner 29.10.2026, tattup-own-apps «Statistik › Builder»): where this visit came from – nl = a
     Klaviyo mail, ads = Google / Meta, other – taken from the first page of the visit: the shop statistics' landing data
     (assets/tt-stats.js, sessionStorage «tt-st-l») or, when the studio is the first page, this address. Kept for the visit. */
  var VISIT = (function () {
    var clean = function (v, n) { return String(v || '').toLowerCase().replace(/[^a-z0-9._ -]/g, '').trim().slice(0, n || 30); };
    var of = function (src, med, camp, kx, click) {
      var nl = /klaviyo/.test(src) || med === 'email' || kx;
      return { s: nl ? 'nl' : click || /google|facebook|meta|instagram|^ig$|^fb$/.test(src) || med === 'cpc' ? 'ads' : 'other', c: nl ? clean(camp || src, 40) : '' };
    };
    try {
      var kept = JSON.parse(sessionStorage.getItem('czs-visit') || 'null'); if (kept && kept.s) return kept;
      var land = JSON.parse(sessionStorage.getItem('tt-st-l') || 'null'), v;
      if (land && land.c) { var p = String(land.c).split('|'); v = of(p[0], p[1], p[2], false, false); }
      else {
        var sp = new URLSearchParams(location.search);
        v = of(clean(sp.get('utm_source')), clean(sp.get('utm_medium')), clean(sp.get('utm_campaign'), 40), !!sp.get('_kx'), !!(sp.get('gclid') || sp.get('gbraid') || sp.get('wbraid') || sp.get('fbclid')));
      }
      sessionStorage.setItem('czs-visit', JSON.stringify(v));
      return v;
    } catch (e) { return { s: 'other', c: '' }; }
  })();
  /* bo = builder opened, bd = a builder design put in the cart → /api/stats-event (same rules as assets/tt-stats.js: never
     our own checks ?tt_test=1 or automated browsers; ?tt_stats_test=1 counts as test data) */
  function trackBuilder(kind, b) {
    try {
      if (!DATA.api || !navigator.sendBeacon) return;
      var test = /[?&]tt_stats_test=1(&|$)/.test(location.search) || sessionStorage.getItem('tt-stats-test') === '1';
      if (!test && (navigator.webdriver || /[?&]tt_test=1(&|$)/.test(location.search) || sessionStorage.getItem('tt-st-skip') === '1' || /TattupQuickCheck|HeadlessChrome/i.test(navigator.userAgent || ''))) return;
      var d = window.innerWidth < 768 ? 'p' : window.innerWidth < 1024 ? 't' : 'd';
      var body = { v: 1, m: String((window.Shopify && Shopify.country) || '').toUpperCase(), l: String(DATA.locale || '').slice(0, 5), d: d, g: 'custom', a: '0', e: [[kind, b + '|' + VISIT.s + '|' + VISIT.c, 1]] };
      if (test) body.t = 1;
      navigator.sendBeacon(DATA.api.replace(/\/$/, '') + '/api/stats-event', new Blob([JSON.stringify(body)], { type: 'text/plain' }));
    } catch (e) {}
  }
  var MOCK = readJSON('cz-mockups') || { list: [], files: {} };
  var FONTS = readJSON('cz-fonts') || [];
  var INSPO_BASE = readJSON('cz-inspo') || { categories: [], items: [] };
  // further motif lists (snippets/cz-inspo-more-*.liquid; split because snippets are limited to 256 KB)
  Array.prototype.forEach.call(document.querySelectorAll('script.cz-inspo-more'), function (el) {
    try { INSPO_BASE.items = INSPO_BASE.items.concat(JSON.parse(el.textContent).items || []); } catch (e) {}
  });
  /* one motif menu for the studio and the builders: the source lists keep their own category ids,
     TAX groups them (no duplicate menus such as "Ornamente" + "Finger-Ornamente") */
  var TAX = [
    ['best', null, null, ['best']],
    ['sleeves', 'Sleeves', 'Sleeves', ['sleeves']],
    ['fine', 'Fine Line', 'Fine line', ['oneline', 'h-flourish', 'fineline']],
    ['script', 'Schrift/Script', 'Script', ['script', 'h-script']],
    ['symbols', 'Symbole', 'Symbols', ['symbols', 'h-bold']],
    ['zodiac', 'Sternzeichen', 'Zodiac', ['zodiac']],
    ['nature', 'Natur/Blumen', 'Nature/Flowers', ['nature']],
    ['animals', null, null, ['animals']], ['love', null, null, ['love']], ['spiritual', null, null, ['spiritual']],
    ['mandala', 'Mandala', 'Mandala', ['mandala']],
    ['geometry', 'Geometrie', 'Geometry', ['geometry']],
    ['orn', 'Ornamente & Finger', 'Ornaments & finger', ['ornaments', 'mini', 'h-finger', 'h-strings']],
    ['henna', 'Henna & Boho', 'Henna & boho', ['h-henna']],
    ['tribal', 'Tribal', 'Tribal', ['tribal', 'h-tribal']],
    ['trampstamp', 'Tramp Stamp', 'Tramp stamp', ['trampstamp']],
    ['oldschool', 'Oldschool', 'Old school', ['oldschool']],
    ['dark', 'Dark & Edgy', 'Dark & edgy', ['h-men', 'dark']],
    ['runes', 'Runen & Wikinger', 'Runes & Viking', ['myth', 'h-runes']],
    ['sigils', 'Sigils', 'Sigils', ['sigils', 'h-sigil']],
    ['space', null, null, ['space']], ['travel', null, null, ['travel']], ['genz', null, null, ['genz']]
  ];
  var HAND_SRC = readJSON('czh-data') || { categories: [], items: [] };
  // sleeve designs of the Sleeve Builder are motifs in the studio too
  var SLEEVE_SRC = { items: ((readJSON('czsl-data') || {}).items || []).map(function (it) { return { id: it.id, cat: 'sleeves', de: it.de, en: it.en, src: it.src }; }) };
  var HIDDEN = {};   // motif ids hidden in the production dashboard
  function taxOf(cat) { for (var i = 0; i < TAX.length; i++) if (TAX[i][3].indexOf(cat) > -1) return TAX[i][0]; return cat; }
  function regroup(items) { return items.filter(function (it) { return !HIDDEN[it.id]; }).map(function (it) { return Object.assign({}, it, { cat: taxOf(it.cat) }); }); }
  function taxCategories(items) {
    var base = INSPO_BASE.categories;
    return TAX.filter(function (tx) { return items.some(function (it) { return it.cat === tx[0]; }); }).map(function (tx) {
      var own = base.filter(function (c) { return c.id === tx[3][0]; })[0] || {};
      return { id: tx[0], de: tx[1] || own.de || tx[0], en: tx[2] || own.en || tx[0] };
    });
  }
  var INSPO = { categories: [], items: [] };
  function buildInspo() {
    var items = regroup(INSPO_BASE.items).concat(regroup(HAND_SRC.items), regroup(SLEEVE_SRC.items));
    INSPO.items = items; INSPO.categories = taxCategories(items);
  }
  buildInspo();
  var T = DATA.t || {};
  // Liquid's t filter HTML-escapes plain keys; decode them once so they can be escaped where used
  (function () {
    var ta = document.createElement('textarea');
    Object.keys(T).forEach(function (k) { if (!/_html$/.test(k) && /&[#a-z0-9]+;/i.test(T[k])) { ta.innerHTML = T[k]; T[k] = ta.value; } });
  })();

  var LOGICAL = 40;                 // logical px per cm
  var PRINT_PPC = 300 / 2.54;       // print px per cm (300 DPI)
  var INK = [10, 10, 13];           // tattoo ink tone for the skin preview
  var INK_SCALE = 2;                // skin preview renders the design at 2× photo resolution
  var MAX_UPLOAD = 10 * 1024 * 1024;   // designs: PNG, JPG, WebP, SVG (iPhone photos are decoded where the browser can)
  var MAX_PHOTO = 25 * 1024 * 1024;    // own body photo: never leaves the browser, phone photos are large
  var EDIT_MAX = 2400;              // longest side of images kept for editing
  var PROPS = ['czKind', 'czId', 'czBg', 'czFont', 'czScript', 'selectable', 'evented'];
  var RASTER = 2000;                // longest side of the on-screen raster of a motif (vectors are used for the print)
  var SIZE_NAMES = { xs: 'XS', s: 'S', m: 'M', l: 'L', xl: 'XL', huge: 'Huge', sleeve: 'Extra Huge' };   // overwritten by DATA.sizes[].short
  var LS = 'czs-';
  var CART_KEY = 'cart:';            // KV key prefix: design of a cart line, by its _cz_design_id

  // only the body areas listed in snippets/cz-mockups.liquid (cz_list, the ones we can measure), in that order
  var MOCK_ORDER = Object.keys(MOCK.files || {});
  MOCK.all = MOCK.list.filter(function (m) { return MOCK_ORDER.indexOf(m.id) > -1; }).sort(function (a, b) { return MOCK_ORDER.indexOf(a.id) - MOCK_ORDER.indexOf(b.id); });
  // builder-only photos (f-fullback for the Script Builder) are not body areas of the skin preview
  MOCK.list = MOCK.all.filter(function (m) { return !m.only; });
  MOCK.all.forEach(function (m) { var f = MOCK.files[m.id] || {}; m.img = f.img; m.mask = f.mask; m.thumb = f.thumb || f.img; });
  var SIZES = (DATA.sizes || []).filter(function (s) { return s.w > 0 && s.h > 0 && s.variants && s.variants.length; });
  SIZES.forEach(function (s) { s.variants.sort(function (a, b) { return a.qty - b.qty; }); if (s.short) SIZE_NAMES[s.code] = s.short; });
  if (!SIZES.length) return;

  /* ---------- helpers ---------- */
  function t(key, vars) {
    var s = T[key] || key;
    if (vars) Object.keys(vars).forEach(function (k) { s = s.split('{{ ' + k + ' }}').join(vars[k]); });
    return s;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(LS + k); if (v === null) localStorage.removeItem(LS + k); else localStorage.setItem(LS + k, v); } catch (e) { return null; } }
  /* number of tattoos (owner 28.10.2026: «überall immer 5 vorauswählen»): every visit starts at 5; only a quantity the
     customer picked himself (tap, cart line opened again, Sleeve Builder summary) stays – for this tab (sessionStorage),
     a new visit starts at 5 again. Before, the pick lived in localStorage for good and a fresh visit fell back to the
     first variant (3), so some saw 3 and others 5. */
  var DEFAULT_QTY = 5;
  store('qty', null); // the old lasting key
  function qtyPick(v) { try { if (v === undefined) return sessionStorage.getItem(LS + 'qty'); sessionStorage.setItem(LS + 'qty', v); } catch (e) { return null; } }
  /* larger data stays in the browser's IndexedDB (designs of cart lines incl. their images, the own
     body photo); localStorage is only a fallback. Nothing of it is ever uploaded. */
  var KV = (function () {
    var dbp = null;
    function db() {
      if (dbp) return dbp;
      dbp = new Promise(function (res, rej) {
        try {
          var r = indexedDB.open('czs-studio', 1);
          r.onupgradeneeded = function () { r.result.createObjectStore('kv'); };
          r.onsuccess = function () { res(r.result); };
          r.onerror = function () { rej(r.error); };
        } catch (e) { rej(e); }
      });
      return dbp;
    }
    function run(mode, fn) {
      return db().then(function (d) {
        return new Promise(function (res, rej) {
          var tx = d.transaction('kv', mode), req = fn(tx.objectStore('kv'));
          tx.oncomplete = function () { res(req ? req.result : undefined); };
          tx.onerror = tx.onabort = function () { rej(tx.error); };
        });
      });
    }
    function lsKey(k) { return LS + 'kv-' + k; }
    return {
      get: function (k) { return run('readonly', function (s) { return s.get(k); }).catch(function () { try { var v = localStorage.getItem(lsKey(k)); return v ? JSON.parse(v) : undefined; } catch (e) { return undefined; } }); },
      set: function (k, v) { return run('readwrite', function (s) { s.put(v, k); }).catch(function () { try { localStorage.setItem(lsKey(k), JSON.stringify(v)); } catch (e) {} }); },
      // like set, but rejects when neither IndexedDB nor the localStorage fallback could keep it (storage full or blocked)
      put: function (k, v) { return run('readwrite', function (s) { s.put(v, k); }).catch(function () { localStorage.setItem(lsKey(k), JSON.stringify(v)); }); },
      del: function (k) { try { localStorage.removeItem(lsKey(k)); } catch (e) {} return run('readwrite', function (s) { s['delete'](k); }).catch(function () {}); },
      keys: function () { return run('readonly', function (s) { return s.getAllKeys(); }).catch(function () { return []; }); }
    };
  })();
  function uid() { return (Date.now().toString(36) + Math.random().toString(36).slice(2, 8)); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function smooth(e0, e1, x) { var k = clamp((x - e0) / (e1 - e0), 0, 1); return k * k * (3 - 2 * k); }
  var isTouch = window.matchMedia('(pointer: coarse)').matches;
  function isMobile() { return window.matchMedia('(max-width: 1023px)').matches; }
  function fmtCm(v) { return String(v).replace('.', DATA.locale && DATA.locale.indexOf('de') === 0 ? ',' : '.'); }

  function formatMoney(cents) {
    var fmt = DATA.moneyFormat || '{{amount}}';
    function delim(n, prec, th, dec) {
      var parts = (n / 100).toFixed(prec).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (parts[1] ? dec + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return delim(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return delim(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delim(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delim(cents, 2, "'", '.');
        default: return delim(cents, 2, ',', '.');
      }
    }).replace(/<[^>]+>/g, '');
  }

  function svg(path, sw) { return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' + (sw || 1.9) + '" stroke-linecap="round" stroke-linejoin="round">' + path + '</svg>'; }
  var ICON = {
    back: svg('<path d="M19 12H5M11 6l-6 6 6 6"/>', 2),
    undo: svg('<path d="M9 14L4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 010 11H11"/>', 2),
    redo: svg('<path d="M15 14l5-5-5-5"/><path d="M20 9H9.5a5.5 5.5 0 000 11H13"/>', 2),
    help: svg('<circle cx="12" cy="12" r="9.5"/><path d="M9.5 9a2.6 2.6 0 015 1c0 1.8-2.5 2.2-2.5 4"/><path d="M12 17.5h.01"/>', 2),
    bag: svg('<path d="M5 8h14l-1.2 11.2A2 2 0 0115.8 21H8.2a2 2 0 01-2-1.8z"/><path d="M9 8V6.5a3 3 0 016 0V8"/>', 2),
    upload: svg('<path d="M12 15V4M7 8.5L12 4l5 4.5"/><path d="M4 15v3.5A1.5 1.5 0 005.5 20h13a1.5 1.5 0 001.5-1.5V15"/>'),
    inspo: svg('<path d="M12 3l2.2 5.4L20 9.2l-4.4 3.9 1.3 5.8L12 16l-4.9 2.9 1.3-5.8L4 9.2l5.8-.8z"/>'),
    text: svg('<path d="M5 6V4.5h14V6M12 4.5v15M9 19.5h6"/>'),
    draw: svg('<path d="M4 20l4.2-1 10.6-10.6a2.1 2.1 0 00-3-3L5.2 16 4 20z"/><path d="M14 7l3 3"/>'),
    ai: svg('<path d="M10 3.5l1.6 4.4L16 9.5l-4.4 1.6L10 15.5l-1.6-4.4L4 9.5l4.4-1.6z"/><path d="M17.5 13.5l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z"/>'),
    close: svg('<path d="M6 6l12 12M18 6L6 18"/>', 2),
    plus: svg('<path d="M12 5v14M5 12h14"/>', 2),
    minus: svg('<path d="M5 12h14"/>', 2),
    fit: svg('<path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/>', 2),
    flip: svg('<path d="M12 3v18"/><path d="M8 7L3 17h5zM16 7l5 10h-5z"/>'),
    up: svg('<path d="M12 19V6M6.5 11.5L12 6l5.5 5.5"/>'),
    down: svg('<path d="M12 5v13M6.5 12.5L12 18l5.5-5.5"/>'),
    trash: svg('<path d="M4 7h16M10 11v6M14 11v6M6 7l1 12.5A1.5 1.5 0 008.5 21h7a1.5 1.5 0 001.5-1.5L18 7M9 7V4.5A1.5 1.5 0 0110.5 3h3A1.5 1.5 0 0115 4.5V7"/>'),
    center: svg('<path d="M12 3v4M12 17v4M3 12h4M17 12h4"/><circle cx="12" cy="12" r="3"/>'),
    bg: svg('<rect x="3.5" y="3.5" width="17" height="17" rx="2.5" stroke-dasharray="3 2.4"/><path d="M8 15.5l3-3.5 2.2 2.4 1.6-1.8 2.7 3"/>'),
    edit: svg('<path d="M4 20l4.2-1 10.6-10.6a2.1 2.1 0 00-3-3L5.2 16 4 20z"/>'),
    expand: svg('<path d="M14 4h6v6M10 20H4v-6M20 4l-7 7M4 20l7-7"/>', 2.2),
    reset: svg('<path d="M4 12a8 8 0 108-8H7"/><path d="M9.5 1.5L7 4l2.5 2.5"/>', 2),
    ruler: svg('<rect x="2.5" y="7.5" width="19" height="9" rx="1.6"/><path d="M6.5 7.5v3M10 7.5v4.5M13.5 7.5v3M17 7.5v4.5"/>', 1.8),
    rotate: svg('<path d="M20 12a8 8 0 11-2.3-5.6"/><path d="M20 4v5h-5"/>', 2),
    truck: svg('<path d="M3 6h11v10H3zM14 9h4l3 3v4h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>', 2),
    lock: svg('<rect x="5" y="10.5" width="14" height="10" rx="2"/><path d="M8 10.5V8a4 4 0 018 0v2.5"/>', 2),
    check: svg('<path d="M5 12l5 5 9-10"/>', 2.4),
    chev: svg('<path d="M6 9l6 6 6-6"/>', 2.4),
    body: svg('<circle cx="12" cy="4.5" r="2"/><path d="M8.5 9h7l-1 6h-1.2l-.6 6.5h-1.4l-.6-6.5H9.5z"/>', 1.9),
    crop: svg('<path d="M6 2v14a2 2 0 002 2h14"/><path d="M18 22V8a2 2 0 00-2-2H2"/>'),
    hand: svg('<path d="M8 13V5.5a1.5 1.5 0 013 0V11M11 10.5V4a1.5 1.5 0 013 0v6.5M14 10.5V5.5a1.5 1.5 0 013 0V13M8 12.5V9.5a1.5 1.5 0 00-3 0V15a6 6 0 006 6h1.5a5.5 5.5 0 005.5-5.5V11.5a1.5 1.5 0 00-3 0"/>'),
    builder: svg('<rect x="3" y="3" width="7.5" height="9" rx="1.6"/><rect x="13.5" y="3" width="7.5" height="5" rx="1.6"/><rect x="13.5" y="11" width="7.5" height="10" rx="1.6"/><rect x="3" y="15" width="7.5" height="6" rx="1.6"/>'),
    pin: svg('<path d="M12 21s7-6.2 7-11.5a7 7 0 10-14 0C5 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/>', 2),
    scale: svg('<path d="M14 4h6v6M10 20H4v-6M20 4l-7 7M4 20l7-7"/>', 2),
    target: svg('<circle cx="12" cy="12" r="7.5"/><circle cx="12" cy="12" r="2.2"/><path d="M12 1.5v3M12 19.5v3M1.5 12h3M19.5 12h3"/>'),
    camera: svg('<path d="M4 8.5A1.5 1.5 0 015.5 7h2.2l1.6-2.2h5.4L16.3 7h2.2A1.5 1.5 0 0120 8.5v9a1.5 1.5 0 01-1.5 1.5h-13A1.5 1.5 0 014 17.5z"/><circle cx="12" cy="13" r="3.4"/>'),
    alignL: svg('<path d="M4 6h16M4 10h10M4 14h16M4 18h10"/>', 2),
    alignC: svg('<path d="M4 6h16M7 10h10M4 14h16M7 18h10"/>', 2),
    alignR: svg('<path d="M4 6h16M10 10h10M4 14h16M10 18h10"/>', 2)
  };

  /* ---------- state ---------- */
  var state = {
    size: null,
    gender: store('gender') || null,
    mode: 'design',
    tool: null,
    qty: +(qtyPick() || 0) || DEFAULT_QTY,
    spot: {},
    place: {},
    zoom: 1,
    busy: false,
    added: false,
    skinVisited: false
  };
  var imgs = {};            // czId -> { raw, clean, file, w, h, kind }
  var history = [];
  var hIndex = -1;
  var restoring = false;
  // the layout as the customer arranged it, while a size change shows it centred / reduced on another sheet: every
  // later size change starts again from this layout (no drift, it can grow back); the next own edit replaces it
  var sizeBase = null, sizing = false;
  var view = { z: 1, ox: 0, oy: 0 };   // canvas viewport: logical -> screen

  function sizeByCode(code) { for (var i = 0; i < SIZES.length; i++) if (SIZES[i].code === code) return SIZES[i]; return null; }
  function curSize() { return sizeByCode(state.size) || SIZES[0]; }
  function LW() { return curSize().w * LOGICAL; }
  function LH() { return curSize().h * LOGICAL; }
  // short name (Huge / Extra Huge, theme snippets/size-name form base) where space is tight; long = full name from the theme (snippets/size-name: "Huge (Half Sleeve)", "Extra Huge (Sleeve)")
  function sizeLabel(s, long) { s = s || curSize(); return ((long && s.name) || SIZE_NAMES[s.code] || s.code) + ' · ' + fmtCm(s.w) + ' × ' + fmtCm(s.h) + ' ' + t('cm'); }
  // a size without that quantity: the nearest available one (all 7 sizes have 3/5/10/20/30/50 as of 28.10.2026)
  function nearestVariant(list, q) {
    var pool = list.filter(function (x) { return x.available !== false; }); if (!pool.length) pool = list;
    return pool.reduce(function (a, b) { return Math.abs(b.qty - q) < Math.abs(a.qty - q) ? b : a; });
  }
  function curVariant() {
    var s = curSize(); var v = null;
    s.variants.forEach(function (x) { if (x.qty === state.qty) v = x; });
    if (!v) { v = nearestVariant(s.variants, state.qty || DEFAULT_QTY); state.qty = v.qty; }
    return v;
  }

  /* ---------- layout ---------- */
  /* "Masse": the body measurements every mockup is calibrated to (MOCK.model, snippets/cz-mockups.liquid) */
  function measureHtml() {
    var M = MOCK.model || {}, f = M.f || {}, m = M.m || {};
    var cell = function (v) { return '<td>' + (v ? esc(fmtCm(v)) + ' ' + esc(t('cm')) : '–') + '</td>'; };
    var row = function (k, a, b) { return '<tr><th scope="row">' + esc(t(k)) + '</th>' + cell(a) + cell(b) + '</tr>'; };
    // owner 20.10.2026: only height, arm and hand – and how to measure arm and hand, each with an animated icon
    return '<button type="button" class="czs-meas__x" data-act="measure" aria-label="' + esc(t('close')) + '">' + ICON.close + '</button>' +
      '<h3 class="czs-meas__title">' + ICON.ruler + '<span>' + esc(t('measure_title')) + '</span></h3>' +
      '<table class="czs-meas__tbl"><thead><tr><td></td><th scope="col">' + esc(t('gender_f')) + '</th><th scope="col">' + esc(t('gender_m')) + '</th></tr></thead><tbody>' +
      row('measure_height', f.h, m.h) + row('measure_arm', f.arm, m.arm) + row('measure_hand', f.hand, m.hand) + '</tbody></table>' +
      '<div class="czs-meas__how"><h4>' + esc(t('measure_how')) + '</h4><div class="czs-meas__pair">' +
      '<figure>' + MEASURE_ARM + '<figcaption>' + esc(t('measure_step_arm')) + '</figcaption></figure>' +
      '<figure>' + MEASURE_HAND + '<figcaption>' + esc(t('measure_step_hand')) + '</figcaption></figure></div></div>';
  }
  /* white figure + lime measuring line that draws itself (CSS .czs-meas__ln): arm = top of the shoulder to the wrist,
     hand = wrist crease to the middle fingertip */
  var MEASURE_ARM = '<svg viewBox="0 0 100 120" aria-hidden="true"><g class="czs-meas__fig">' +
    '<circle cx="54" cy="14" r="9"/><rect x="50" y="21" width="8" height="8" rx="2"/>' +
    '<path d="M37 30q17-5 34 0l4 6-4 48H38l-4-48z"/>' +
    '<path class="czs-meas__limb" d="M35 35l-6 38-2 31M73 35l6 38 2 31"/></g>' +
    '<g class="czs-meas__tick"><path d="M16 30h22M14 104h18"/></g>' +
    '<path class="czs-meas__ln" pathLength="100" d="M18 30v74"/></svg>';
  var MEASURE_HAND = '<svg viewBox="0 0 100 120" aria-hidden="true"><g class="czs-meas__fig">' +
    '<rect x="30" y="34" width="9" height="34" rx="4.5"/><rect x="40" y="22" width="9" height="46" rx="4.5"/>' +
    '<rect x="50" y="18" width="9" height="50" rx="4.5"/><rect x="60" y="26" width="9" height="42" rx="4.5"/>' +
    '<rect x="66" y="62" width="9" height="28" rx="4.5" transform="rotate(-38 70 76)"/>' +
    '<path d="M30 58h39v24q0 12-12 14H42q-12-2-12-14z"/><rect x="38" y="95" width="23" height="18" rx="3"/></g>' +
    '<g class="czs-meas__tick"><path d="M14 96h30M14 18h40"/></g>' +
    '<path class="czs-meas__ln" pathLength="100" d="M18 96V18"/></svg>';
  function measureAway(ev) {
    if (ev.type === 'keydown' ? ev.key === 'Escape' : !ev.target.closest('.czs-meas, .czs-measbtn')) setMeasure(false);
  }
  function setMeasure(open) {
    var p = $('.czs-meas'), b = $('.czs-measbtn'); if (!p) return;
    p.hidden = !open; if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
    // closes on a tap/click outside and on Escape
    ['pointerdown', 'keydown'].forEach(function (n) { document[open ? 'addEventListener' : 'removeEventListener'](n, measureAway, true); });
  }
  function toolBtn(id) {
    return '<button type="button" class="czs-tool czs-tool--' + id + '" data-tool="' + id + '" aria-pressed="false">' + ICON[id] + '<span>' + esc(t('tool_' + id)) + '</span></button>';
  }
  root.innerHTML = [
    '<header class="czs-top">',
    '  <a class="czs-back" href="' + esc(DATA.routes && DATA.routes.root || '/') + '">' + ICON.back + '<span>' + esc(t('back')) + '</span></a>',
    // the Tattup logo (shop file, drawn white) leads back to the shop like the back link
    '  <a class="czs-brand' + (DATA.logo ? ' czs-brand--logo' : '') + '" href="' + esc(DATA.routes && DATA.routes.root || '/') + '"' + (DATA.logo ? ' aria-label="Tattup"><img src="' + esc(DATA.logo) + '" alt="Tattup" width="137" height="52">' : '>' + t('brand_html')) + '</a>',
    '  <div class="czs-editing" hidden>' + ICON.edit + '<span>' + esc(t('edit_mode')) + '</span><button type="button" data-act="edit-stop" aria-label="' + esc(t('edit_stop')) + '" title="' + esc(t('edit_stop')) + '">' + ICON.close + '</button></div>',
    '  <div class="czs-top__act">',
    '    <button type="button" class="czs-ibtn" data-act="undo" aria-label="' + esc(t('undo')) + '" title="' + esc(t('undo')) + '" disabled>' + ICON.undo + '</button>',
    '    <button type="button" class="czs-ibtn" data-act="redo" aria-label="' + esc(t('redo')) + '" title="' + esc(t('redo')) + '" disabled>' + ICON.redo + '</button>',
    '    <button type="button" class="czs-ibtn" data-act="help" aria-label="' + esc(t('help')) + '" title="' + esc(t('help')) + '">' + ICON.help + '</button>',
    '    <button type="button" class="czs-ibtn czs-cartbtn" data-act="drawer" aria-label="' + esc(t('cart_open')) + '" title="' + esc(t('cart_open')) + '">' + ICON.bag + '<i class="czs-badge" hidden></i></button>',
    '  </div>',
    '</header>',
    '<nav class="czs-sizes" aria-label="' + esc(t('sizes_label')) + '"><div class="czs-sizes__track"></div></nav>',
    '<div class="czs-main" id="czs-main">',
    '  <section class="czs-stage">',
    '    <div class="czs-mode" role="tablist" aria-label="' + esc(t('mode_label')) + '">',
    '      <span class="czs-mode__pill" aria-hidden="true"></span>',
    '      <button type="button" role="tab" data-mode="design" aria-selected="true">' + ICON.edit + '<span>' + esc(t('mode_design')) + '</span></button>',
    '      <button type="button" role="tab" data-mode="skin" aria-selected="false">' + ICON.body + '<span>' + esc(t('mode_skin')) + '</span></button>',
    '    </div>',
    '    <button type="button" class="czs-sizebtn" data-act="size-sheet"><small>' + esc(t('size_short')) + '</small><b></b>' + ICON.chev + '</button>',
    '    <div class="czs-view czs-view--design">',
    '      <div class="czs-board"><canvas id="czs-canvas"></canvas></div>',
    '      <div class="czs-frame" aria-hidden="true">',
    '        <div class="czs-ruler czs-ruler--top"><span></span></div>',
    '        <div class="czs-ruler czs-ruler--side"><span></span></div>',
    '        <div class="czs-guide czs-guide--v"></div><div class="czs-guide czs-guide--h"></div>',
    '        <div class="czs-empty" hidden></div>',
    '      </div>',
    '      <div class="czs-zoom">',
    '        <button type="button" class="czs-ibtn" data-zoom="in" aria-label="' + esc(t('zoom_in')) + '" title="' + esc(t('zoom_in')) + '">' + ICON.plus + '</button>',
    '        <button type="button" class="czs-ibtn" data-zoom="out" aria-label="' + esc(t('zoom_out')) + '" title="' + esc(t('zoom_out')) + '">' + ICON.minus + '</button>',
    '        <button type="button" class="czs-ibtn" data-zoom="fit" aria-label="' + esc(t('zoom_reset')) + '" title="' + esc(t('zoom_reset')) + '">' + ICON.fit + '</button>',
    '      </div>',
    '      <nav class="czs-tools" role="toolbar" aria-label="' + esc(t('tools_label')) + '">' + toolBtn('upload') + toolBtn('inspo') + toolBtn('text') + toolBtn('draw') + toolBtn('ai') + (DATA.hand && DATA.hand.js ? toolBtn('builder') : '') + '</nav>',
    '      <div class="czs-objbar" role="toolbar" aria-label="' + esc(t('obj_label')) + '" hidden></div>',
    '    </div>',
    '    <div class="czs-view czs-view--skin">',
    '      <div class="czs-skinwrap"><canvas class="czs-skincanvas"></canvas>',
    '        <div class="czs-skinui" hidden><svg class="czs-skinui__link" aria-hidden="true"><polygon class="czs-skinui__box"></polygon><line></line></svg>',
    '          <span class="czs-sdim" data-sdim="w" aria-hidden="true"></span><span class="czs-sdim" data-sdim="h" aria-hidden="true"></span>',
    '          <button type="button" class="czs-skinrot" aria-label="' + esc(t('skin_rotate')) + '" title="' + esc(t('skin_rotate')) + '">' + ICON.rotate + '</button>',
    '          <button type="button" class="czs-skinscale" aria-label="' + esc(t('own_scale')) + '" title="' + esc(t('own_scale')) + '" hidden>' + ICON.scale + '</button>',
    '        </div>',
    '      </div>',
    '      <button type="button" class="czs-ownnew" data-act="own-new" hidden>' + ICON.camera + '<span>' + esc(t('own_new')) + '</span></button>',
    '      <input type="file" class="czs-ownfile" accept="image/png,image/jpeg,image/webp,image/heic,image/heif,.heic,.heif" hidden>',
    '      <span class="czs-real">' + esc(t('skin_real')) + '</span>',
    '      <div class="czs-skin__ctrl">',
    '        <button type="button" class="czs-ibtn" data-szoom="in" aria-label="' + esc(t('zoom_in')) + '" title="' + esc(t('zoom_in')) + '">' + ICON.plus + '</button>',
    '        <button type="button" class="czs-ibtn" data-szoom="out" aria-label="' + esc(t('zoom_out')) + '" title="' + esc(t('zoom_out')) + '">' + ICON.minus + '</button>',
    '        <button type="button" class="czs-ibtn" data-szoom="reset" aria-label="' + esc(t('skin_reset')) + '" title="' + esc(t('skin_reset')) + '">' + ICON.reset + '</button>',
    '        <button type="button" class="czs-ibtn czs-measbtn" data-act="measure"' + (MOCK.model ? '' : ' hidden') + ' aria-expanded="false" aria-controls="czs-meas" aria-label="' + esc(t('measure_btn')) + '" title="' + esc(t('measure_btn')) + '">' + ICON.ruler + '</button>',
    '      </div>',
    '      <div class="czs-meas" id="czs-meas" role="dialog" aria-label="' + esc(t('measure_title')) + '" hidden>' + measureHtml() + '</div>',
    '      <p class="czs-note" hidden><span></span><button type="button" class="czs-note__x" data-act="note-x" aria-label="' + esc(t('close')) + '">' + ICON.close + '</button></p>',
    '      <div class="czs-skin__empty" hidden><p></p></div>',
    '      <div class="czs-handview" hidden><img alt=""><button type="button" class="czs-btn czs-btn--accent" data-act="hand">' + ICON.hand + '<span>' + esc(t('hand_edit')) + '</span></button></div>',
    '      <div class="czs-skinbar">',
    '        <p class="czs-realnote"></p>',
    '        <div class="czs-skinbar__row">',
    '          <div class="czs-seg" role="group" aria-label="' + esc(t('skin_model')) + '">',
    '            <button type="button" data-gender="f" aria-pressed="false">' + esc(t('gender_f')) + '</button>',
    '            <button type="button" data-gender="m" aria-pressed="false">' + esc(t('gender_m')) + '</button>',
    '          </div>',
    '          <button type="button" class="czs-spotbtn" data-act="spots">' + ICON.pin + '<span></span>' + ICON.chev + '</button>',
    '        </div>',
    '        <div class="czs-spots" role="group" aria-label="' + esc(t('skin_spots')) + '"></div>',
    '      </div>',
    '    </div>',
    '  </section>',
    '  <aside class="czs-panel">',
    '    <div class="czs-sheet" hidden role="dialog" aria-modal="false"><span class="czs-grab" aria-hidden="true"></span>',
    '      <div class="czs-sheet__head"><h2></h2><button type="button" class="czs-ibtn" data-act="close-tool" aria-label="' + esc(t('close')) + '">' + ICON.close + '</button></div>',
    '      <div class="czs-sheet__body"></div>',
    '    </div>',
    '    <div class="czs-summary">',
    '      <h3 class="czs-h">' + esc(t('qty_title')) + '</h3>',
    '      <ul class="czs-qty"></ul>',
    '      <p class="czs-why">' + esc(t('qty_why')) + '</p>',
    '      <div class="czs-total"><span>' + esc(t('total')) + '</span><b class="czs-price"></b></div>',
    '      <button type="button" class="czs-cta" data-act="cart">' + esc(t('cart')) + '</button>',
    '      <p class="czs-delivery">' + ICON.truck + '<span>' + esc(t('delivery')) + '</span></p>',
    '      <div class="czs-pay" data-pay></div>',
    '    </div>',
    '  </aside>',
    '</div>',
    '<div class="czs-buybar">',
    '  <button type="button" class="czs-qbtn" data-act="qty-sheet"><b></b><span></span></button>',
    '  <button type="button" class="czs-sizebar" data-act="size-sheet"><small>' + esc(t('size_short')) + '</small><b></b><span></span></button>',
    '  <button type="button" class="czs-cta" data-act="cart">' + esc(t('cart')) + '</button>',
    '</div>',
    '<div class="czs-toast" role="status" aria-live="polite"></div>'
  ].join('');

  var el = {
    sizes: $('.czs-sizes__track'), tools: $('.czs-tools'), board: $('.czs-board'), frame: $('.czs-frame'),
    rTop: $('.czs-ruler--top span'), rSide: $('.czs-ruler--side span'), gV: $('.czs-guide--v'), gH: $('.czs-guide--h'),
    empty: $('.czs-empty'), objbar: $('.czs-objbar'), sheet: $('.czs-sheet'), sheetTitle: $('.czs-sheet__head h2'),
    sheetBody: $('.czs-sheet__body'), qty: $('.czs-qty'), price: $('.czs-price'), qbtn: $('.czs-qbtn'),
    skinWrap: $('.czs-skinwrap'), skinCanvas: $('.czs-skincanvas'), spots: $('.czs-spots'), spotBtn: $('.czs-spotbtn'),
    skinUi: $('.czs-skinui'), skinRot: $('.czs-skinrot'), note: $('.czs-note'), skinEmpty: $('.czs-skin__empty'),
    toast: $('.czs-toast'), undo: $('[data-act="undo"]'), redo: $('[data-act="redo"]'), badge: $('.czs-badge'),
    skinScale: $('.czs-skinscale'), ownNew: $('.czs-ownnew'), ownFile: $('.czs-ownfile'), editing: $('.czs-editing')
  };
  (function () { var tpl = document.getElementById('czs-payments'); var box = $('[data-pay]'); if (tpl && box) box.innerHTML = tpl.innerHTML; else if (box) box.remove(); })();

  /* ---------- scroll lock (tour, sheets on phones, modals) ---------- */
  var locks = {};
  function lockScroll(key, on) {
    if (on) locks[key] = 1; else delete locks[key];
    var any = Object.keys(locks).length > 0;
    document.documentElement.classList.toggle('czs-locked', any);
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg, isError) {
    el.toast.textContent = msg;
    el.toast.classList.toggle('is-error', !!isError);
    el.toast.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.toast.classList.remove('is-on'); }, isError ? 5200 : 3200);
  }

  /* ---------- fabric canvas ---------- */
  var objDefaults = {
    cornerStyle: 'circle', cornerColor: '#dfff4f', cornerStrokeColor: '#0a0a0a', transparentCorners: false,
    cornerSize: 14, touchCornerSize: 40, borderColor: '#9ab800', borderScaleFactor: 1.6, padding: 6,
    borderOpacityWhenMoving: 0.6
  };
  [F.InteractiveFabricObject, F.FabricObject].forEach(function (C) { if (C && C.ownDefaults) Object.assign(C.ownDefaults, objDefaults); });

  var fc = new F.Canvas('czs-canvas', {
    preserveObjectStacking: true, backgroundColor: null, selectionColor: 'rgba(223,255,79,0.12)',
    selectionBorderColor: '#9ab800', fireRightClick: true, stopContextMenu: true, enableRetinaScaling: true,
    targetFindTolerance: isTouch ? 12 : 4, allowTouchScrolling: false, controlsAboveOverlay: true
  });
  var sheetRect = new F.Rect({ left: 0, top: 0, width: 10, height: 10, fill: '#ffffff', originX: 'left', originY: 'top', selectable: false, evented: false, objectCaching: false });
  var outside = null;
  function buildSheet() {
    sheetRect.set({ width: LW(), height: LH() });
    var W = LW(), H = LH(), B = 100000;
    // dims everything outside the print area; controls are drawn above it
    outside = new F.Path('M' + (-B) + ' ' + (-B) + ' H' + B + ' V' + B + ' H' + (-B) + ' Z M0 0 V' + H + ' H' + W + ' V0 Z', {
      fill: document.documentElement.classList.contains('tt-light') ? 'rgba(226,225,218,0.88)' : 'rgba(10,10,10,0.8)', fillRule: 'evenodd', selectable: false, evented: false, objectCaching: false
    });
    fc.backgroundImage = sheetRect;
    fc.overlayImage = outside;
  }

  function renderRotateIcon(ctx, left, top) {
    ctx.save(); ctx.translate(left, top);
    ctx.beginPath(); ctx.arc(0, 0, 14, 0, Math.PI * 2); ctx.fillStyle = '#dfff4f'; ctx.fill();
    ctx.lineWidth = 1.5; ctx.strokeStyle = '#0a0a0a'; ctx.stroke();
    ctx.lineWidth = 2; ctx.lineCap = 'round'; ctx.beginPath(); ctx.arc(0, 0, 6, -Math.PI * 0.15, Math.PI * 1.35); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(6.2, -5.2); ctx.lineTo(6.2, -0.8); ctx.lineTo(1.9, -1.9); ctx.stroke();
    ctx.restore();
  }
  function decorate(o) {
    o.set(objDefaults);
    var ctrls = Object.assign({}, o.controls);
    if (ctrls.mtr) {
      ctrls.mtr = new F.Control({
        x: 0, y: -0.5, offsetY: -38, actionName: 'rotate', cursorStyle: 'grab', withConnection: true,
        sizeX: 30, sizeY: 30, touchSizeX: 48, touchSizeY: 48,
        actionHandler: F.controlsUtils.rotationWithSnapping, cursorStyleHandler: F.controlsUtils.rotationStyleHandler,
        render: renderRotateIcon
      });
    }
    o.controls = ctrls;
    o.set({ lockSkewingX: true, lockSkewingY: true });
    if (!o.czId) o.czId = uid();
    return o;
  }

  /* fit the print sheet into the board: the canvas covers the whole board */
  function boardPads() {
    var mob = isMobile();
    return { top: mob ? 64 : 76, bottom: mob ? 96 : 40, left: mob ? 22 : 120, right: mob ? 34 : 70 };
  }
  function layoutPaper() {
    var b = el.board.getBoundingClientRect();
    if (!b.width || !b.height) return;
    var p = boardPads();
    var aw = Math.max(60, b.width - p.left - p.right), ah = Math.max(60, b.height - p.top - p.bottom);
    var z = Math.max(0.03, Math.min(aw / LW(), ah / LH()) * state.zoom);
    var ox = p.left + (aw - LW() * z) / 2, oy = p.top + (ah - LH() * z) / 2;
    view = { z: z, ox: ox, oy: oy };
    fc.setDimensions({ width: Math.round(b.width), height: Math.round(b.height) });
    fc.setViewportTransform([z, 0, 0, z, ox, oy]);
    el.frame.style.left = ox + 'px'; el.frame.style.top = oy + 'px';
    el.frame.style.width = LW() * z + 'px'; el.frame.style.height = LH() * z + 'px';
    var sz = curSize();
    el.rTop.textContent = fmtCm(sz.w) + ' ' + t('cm');
    el.rSide.textContent = fmtCm(sz.h) + ' ' + t('cm');
    fc.requestRenderAll();
    positionObjbar();
  }
  function toScreen(x, y) { return { x: view.ox + x * view.z, y: view.oy + y * view.z }; }

  /* ---------- history ---------- */
  function snapshot() {
    return JSON.stringify(fc.getObjects().map(function (o) {
      var j = o.toObject(PROPS);
      if (o.czKind === 'upload' || o.czKind === 'inspo') j.src = 'czimg:' + o.czId;
      return j;
    }));
  }
  function pushHistory() {
    if (restoring) return;
    var snap = snapshot();
    if (history[hIndex] === snap) return;
    if (!sizing) sizeBase = null;
    history = history.slice(0, hIndex + 1);
    history.push(snap);
    if (history.length > 60) history.shift();
    hIndex = history.length - 1;
    syncHistoryButtons();
    updateEmpty();
    markSkinDirty(true);
    autosave();
  }
  function syncHistoryButtons() {
    el.undo.disabled = hIndex <= 0;
    el.redo.disabled = hIndex >= history.length - 1;
  }
  function srcFor(id, useClean) {
    var im = imgs[id]; if (!im) return null;
    return (useClean !== false && im.clean) ? im.clean : im.raw;
  }
  function restore(snap) {
    restoring = true;
    var list = JSON.parse(snap);
    list.forEach(function (j) {
      if (typeof j.src === 'string' && j.src.indexOf('czimg:') === 0) j.src = srcFor(j.src.slice(6), j.czBg !== false);
    });
    return F.util.enlivenObjects(list).then(function (objs) {
      fc.discardActiveObject();
      fc.remove.apply(fc, fc.getObjects());
      objs.forEach(function (o, i) { Object.keys(list[i]).forEach(function (k) { if (PROPS.indexOf(k) > -1) o[k] = list[i][k]; }); decorate(o); fc.add(o); });
      fc.requestRenderAll();
      restoring = false;
      updateEmpty(); hideObjbar(); markSkinDirty(true); syncTextPanel();
      // texts restored before their font was loaded are measured again once it is there
      ensureFonts(objs).then(function () { fc.requestRenderAll(); markSkinDirty(true); });
    }).catch(function () { restoring = false; });
  }
  function undo() { if (hIndex <= 0) return; hIndex--; restore(history[hIndex]).then(function () { syncHistoryButtons(); autosave(); }); }
  function redo() { if (hIndex >= history.length - 1) return; hIndex++; restore(history[hIndex]).then(function () { syncHistoryButtons(); autosave(); }); }

  /* autosave: survives a reload. The draft incl. its images (data URLs, several MB with big photos) goes into
     IndexedDB, the same browser store as the cart designs; the small localStorage could not hold big photos.
     An older draft in localStorage ('design') is still read once and then replaced. If even IndexedDB can't keep
     it, the customer gets one short notice (the design stays on screen, it is only not kept over a reload). */
  var saveTimer, draftSeq = 0, draftWarned = false, draftLoaded = false; // nothing is written before the stored draft was read
  function clearDraft() { draftSeq++; store('design', null); KV.del('draft'); }
  function autosave() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      if (!draftLoaded) return;
      var objs = fc.getObjects();
      if (!objs.length) { clearDraft(); return; }
      var used = {};
      objs.forEach(function (o) { var im = imgs[o.czId]; if (im) used[o.czId] = { raw: im.raw, clean: im.clean, w: im.w, h: im.h, srcW: im.srcW || null, srcH: im.srcH || null, kind: im.kind, inspo: im.inspo, vec: im.vec || null, srcUrl: im.srcUrl || null, ai: !!im.ai, name: im.name || null, prompt: im.prompt || null, aiUrl: im.aiUrl || null, via: im.via || null }; });
      // the body area, model and placement the customer chose stay too (the cart mockup shows exactly that view)
      var json = JSON.stringify({ v: 1, size: state.size, objects: snapshot(), imgs: used, place: state.place, spot: state.spot });
      var seq = ++draftSeq;
      KV.put('draft', json).then(function () {
        if (seq === draftSeq) { store('design', null); draftWarned = false; } // the old small copy is not needed any more
      }).catch(function () {
        if (seq !== draftSeq || draftWarned) return;
        draftWarned = true;
        toast(t('autosave_full'), true);
      });
    }, 600);
  }
  function applyDraft(raw) {
    var d;
    try { d = typeof raw === 'string' ? JSON.parse(raw) : raw; } catch (e) { return Promise.resolve(false); }
    if (!d || !d.objects) return Promise.resolve(false);
    Object.keys(d.imgs || {}).forEach(function (k) { imgs[k] = d.imgs[k]; });
    if (d.size && sizeByCode(d.size)) state.size = d.size;
    if (d.place && typeof d.place === 'object') state.place = d.place;
    if (d.spot && typeof d.spot === 'object') state.spot = d.spot;
    return restore(d.objects).then(function () { return fc.getObjects().length > 0; });
  }
  function loadAutosave() {
    return KV.get('draft').then(function (raw) {
      return raw ? applyDraft(raw) : applyDraft(store('design'));
    }).catch(function () { return false; }).then(function (ok) { draftLoaded = true; return ok; });
  }

  /* ---------- canvas events ---------- */
  fc.on('object:added', function () { if (!restoring) pushHistory(); });
  fc.on('object:removed', function () { if (!restoring) pushHistory(); });
  fc.on('object:modified', function (e) { if (e.target && e.action && /scale/i.test(e.action)) e.target._czAuto = false; if (e.target) bringIntoView(e.target); pushHistory(); showActiveObjbar(); });
  fc.on('path:created', function (e) { var p = e.path; p.czKind = 'draw'; decorate(p); pushHistory(); });
  fc.on('selection:created', onSelect);
  fc.on('selection:updated', onSelect);
  fc.on('selection:cleared', function () { hideObjbar(); syncTextPanel(); });
  fc.on('object:moving', function (e) { snapToCenter(e.target); keepReachable(e.target); hideObjbar(); });
  fc.on('object:scaling', function () { hideObjbar(); });
  fc.on('object:rotating', hideObjbar);
  fc.on('mouse:up', function () { el.gV.classList.remove('is-on'); el.gH.classList.remove('is-on'); showActiveObjbar(); });
  fc.on('mouse:dblclick', function (e) {
    var o = e.target; if (!o) return;
    if (o.czKind === 'text') { openTool('text'); focusTextInput(); }
  });
  fc.on('mouse:down', function (e) {
    closeCtx();
    if (e.e && e.e.button === 2) {
      var o = e.target;
      if (o) { fc.setActiveObject(o); fc.requestRenderAll(); openCtx(o, e.e.clientX, e.e.clientY); }
    }
  });

  /* the board is what the customer sees: an element may grow past the print sheet, but its handles
     always stay on screen (so it can be made smaller again) and it can't be dragged out of reach */
  function screenBox(o) {
    var b = o.getBoundingRect();
    return { x0: view.ox + b.left * view.z, y0: view.oy + b.top * view.z, x1: view.ox + (b.left + b.width) * view.z, y1: view.oy + (b.top + b.height) * view.z };
  }
  function lastGood(o) { o._czLast = { scaleX: o.scaleX, scaleY: o.scaleY, left: o.left, top: o.top }; }
  function keepHandlesVisible(o) {
    o.setCoords(); // corner cache is stale while Fabric is transforming
    var bb = el.board.getBoundingClientRect(), m = 16, r = screenBox(o);
    var ok = r.x0 >= m && r.y0 >= m && r.x1 <= bb.width - m && r.y1 <= bb.height - m;
    var grew = o._czLast && Math.abs(o.scaleX * o.scaleY) > Math.abs(o._czLast.scaleX * o._czLast.scaleY);
    if (!ok && grew) { o.set(o._czLast); o.setCoords(); return; }
    lastGood(o);
  }
  function keepReachable(o) {
    var bb = el.board.getBoundingClientRect(), m = 40, c = o.getCenterPoint();
    var x = clamp(c.x, (m - view.ox) / view.z, (bb.width - m - view.ox) / view.z);
    var y = clamp(c.y, (m - view.oy) / view.z, (bb.height - m - view.oy) / view.z);
    if (x !== c.x || y !== c.y) { o.setPositionByOrigin(new F.Point(x, y), 'center', 'center'); o.setCoords(); }
  }
  function bringIntoView(o) {
    var m = 18, n = 0;
    for (; n < 14; n++) {
      o.setCoords();
      var bb = el.board.getBoundingClientRect(), r0 = screenBox(o);
      var top = isMobile() ? 56 : m;
      if (r0.x0 >= m && r0.y0 >= top && r0.x1 <= bb.width - m && r0.y1 <= bb.height - m) break;
      if (state.zoom <= 0.2) break;
      state.zoom = Math.max(0.2, state.zoom * 0.85);
      layoutPaper();
    }
  }
  function outsideSheet(o) { return o.getCoords().some(function (p) { return p.x < -1 || p.y < -1 || p.x > LW() + 1 || p.y > LH() + 1; }); }
  fc.on('mouse:down', function () { var o = fc.getActiveObject(); if (o) lastGood(o); });

  function onSelect() {
    var o = fc.getActiveObject();
    if (!o) return;
    showObjbar(o);
    if (state.tool === 'text') syncTextPanel();
  }
  function snapToCenter(o) {
    var c = o.getCenterPoint(), tol = 8 / view.z, onV = false, onH = false;
    if (Math.abs(c.x - LW() / 2) < tol) { c.x = LW() / 2; onV = true; }
    if (Math.abs(c.y - LH() / 2) < tol) { c.y = LH() / 2; onH = true; }
    if (onV || onH) { o.setPositionByOrigin(c, 'center', 'center'); o.setCoords(); }
    el.gV.classList.toggle('is-on', onV);
    el.gH.classList.toggle('is-on', onH);
  }

  /* long press = element menu; two fingers = zoom the sheet (phones) */
  (function () {
    var timer, sx, sy, pinch = null;
    var up = fc.upperCanvasEl;
    up.addEventListener('touchstart', function (ev) {
      if (ev.touches.length === 2) {
        clearTimeout(timer);
        var a = ev.touches[0], b = ev.touches[1];
        pinch = { d: Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY), zoom: state.zoom };
        return;
      }
      if (ev.touches.length !== 1) { clearTimeout(timer); return; }
      sx = ev.touches[0].clientX; sy = ev.touches[0].clientY;
      clearTimeout(timer);
      timer = setTimeout(function () {
        var o = fc.findTarget(ev) || fc.getActiveObject();
        if (o) { fc.setActiveObject(o); fc.requestRenderAll(); hideObjbar(); openCtx(o, sx, sy); if (navigator.vibrate) navigator.vibrate(12); }
      }, 550);
    }, { passive: true });
    up.addEventListener('touchmove', function (ev) {
      if (pinch && ev.touches.length === 2 && !fc.getActiveObject()) {
        var a = ev.touches[0], b = ev.touches[1];
        state.zoom = clamp(pinch.zoom * Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY) / pinch.d, 0.6, 4);
        layoutPaper();
        return;
      }
      var tt = ev.touches[0]; if (tt && (Math.abs(tt.clientX - sx) > 8 || Math.abs(tt.clientY - sy) > 8)) clearTimeout(timer);
    }, { passive: true });
    up.addEventListener('touchend', function (ev) { clearTimeout(timer); if (ev.touches.length < 2) pinch = null; }, { passive: true });
  })();

  /* ---------- element bar + context menu ---------- */
  function objActions(o) {
    var a = [];
    if (o.czKind === 'text') a.push(['edit', ICON.edit, t('obj_edit_text')]);
    if (o.czKind === 'upload' && imgs[o.czId]) a.push(['crop', ICON.crop, t('obj_crop')]);
    if (o.czKind === 'upload' && imgs[o.czId] && imgs[o.czId].clean) a.push(['bg', ICON.bg, t('obj_bg'), o.czBg === false ? t('obj_bg_on') : t('obj_bg_off'), o.czBg !== false]);
    a.push(['flip', ICON.flip, t('obj_flip')]);
    if (!isMobile()) { a.push(['forward', ICON.up, t('obj_forward')]); a.push(['backward', ICON.down, t('obj_backward')]); }
    a.push(['delete', ICON.trash, t('obj_delete')]);
    return a;
  }
  function showObjbar(o) {
    if (fc.isDrawingMode || state.mode !== 'design') return;
    el.objbar.innerHTML = objActions(o).map(function (x) {
      var title = x[3] || x[2];
      return '<button type="button" data-obj="' + x[0] + '" aria-label="' + esc(title) + '" title="' + esc(title) + '"' + (x[4] !== undefined ? ' aria-pressed="' + x[4] + '"' : '') + '>' + x[1] + '<span>' + esc(x[2]) + '</span></button>';
    }).join('');
    el.objbar.hidden = false;
    positionObjbar();
  }
  // no cm labels on the selected element (owner 20.10.2026): an uploaded image counts its empty margin, so the
  // figures were misleading – the sheet size (rulers, size chip) is the only size shown
  function showActiveObjbar() { var o = fc.getActiveObject(); if (o && !fc.isDrawingMode) showObjbar(o); }
  function hideObjbar() { el.objbar.hidden = true; }
  function positionObjbar() {
    var o = fc.getActiveObject();
    if (!o || el.objbar.hidden) return;
    var pts = o.getCoords();
    var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    pts.forEach(function (p) { minX = Math.min(minX, p.x); maxX = Math.max(maxX, p.x); minY = Math.min(minY, p.y); maxY = Math.max(maxY, p.y); });
    var vr = el.board.getBoundingClientRect();
    var bw = el.objbar.offsetWidth || 260, bh = el.objbar.offsetHeight || 56;
    var cx = toScreen((minX + maxX) / 2, 0).x;
    var below = toScreen(0, maxY).y + 18;
    var y = below;
    var limit = vr.height - (isMobile() ? 92 : 16) - bh;
    // never under the design/skin switch (or the size button on phones) at the top of the stage
    var mr = $('.czs-mode').getBoundingClientRect(), minTop = Math.max(8, mr.bottom - vr.top + 10);
    if (y > limit) y = toScreen(0, minY).y - 60 - bh; // above the rotation handle
    if (y < minTop) y = limit; // huge element: park the bar at the bottom of the stage
    y = clamp(y, minTop, Math.max(minTop, limit));
    el.objbar.style.left = clamp(cx, bw / 2 + 8, vr.width - bw / 2 - 8) + 'px';
    el.objbar.style.top = y + 'px';
  }
  el.objbar.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-obj]'); if (!b) return;
    runObjAction(b.getAttribute('data-obj'));
  });

  var ctxEl = null;
  function openCtx(o, x, y) {
    closeCtx();
    ctxEl = document.createElement('div');
    ctxEl.className = 'czs-ctx';
    ctxEl.setAttribute('role', 'menu');
    ctxEl.innerHTML = objActions(o).map(function (a) { return '<button type="button" role="menuitem" data-obj="' + a[0] + '">' + a[1] + '<span>' + esc(a[3] || a[2]) + '</span></button>'; }).join('');
    root.appendChild(ctxEl);
    var w = ctxEl.offsetWidth, h = ctxEl.offsetHeight;
    ctxEl.style.left = clamp(x, 8, window.innerWidth - w - 8) + 'px';
    ctxEl.style.top = clamp(y, 8, window.innerHeight - h - 8) + 'px';
    ctxEl.addEventListener('click', function (ev) { var b = ev.target.closest('[data-obj]'); if (b) { runObjAction(b.getAttribute('data-obj')); closeCtx(); } });
    var first = ctxEl.querySelector('button'); if (first && !isTouch) first.focus();
  }
  function closeCtx() { if (ctxEl) { ctxEl.remove(); ctxEl = null; showActiveObjbar(); } }
  document.addEventListener('pointerdown', function (ev) { if (ctxEl && !ctxEl.contains(ev.target)) closeCtx(); });

  function selectionList(o) { return o.type === 'activeselection' || o.type === 'activeSelection' ? o.getObjects() : [o]; }
  function runObjAction(act) {
    var o = fc.getActiveObject(); if (!o) return;
    var targets = selectionList(o);
    switch (act) {
      case 'delete': removeObjects(targets); break;
      case 'flip': o.set('flipX', !o.flipX); fc.requestRenderAll(); pushHistory(); break;
      case 'fit': fitToSheet(o); break;
      case 'crop': openCrop(o); break;
      case 'center': o.setPositionByOrigin(new F.Point(LW() / 2, LH() / 2), 'center', 'center'); o.setCoords(); fc.requestRenderAll(); pushHistory(); showActiveObjbar(); break;
      case 'forward': targets.forEach(function (x) { fc.bringObjectForward(x); }); fc.requestRenderAll(); pushHistory(); break;
      case 'backward': targets.forEach(function (x) { fc.sendObjectBackwards(x); }); fc.requestRenderAll(); pushHistory(); break;
      case 'edit': openTool('text'); focusTextInput(); break;
      case 'bg': toggleBackground(o); break;
    }
  }
  /* crop an uploaded image: drag the frame or its corners, the kept part stays where it is on the sheet */
  function openCrop(o) {
    var im = imgs[o.czId]; if (!im) return;
    var src = im.raw;
    var m = openModal('<h2>' + esc(t('crop_title')) + '</h2><div class="czs-crop"><div class="czs-crop__stage"><img src="' + src + '" alt=""><div class="czs-crop__box"><i data-h="nw"></i><i data-h="ne"></i><i data-h="sw"></i><i data-h="se"></i></div></div></div>' +
      '<div class="czs-actions"><button type="button" class="czs-btn" data-x>' + esc(t('crop_cancel')) + '</button><button type="button" class="czs-btn czs-btn--accent" data-crop-ok>' + esc(t('crop_apply')) + '</button></div>', { wide: true });
    var stage = $('.czs-crop__stage', m), box = $('.czs-crop__box', m);
    var c = { x0: 0, y0: 0, x1: 1, y1: 1 }, drag = null, MIN = 0.06;
    function paint() { box.style.left = c.x0 * 100 + '%'; box.style.top = c.y0 * 100 + '%'; box.style.width = (c.x1 - c.x0) * 100 + '%'; box.style.height = (c.y1 - c.y0) * 100 + '%'; }
    paint();
    stage.addEventListener('pointerdown', function (ev) {
      var r0 = stage.getBoundingClientRect(), h = ev.target.getAttribute && ev.target.getAttribute('data-h');
      if (!h && !box.contains(ev.target)) return;
      ev.preventDefault(); stage.setPointerCapture(ev.pointerId);
      drag = { h: h || 'move', px: ev.clientX, py: ev.clientY, w: r0.width, hgt: r0.height, c: Object.assign({}, c) };
    });
    stage.addEventListener('pointermove', function (ev) {
      if (!drag) return;
      var dx = (ev.clientX - drag.px) / drag.w, dy = (ev.clientY - drag.py) / drag.hgt, b = drag.c;
      if (drag.h === 'move') {
        var w = b.x1 - b.x0, hh = b.y1 - b.y0;
        c.x0 = clamp(b.x0 + dx, 0, 1 - w); c.y0 = clamp(b.y0 + dy, 0, 1 - hh); c.x1 = c.x0 + w; c.y1 = c.y0 + hh;
      } else {
        if (drag.h.indexOf('w') > -1) c.x0 = clamp(b.x0 + dx, 0, b.x1 - MIN);
        if (drag.h.indexOf('e') > -1) c.x1 = clamp(b.x1 + dx, b.x0 + MIN, 1);
        if (drag.h.indexOf('n') > -1) c.y0 = clamp(b.y0 + dy, 0, b.y1 - MIN);
        if (drag.h.indexOf('s') > -1) c.y1 = clamp(b.y1 + dy, b.y0 + MIN, 1);
      }
      paint();
    });
    stage.addEventListener('pointerup', function () { drag = null; });
    stage.addEventListener('pointercancel', function () { drag = null; });
    $('[data-crop-ok]', m).addEventListener('click', function () { applyCrop(o, c); closeModal(); });
  }
  function cropData(url, c) {
    if (!url) return Promise.resolve(null);
    return loadImage(url).then(function (img) {
      var w = img.naturalWidth, h = img.naturalHeight;
      var sx = Math.round(c.x0 * w), sy = Math.round(c.y0 * h), sw = Math.max(1, Math.round((c.x1 - c.x0) * w)), sh = Math.max(1, Math.round((c.y1 - c.y0) * h));
      var cv = document.createElement('canvas'); cv.width = sw; cv.height = sh;
      cv.getContext('2d').drawImage(img, sx, sy, sw, sh, 0, 0, sw, sh);
      return cv.toDataURL('image/png');
    });
  }
  function applyCrop(o, c) {
    if (c.x0 <= 0.001 && c.y0 <= 0.001 && c.x1 >= 0.999 && c.y1 >= 0.999) return;
    var im = imgs[o.czId];
    Promise.all([cropData(im.raw, c), cropData(im.clean, c)]).then(function (res) {
      var id = uid(), fw = c.x1 - c.x0, fh = c.y1 - c.y0;
      imgs[id] = { raw: res[0], clean: res[1], auto: im.auto, file: im.file, srcUrl: im.srcUrl || null, ai: !!im.ai, name: im.name || null, prompt: im.prompt || null, aiUrl: im.aiUrl || null, w: Math.round(im.w * fw), h: Math.round(im.h * fh), srcW: Math.round((im.srcW || im.w) * fw), srcH: Math.round((im.srcH || im.h) * fh), kind: 'upload' };
      // keep the kept part in place: move the centre by the crop offset (in object space, incl. flip and rotation)
      var lx = ((c.x0 + c.x1) / 2 - 0.5) * o.width * o.scaleX * (o.flipX ? -1 : 1), ly = ((c.y0 + c.y1) / 2 - 0.5) * o.height * o.scaleY * (o.flipY ? -1 : 1);
      var a = o.angle * Math.PI / 180, ctr = o.getCenterPoint();
      var nc = new F.Point(ctr.x + lx * Math.cos(a) - ly * Math.sin(a), ctr.y + lx * Math.sin(a) + ly * Math.cos(a));
      var sx = o.scaleX, sy = o.scaleY;
      return o.setSrc(o.czBg !== false && res[1] ? res[1] : res[0]).then(function () {
        o.set({ scaleX: sx, scaleY: sy }); // same scale: the kept part keeps its size on the sheet
        o.czId = id;
        o.setPositionByOrigin(nc, 'center', 'center'); o.setCoords();
        fc.requestRenderAll(); pushHistory(); showObjbar(o);
      });
    }).catch(function () { toast(t('error_generic'), true); });
  }
  function fitToSheet(o) {
    var b = o.getBoundingRect();
    var k = Math.min(LW() / b.width, LH() / b.height);
    o.set({ scaleX: o.scaleX * k, scaleY: o.scaleY * k });
    o.setPositionByOrigin(new F.Point(LW() / 2, LH() / 2), 'center', 'center'); o.setCoords();
    fc.requestRenderAll(); pushHistory(); showObjbar(o);
  }
  function removeObjects(list) {
    fc.discardActiveObject();
    list.forEach(function (x) { fc.remove(x); });
    fc.requestRenderAll();
    hideObjbar();
  }
  function toggleBackground(o) {
    var im = imgs[o.czId]; if (!im || !im.clean) return;
    var useClean = o.czBg === false;
    o.setSrc(useClean ? im.clean : im.raw).then(function () {
      o.czBg = useClean; fc.requestRenderAll(); pushHistory(); showObjbar(o);
      toast(useClean ? t('bg_removed') : t('obj_bg_off'));
    });
  }

  /* keyboard */
  document.addEventListener('keydown', function (ev) {
    var tag = (ev.target.tagName || '').toLowerCase();
    if (tag === 'input' || tag === 'textarea' || ev.target.isContentEditable) return;
    if (modalEl || drawerOpen()) { if (ev.key === 'Escape') closeModal(); return; }
    var mod = ev.ctrlKey || ev.metaKey;
    if (mod && ev.key.toLowerCase() === 'z') { ev.preventDefault(); ev.shiftKey ? redo() : undo(); return; }
    if (mod && ev.key.toLowerCase() === 'y') { ev.preventDefault(); redo(); return; }
    if (state.mode !== 'design') return;
    var o = fc.getActiveObject();
    if (ev.key === 'Escape') { closeCtx(); if (state.tool) closeTool(); fc.discardActiveObject(); fc.requestRenderAll(); return; }
    if (!o) return;
    if (ev.key === 'Delete' || ev.key === 'Backspace') { ev.preventDefault(); removeObjects(selectionList(o)); return; }
    var step = (ev.shiftKey ? 1 : 0.1) * LOGICAL, dx = 0, dy = 0;
    if (ev.key === 'ArrowLeft') dx = -step; else if (ev.key === 'ArrowRight') dx = step; else if (ev.key === 'ArrowUp') dy = -step; else if (ev.key === 'ArrowDown') dy = step; else return;
    ev.preventDefault();
    o.set({ left: o.left + dx, top: o.top + dy }); o.setCoords(); fc.requestRenderAll(); positionObjbar();
    clearTimeout(o._nudge); o._nudge = setTimeout(pushHistory, 300);
  });

  /* ---------- sizes ---------- */
  /* «ab» price per piece = the smallest package (owner 28.10.2026: XS «ab 14.–» for 3 pieces, never the 50-piece price);
     same rule as snippets/per-piece-price; the variants are sorted by quantity above */
  function entryPerPiece(s) { var v = s.variants[0]; return v ? Math.round(v.price / v.qty) : 0; }
  function renderSizes() {
    el.sizes.innerHTML = SIZES.map(function (s) {
      return '<button type="button" class="czs-size" data-size="' + s.code + '" aria-pressed="' + (s.code === state.size) + '">' +
        '<b>' + esc(SIZE_NAMES[s.code] || s.code) + (s.sub ? '<em>' + esc(s.sub) + '</em>' : '') + '</b><span>' + fmtCm(s.w) + ' × ' + fmtCm(s.h) + ' ' + esc(t('cm')) + '</span>' +
        '<small>' + esc(t('from', { price: formatMoney(entryPerPiece(s)) })) + '</small></button>';
    }).join('');
  }
  el.sizes.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-size]'); if (!b) return;
    setSize(b.getAttribute('data-size'));
    onbEvent('size');
  });
  function setSize(code, silent) {
    var prev = curSize();
    var next = sizeByCode(code); if (!next) return;
    var oldW = prev.w * LOGICAL, oldH = prev.h * LOGICAL;
    state.size = code;
    store('size', code);
    $$('.czs-size').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-size') === code ? 'true' : 'false'); });
    var newW = next.w * LOGICAL, newH = next.h * LOGICAL;
    buildSheet();
    var objs = fc.getObjects();
    if (!silent && objs.length && (oldW !== newW || oldH !== newH)) {
      // every tattoo keeps its size in cm and the design its place relative to the centre of the sheet; only if it
      // doesn't fit on a smaller sheet it is reduced just enough (and the customer is told). Always computed from the
      // layout the customer made (sizeBase), never from an already reduced one: no drift over many switches, and on a
      // bigger sheet it is back at the customer's own size. Filling the sheet is for inserting only.
      if (sizeBase && snapshot() !== history[hIndex]) sizeBase = null; // an own edit not yet in the history (typing)
      var base = sizeBase && sizeBase.items.length === objs.length && sizeBase.items.every(function (it, i) { return it.o === objs[i]; }) ? sizeBase : null;
      if (!base) {
        var bx0 = Infinity, by0 = Infinity, bx1 = -Infinity, by1 = -Infinity;
        objs.forEach(function (o) { o.getCoords().forEach(function (p) { bx0 = Math.min(bx0, p.x); by0 = Math.min(by0, p.y); bx1 = Math.max(bx1, p.x); by1 = Math.max(by1, p.y); }); });
        // only the part on the sheet counts (same box as the cm figures and the skin preview): a design that reaches
        // over the edge is not reduced for that, and on its own sheet everything stays exactly where it was
        var cx0 = Math.max(bx0, 0), cy0 = Math.max(by0, 0), cx1 = Math.min(bx1, oldW), cy1 = Math.min(by1, oldH);
        if (cx1 > cx0 && cy1 > cy0) { bx0 = cx0; by0 = cy0; bx1 = cx1; by1 = cy1; }
        var gx = (bx0 + bx1) / 2 - oldW / 2, gy = (by0 + by1) / 2 - oldH / 2;
        // a design that sat centred stays centred; otherwise it keeps its offset from the centre (within the sheet)
        base = { w: bx1 - bx0, h: by1 - by0, gx: gx, gy: gy, ox: Math.abs(gx) < 1 ? 0 : gx, oy: Math.abs(gy) < 1 ? 0 : gy,
          items: objs.map(function (o) { var c = o.getCenterPoint(); return { o: o, sx: o.scaleX, sy: o.scaleY, dx: c.x - oldW / 2, dy: c.y - oldH / 2 }; }) };
      }
      var k = Math.min(1, newW / Math.max(1, base.w), newH / Math.max(1, base.h));
      var hw = base.w * k / 2, hh = base.h * k / 2;
      var cx = clamp(newW / 2 + base.ox, hw, Math.max(hw, newW - hw)), cy = clamp(newH / 2 + base.oy, hh, Math.max(hh, newH - hh));
      // the selected element stays selected (an open text panel keeps editing that text, no second text)
      var act = fc.getActiveObject(), keep = act && objs.indexOf(act) > -1 ? act : null;
      restoring = true;
      fc.discardActiveObject();
      base.items.forEach(function (it) {
        it.o.set({ scaleX: it.sx * k, scaleY: it.sy * k });
        it.o.setPositionByOrigin(new F.Point(cx + (it.dx - base.gx) * k, cy + (it.dy - base.gy) * k), 'center', 'center');
        it.o.setCoords();
        it.o._czAuto = false; // a text no longer grows to fill the (new) sheet while typing
      });
      restoring = false;
      if (keep) { fc.setActiveObject(keep); onSelect(); }
      sizeBase = base;
      sizing = true; pushHistory(); sizing = false;
      if (k < 0.999) toast(t('size_shrunk'));
    }
    var sb = $('.czs-sizebtn b'); if (sb) sb.textContent = sizeLabel(next);
    // phone size bar: name (Huge / Extra Huge) on the main line, cm + price below; where the bar is too narrow only the price stays (CSS container query)
    var sbar = $('.czs-sizebar'); if (sbar) { $('b', sbar).innerHTML = '<em>' + esc(SIZE_NAMES[next.code] || next.code) + '</em>' + ICON.chev; $('span', sbar).innerHTML = '<i>' + esc(fmtCm(next.w) + ' × ' + fmtCm(next.h) + ' ' + t('cm')) + ' · </i>' + esc(t('from', { price: formatMoney(entryPerPiece(next)) })); }
    var sel = el.sizes.querySelector('[aria-pressed="true"]');
    if (sel && sel.scrollIntoView) sel.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: silent ? 'auto' : 'smooth' });
    layoutPaper();
    renderQty();
    if (state.mode === 'skin') renderSpots();
    markSkinDirty(true);
  }

  function openSizeSheet() {
    var m = openModal('<h2>' + esc(t('sizes_label')) + '</h2><ul class="czs-sizelist">' + SIZES.map(function (s) {
      return '<li><button type="button" data-size="' + s.code + '" aria-pressed="' + (s.code === state.size) + '"><b>' + esc(SIZE_NAMES[s.code] || s.code) + (s.sub ? '<em>' + esc(s.sub) + '</em>' : '') + '</b><span>' + fmtCm(s.w) + ' × ' + fmtCm(s.h) + ' ' + esc(t('cm')) + '</span><small>' + esc(t('from', { price: formatMoney(entryPerPiece(s)) })) + '</small><i style="--w:' + s.w + ';--h:' + s.h + '"></i></button></li>';
    }).join('') + '</ul>', { sheet: true });
    m.addEventListener('click', function (ev) { var b = ev.target.closest('[data-size]'); if (b) { setSize(b.getAttribute('data-size')); closeModal(); onbEvent('size'); } });
  }

  /* ---------- quantity + price ---------- */
  function qtyRows(s, v, withTotal) {
    var base = s.variants[0].price / s.variants[0].qty;
    return s.variants.map(function (x) {
      var per = Math.round(x.price / x.qty);
      var save = Math.round((1 - per / base) * 100);
      return '<li><button type="button" class="czs-qrow" data-qty="' + x.qty + '" aria-pressed="' + (x.qty === v.qty) + '"' + (x.available === false ? ' disabled' : '') + '>' +
        '<b>' + x.qty + '</b><span>' + esc(t('qty_per', { price: formatMoney(per) })) + (withTotal ? ' · ' + formatMoney(x.price) : '') + '</span>' + (save > 0 ? '<i>' + esc(t('qty_save', { percent: save })) + '</i>' : '<i hidden></i>') + '</button></li>';
    }).join('');
  }
  function renderQty() {
    var s = curSize(); var v = curVariant();
    el.qty.innerHTML = qtyRows(s, v, false);
    el.price.textContent = formatMoney(v.price);
    el.qbtn.querySelector('b').innerHTML = esc(t('qty_tattoos', { count: v.qty })) + ICON.chev;
    el.qbtn.querySelector('span').textContent = formatMoney(v.price) + ' · ' + t('qty_per', { price: formatMoney(Math.round(v.price / v.qty)) });
  }
  function setQty(q) { state.qty = q; qtyPick(String(q)); renderQty(); onbEvent('qty'); }
  el.qty.addEventListener('click', function (ev) { var b = ev.target.closest('[data-qty]'); if (b) setQty(+b.getAttribute('data-qty')); });
  function openQtySheet() {
    var s = curSize(); var v = curVariant();
    var m = openModal('<h2>' + esc(t('qty_title')) + '</h2><ul class="czs-qty">' + qtyRows(s, v, true) + '</ul><p>' + esc(t('qty_why')) + '</p>', { sheet: true });
    m.addEventListener('click', function (ev) { var b = ev.target.closest('[data-qty]'); if (b) { setQty(+b.getAttribute('data-qty')); closeModal(); } });
  }

  /* ---------- modal ---------- */
  var modalEl = null, modalReturn = null;
  function openModal(inner, opts) {
    closeModal();
    opts = opts || {};
    modalReturn = document.activeElement;
    modalEl = document.createElement('div');
    modalEl.className = 'czs-modal' + (opts.sheet ? ' czs-modal--sheet' : '') + (opts.cls ? ' ' + opts.cls : '');
    modalEl.innerHTML = '<div class="czs-dialog' + (opts.wide ? ' czs-dialog--wide' : '') + '" role="dialog" aria-modal="true">' + (opts.locked ? '' : '<button type="button" class="czs-ibtn czs-dialog__x" data-x aria-label="' + esc(t('close')) + '">' + ICON.close + '</button>') + inner + '</div>';
    root.appendChild(modalEl);
    // scoped (first-visit model picker): the page below the studio stays scrollable and usable, the dialog is clipped to
    // the part of the screen the studio covers
    if (opts.scoped) { modalEl.__scoped = true; clipToRoot(modalEl); } else lockScroll('modal', true);
    if (!opts.locked) {
      modalEl.addEventListener('click', function (ev) { if (ev.target === modalEl || ev.target.closest('[data-x]')) closeModal(); });
    }
    var f = modalEl.querySelector('.czs-dialog button:not([data-x]), .czs-dialog input'); if (f && !isTouch) setTimeout(function () { f.focus(); }, 30);
    return modalEl;
  }
  function closeModal() {
    if (!modalEl) return;
    modalEl.remove(); modalEl = null;
    lockScroll('modal', false);
    if (modalReturn && modalReturn.focus && !isTouch) modalReturn.focus();
  }

  /* ---------- tools ---------- */
  el.tools.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-tool]'); if (!b) return;
    var id = b.getAttribute('data-tool');
    if (state.tool === id) closeTool(); else openTool(id);
  });
  function openTool(id) {
    if (state.mode !== 'design') setMode('design');
    if (id === 'upload') { if (state.tool) closeTool(); openUploadDialog(); return; }
    if (id === 'builder') { if (state.tool) closeTool(); openBuilders(); return; }
    state.tool = id;
    $$('.czs-tool').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-tool') === id ? 'true' : 'false'); });
    el.sheet.hidden = false;
    root.classList.add('has-sheet');
    if (isMobile()) lockScroll('sheet', true);
    el.sheetTitle.textContent = t(id === 'ai' ? 'ai_title' : id + '_title');
    fc.isDrawingMode = id === 'draw';
    ({ upload: panelUpload, inspo: panelInspo, text: panelText, draw: panelDraw, ai: panelAi })[id]();
    if (id === 'draw') { fc.discardActiveObject(); fc.requestRenderAll(); hideObjbar(); }
    el.sheetBody.scrollTop = 0;
  }
  function closeTool() {
    state.tool = null;
    fc.isDrawingMode = false;
    el.sheet.hidden = true;
    root.classList.remove('has-sheet');
    lockScroll('sheet', false);
    el.sheetBody.innerHTML = '';
    $$('.czs-tool').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    showActiveObjbar();
  }
  root.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-act]'); if (!b || !root.contains(b)) return;
    var act = b.getAttribute('data-act');
    if (act === 'close-tool') closeTool();
    else if (act === 'undo') undo();
    else if (act === 'redo') redo();
    else if (act === 'help') startOnboarding(true);
    else if (act === 'cart') startCheckout();
    else if (act === 'qty-sheet') openQtySheet();
    else if (act === 'spots') openSpotSheet();
    else if (act === 'drawer') openDrawer(b);
    else if (act === 'size-sheet') openSizeSheet();
    else if (act === 'note-x') { store('note-sleeve', '1'); el.note.hidden = true; }
    else if (act === 'measure') setMeasure($('.czs-meas').hidden);
    else if (act === 'own-new') pickOwnPhoto();
    else if (act === 'edit-stop') stopEditing(true);
    else if (act === 'hand') openHandBuilder();
    else if (act === 'sleeve') openSleeveBuilder();
    else if (act === 'script') openScriptBuilder();
    else if (act === 'builders') openBuilders();
  });

  /* upload */
  function openUploadDialog() {
    var m = openModal('<h2>' + esc(t('upload_title')) + '</h2><div class="czs-upload"></div>', { sheet: true });
    panelUpload($('.czs-upload', m));
  }
  function panelUpload(box) {
    box = box || el.sheetBody;
    box.innerHTML =
      '<label class="czs-drop">' + ICON.upload + '<b>' + esc(t('upload_drop')) + '</b><span class="czs-muted">' + esc(t('upload_formats')) + '</span>' +
      '<input type="file" accept="image/png,image/jpeg,image/webp,image/svg+xml,image/heic,image/heif,.heic,.heif" multiple></label>' +
      '<p class="czs-muted">' + esc(t('upload_more')) + '</p>' +
      '<p class="czs-tip">' + esc(t('info_4')) + '</p>' +
      '<button type="button" class="czs-link" data-guide>' + esc(t('upload_guide')) + '</button>';
    var drop = $('.czs-drop', box), input = $('input', drop);
    input.addEventListener('click', function (ev) {
      if (store('upload-ok') !== '1') { ev.preventDefault(); openUploadInfo(function () { openUploadDialog(); var i2 = $('.czs-modal .czs-drop input'); if (i2) i2.click(); }); }
    });
    input.addEventListener('change', function () { var files = Array.prototype.slice.call(input.files || []); input.value = ''; if (files.length) { closeModal(); handleFiles(files); } });
    ['dragenter', 'dragover'].forEach(function (n) { drop.addEventListener(n, function (ev) { ev.preventDefault(); drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (n) { drop.addEventListener(n, function () { drop.classList.remove('is-over'); }); });
    drop.addEventListener('drop', function (ev) {
      ev.preventDefault();
      var files = ev.dataTransfer && ev.dataTransfer.files;
      files = Array.prototype.slice.call(files || []);
      if (store('upload-ok') !== '1') openUploadInfo(function () { handleFiles(files); }); else { closeModal(); handleFiles(files); }
    });
    $('[data-guide]', box).addEventListener('click', function () { openUploadInfo(openUploadDialog); });
  }
  function openUploadInfo(next) {
    var ok = store('upload-ok') === '1';
    var m = openModal(
      '<h2>' + esc(t('info_title')) + '</h2><p>' + esc(t('info_intro')) + '</p>' +
      '<ul class="czs-list">' + [1, 2, 3, 4, 5].map(function (i) { return '<li>' + esc(t('info_' + i)) + '</li>'; }).join('') + '</ul>' +
      '<label class="czs-check"><input type="checkbox"' + (ok ? ' checked' : '') + '><span>' + esc(t('info_check')) + '</span></label>' +
      '<div class="czs-actions"><button type="button" class="czs-btn czs-btn--accent" data-ok' + (ok ? '' : ' disabled') + '>' + esc(t('info_confirm')) + '</button></div>'
    );
    var cb = $('input[type=checkbox]', m), btn = $('[data-ok]', m);
    cb.addEventListener('change', function () { btn.disabled = !cb.checked; });
    btn.addEventListener('click', function () {
      if (!cb.checked) return;
      store('upload-ok', '1'); store('upload-ok-at', new Date().toISOString());
      closeModal();
      if (next) next();
    });
  }
  function handleFiles(list) {
    var files = Array.prototype.slice.call(list || []);
    if (!files.length) return;
    files.reduce(function (p, f) { return p.then(function () { return addUpload(f); }); }, Promise.resolve());
  }
  function addUpload(file, opts) {
    var name = (file.name || '').toLowerCase();
    var isHeic = /heic|heif/.test(file.type) || /\.(heic|heif)$/.test(name);
    var ok = /^image\/(png|jpe?g|webp|svg\+xml)$/.test(file.type) || isHeic || /\.(png|jpe?g|webp|svg)$/.test(name);
    if (!ok) { toast(t('upload_error_type'), true); return Promise.resolve(); }
    if (file.size > MAX_UPLOAD) { toast(t('upload_error_size'), true); return Promise.resolve(); }
    toast(t('upload_processing'));
    return prepareImage(file, opts).then(function (res) {
      var id = uid();
      imgs[id] = { raw: res.raw, clean: res.clean, auto: res.auto, file: file, w: res.w, h: res.h, srcW: res.srcW, srcH: res.srcH, kind: 'upload',
        ai: !!(opts && opts.ai), name: file.name || null, prompt: (opts && opts.prompt) || null, aiUrl: (opts && opts.aiUrl) || null };
      preupload(id);
      return addImageObject(id, 'upload').then(function (o) {
        if (res.auto) toast(t('bg_removed'));
        checkResolution(o);
        onbEvent('content');
      });
    }).catch(function (err) {
      toast(err && err.message === 'heic' ? t('upload_error_heic') : t('error_generic'), true);
    });
  }
  /* every upload and AI image goes to the studio storage right away (not only at add to cart), so the
     production team gets the untouched original even if the page was reloaded in between (the File object
     does not survive a reload). The files sit under a draft id of this browser; the design record copies
     them to the ordered design. */
  var srcUploads = {};
  function draftId() {
    // a fresh draft id every few days: the storage clean-up removes draft files that were never ordered
    // after 14 days, counted from the first file under that id
    var d = store('draft-id'), at = +store('draft-at') || 0;
    if (!d || !/^cz_[a-z0-9]{6,40}$/.test(d) || Date.now() - at > 3 * 864e5) { d = 'cz_' + uid(); store('draft-id', d); store('draft-at', String(Date.now())); }
    return d;
  }
  function preupload(id) {
    var im = imgs[id], api = window.czsApi;
    if (!im || !im.file || im.srcUrl || !DATA.api || !api || srcUploads[id]) return srcUploads[id] || Promise.resolve(im && im.srcUrl);
    var f = im.file, name = 'src-' + (im.ai ? 'ki' : 'upload') + '-' + String(f.name || 'bild').replace(/[^\w.\-]+/g, '_').slice(-60);
    for (var k0 in srcUploads) if (imgs[k0] && imgs[k0].file === f) return srcUploads[k0];   // same file already on its way (crop)
    srcUploads[id] = api.upload(draftId(), name, f).then(function (url) {
      // crops and builder copies of the same file share the URL
      Object.keys(imgs).forEach(function (k) { if (imgs[k].file === f && !imgs[k].srcUrl) imgs[k].srcUrl = url; });
      autosave();
      return url;
    }).catch(function () { delete srcUploads[id]; return null; });
    return srcUploads[id];
  }
  function checkResolution(o) {
    var im = imgs[o.czId]; if (!im || !im.srcW) return;
    var cmW = o.getScaledWidth() / LOGICAL;
    var dpi = im.srcW / (cmW / 2.54);
    if (dpi < 110) setTimeout(function () { toast(t('low_res'), true); }, 900);
  }
  function addImageObject(id, kind) {
    var im = imgs[id];
    var useClean = !!im.clean && im.auto !== false;
    return F.FabricImage.fromURL(useClean ? im.clean : im.raw).then(function (o) {
      o.czId = id; o.czKind = kind; o.czBg = useClean;
      var k = Math.min(LW() / o.width, LH() / o.height);
      o.set({ scaleX: k, scaleY: k, originX: 'center', originY: 'center', left: LW() / 2, top: LH() / 2 });
      decorate(o);
      fc.add(o); fc.setActiveObject(o); fc.requestRenderAll();
      return o;
    });
  }

  /* image preparation: decode, downscale for editing, remove a light background (colour-to-alpha) */
  function loadImage(src) {
    return new Promise(function (res, rej) { var i = new Image(); i.onload = function () { res(i); }; i.onerror = rej; i.src = src; });
  }
  function prepareImage(file, opts) {
    var url = URL.createObjectURL(file);
    var isSvg = /svg/.test(file.type) || /\.svg$/i.test(file.name || '');
    var isHeic = /heic|heif/i.test(file.type) || /\.(heic|heif)$/i.test(file.name || '');
    return loadImage(url).catch(function () { throw new Error(isHeic ? 'heic' : 'decode'); }).then(function (img) {
      URL.revokeObjectURL(url);
      var w = img.naturalWidth || 1200, h = img.naturalHeight || 1200;
      if (isSvg && Math.max(w, h) < 2000) { var f = 2000 / Math.max(w, h); w *= f; h *= f; }
      var k = Math.min(1, EDIT_MAX / Math.max(w, h));
      var cw = Math.max(1, Math.round(w * k)), ch = Math.max(1, Math.round(h * k));
      var c = document.createElement('canvas'); c.width = cw; c.height = ch;
      var x = c.getContext('2d', { willReadFrequently: true });
      x.drawImage(img, 0, 0, cw, ch);
      var raw = c.toDataURL('image/png');
      var auto = removeLightBackground(x, cw, ch), clean = null;
      if (auto) clean = c.toDataURL('image/png');
      else {
        // busy background (tattoo photo on skin, paper with shadows): pull out the ink; if that finds
        // nothing useful, fall back to cutting the background away from the edges
        var copy = x.getImageData(0, 0, cw, ch);
        if (edgeLum(copy) > 170 && removeBackgroundFlood(x, cw, ch)) clean = c.toDataURL('image/png');
        else { x.putImageData(copy, 0, 0); if (extractInk(x, cw, ch)) clean = c.toDataURL('image/png'); else { x.putImageData(copy, 0, 0); if (removeBackgroundFlood(x, cw, ch)) clean = c.toDataURL('image/png'); } }
      }
      var srcW = isSvg ? 4000 : img.naturalWidth, srcH = isSvg ? 4000 : img.naturalHeight;
      // AI results: crop to the drawing (alpha box of the cleaned image + a little padding), raw and clean alike
      var bb = opts && opts.trim && clean ? alphaBox(x, cw, ch) : null;
      if (bb) {
        var fx = (img.naturalWidth || cw) / cw, fy = (img.naturalHeight || ch) / ch;
        var cc = document.createElement('canvas'); cc.width = bb.w; cc.height = bb.h;
        cc.getContext('2d').drawImage(c, bb.x, bb.y, bb.w, bb.h, 0, 0, bb.w, bb.h); clean = cc.toDataURL('image/png');
        var cr = document.createElement('canvas'); cr.width = bb.w; cr.height = bb.h;
        cr.getContext('2d').drawImage(img, bb.x * fx, bb.y * fy, bb.w * fx, bb.h * fy, 0, 0, bb.w, bb.h); raw = cr.toDataURL('image/png');
        srcW = Math.round(srcW * bb.w / cw); srcH = Math.round(srcH * bb.h / ch); cw = bb.w; ch = bb.h;
      }
      return { raw: raw, clean: clean, auto: auto, w: cw, h: ch, srcW: srcW, srcH: srcH };
    });
  }
  /* bounding box of the visible pixels plus padding; null when there is nothing worth trimming */
  function alphaBox(x, w, h) {
    var p = x.getImageData(0, 0, w, h).data, x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (var yy = 0; yy < h; yy++) for (var xx = 0; xx < w; xx++) if (p[(yy * w + xx) * 4 + 3] > 24) { if (xx < x0) x0 = xx; if (xx > x1) x1 = xx; if (yy < y0) y0 = yy; if (yy > y1) y1 = yy; }
    if (x1 < 0) return null;
    var pad = Math.round(Math.max(x1 - x0, y1 - y0) * 0.03) + 4;
    x0 = Math.max(0, x0 - pad); y0 = Math.max(0, y0 - pad); x1 = Math.min(w - 1, x1 + pad); y1 = Math.min(h - 1, y1 + pad);
    var bw = x1 - x0 + 1, bh = y1 - y0 + 1;
    if (bw * bh > w * h * 0.92) return null;
    return { x: x0, y: y0, w: bw, h: bh };
  }
  function removeLightBackground(x, w, h) {
    var d = x.getImageData(0, 0, w, h), p = d.data, n = w * h, i;
    var transparent = 0;
    for (i = 3; i < p.length; i += 4 * 7) if (p[i] < 240) transparent++;
    if (transparent > n / 7 * 0.02) return false;
    var rs = [], gs = [], bs = [];
    function sample(px) { rs.push(p[px]); gs.push(p[px + 1]); bs.push(p[px + 2]); }
    var stepX = Math.max(1, Math.floor(w / 80)), stepY = Math.max(1, Math.floor(h / 80));
    for (var xx = 0; xx < w; xx += stepX) { sample(xx * 4); sample(((h - 1) * w + xx) * 4); }
    for (var yy = 0; yy < h; yy += stepY) { sample(yy * w * 4); sample((yy * w + w - 1) * 4); }
    function med(a) { a.sort(function (m, n2) { return m - n2; }); return a[Math.floor(a.length / 2)]; }
    var br = med(rs.slice()), bg = med(gs.slice()), bb = med(bs.slice());
    var lum = 0.299 * br + 0.587 * bg + 0.114 * bb;
    var dev = 0; for (i = 0; i < rs.length; i++) dev += Math.abs(rs[i] - br) + Math.abs(gs[i] - bg) + Math.abs(bs[i] - bb);
    dev /= rs.length * 3;
    if (lum < 165 || dev > 26) return false;
    for (i = 0; i < p.length; i += 4) {
      var r = p[i], g = p[i + 1], b = p[i + 2];
      var a = Math.max(r < br ? (br - r) / br : 0, g < bg ? (bg - g) / bg : 0, b < bb ? (bb - b) / bb : 0);
      var alpha = smooth(0.07, 0.42, a);
      if (alpha <= 0) { p[i + 3] = 0; continue; }
      // the motif keeps its own tones: only the paper becomes transparent (soft edge)
      p[i + 3] = Math.round(Math.min(1, alpha * 1.5) * (p[i + 3] / 255) * 255);
    }
    x.putImageData(d, 0, 0);
    return true;
  }

  /* cut-out for any background: grow the background region from the image edges over similar colours */
  /* ink extraction for busy photos (tattoo on skin, shaded paper): a morphological closing fills thin
     dark strokes with the brightness around them; whatever disappears in that step is ink (kept pure
     black). Large dark areas (a studio backdrop, clothing) survive the closing and stay transparent. */
  function edgeLum(d) {
    var p = d.data, w = d.width, h = d.height, v = [], i;
    for (i = 0; i < w; i += 4) { v.push(p[i * 4] * 0.3 + p[i * 4 + 1] * 0.59 + p[i * 4 + 2] * 0.11); var k = ((h - 1) * w + i) * 4; v.push(p[k] * 0.3 + p[k + 1] * 0.59 + p[k + 2] * 0.11); }
    for (i = 0; i < h; i += 4) { var a = i * w * 4, b = (i * w + w - 1) * 4; v.push(p[a] * 0.3 + p[a + 1] * 0.59 + p[a + 2] * 0.11, p[b] * 0.3 + p[b + 1] * 0.59 + p[b + 2] * 0.11); }
    v.sort(function (m, n) { return m - n; }); return v[Math.floor(v.length / 2)];
  }
  function runFilter(src, dst, w, h, R, isMax, horizontal) {
    var len = horizontal ? w : h, lines = horizontal ? h : w, k = 2 * R + 1;
    var g = new Uint8Array(len), hh = new Uint8Array(len), line = new Uint8Array(len), i, j;
    var pick = isMax ? function (a, b) { return a > b ? a : b; } : function (a, b) { return a < b ? a : b; };
    for (var l = 0; l < lines; l++) {
      for (i = 0; i < len; i++) line[i] = src[horizontal ? l * w + i : i * w + l];
      for (i = 0; i < len; i++) g[i] = i % k === 0 ? line[i] : pick(g[i - 1], line[i]);
      for (i = len - 1; i >= 0; i--) hh[i] = (i % k === k - 1 || i === len - 1) ? line[i] : pick(hh[i + 1], line[i]);
      for (i = 0; i < len; i++) {
        var a = Math.max(0, i - R), b = Math.min(len - 1, i + R);
        j = horizontal ? l * w + i : i * w + l;
        dst[j] = pick(hh[a], g[b]);
      }
    }
  }
  function extractInk(x, w, h) {
    var d = x.getImageData(0, 0, w, h), p = d.data, n = w * h, i;
    for (i = 3; i < p.length; i += 4 * 9) if (p[i] < 200) return false; // already has transparency
    var lum = new Uint8Array(n), t1 = new Uint8Array(n), t2 = new Uint8Array(n);
    for (i = 0; i < n; i++) lum[i] = (p[i * 4] * 77 + p[i * 4 + 1] * 150 + p[i * 4 + 2] * 29) >> 8;
    var R = Math.max(6, Math.round(Math.max(w, h) * 0.02));
    runFilter(lum, t1, w, h, R, true, true); runFilter(t1, t2, w, h, R, true, false);   // dilate
    runFilter(t2, t1, w, h, R, false, true); runFilter(t1, t2, w, h, R, false, false); // erode -> closing
    var alpha = new Float32Array(n), inkN = 0;
    for (i = 0; i < n; i++) { var a = clamp((t2[i] - lum[i] - 20) / 42, 0, 1); alpha[i] = a < 0.2 ? 0 : a; }
    // drop specks (skin hair, pores, creases): ink fragments much smaller than the main motif parts
    var lab = new Int32Array(n).fill(-1), q = new Int32Array(n), areas = [];
    for (i = 0; i < n; i++) {
      if (!alpha[i] || lab[i] >= 0) continue;
      var qh = 0, qt = 0, id = areas.length, area = 0; q[qt++] = i; lab[i] = id;
      while (qh < qt) {
        var k = q[qh++], kx = k % w; area++;
        if (kx > 0 && alpha[k - 1] && lab[k - 1] < 0) { lab[k - 1] = id; q[qt++] = k - 1; }
        if (kx < w - 1 && alpha[k + 1] && lab[k + 1] < 0) { lab[k + 1] = id; q[qt++] = k + 1; }
        if (k >= w && alpha[k - w] && lab[k - w] < 0) { lab[k - w] = id; q[qt++] = k - w; }
        if (k < n - w && alpha[k + w] && lab[k + w] < 0) { lab[k + w] = id; q[qt++] = k + w; }
      }
      areas.push(area);
    }
    var biggest = areas.reduce(function (m, v) { return Math.max(m, v); }, 0), minArea = Math.max(n * 0.00004, biggest * 0.02);
    for (i = 0; i < n; i++) {
      var keep = alpha[i] && areas[lab[i]] >= minArea;
      if (keep) inkN++;
      p[i * 4 + 3] = keep ? Math.round(Math.min(1, alpha[i] * 1.6) * 255) : 0;
    }
    if (inkN < n * 0.002 || inkN > n * 0.6) return false;
    x.putImageData(d, 0, 0);
    return true;
  }
  function removeBackgroundFlood(x, w, h) {
    var d = x.getImageData(0, 0, w, h), p = d.data, n = w * h, i;
    for (i = 3; i < p.length; i += 4 * 9) if (p[i] < 200) return false; // already has transparency
    var rs = [], gs = [], bs = [];
    var stepX = Math.max(1, Math.floor(w / 100)), stepY = Math.max(1, Math.floor(h / 100));
    function sample(px) { rs.push(p[px]); gs.push(p[px + 1]); bs.push(p[px + 2]); }
    for (var xx = 0; xx < w; xx += stepX) { sample(xx * 4); sample(((h - 1) * w + xx) * 4); }
    for (var yy = 0; yy < h; yy += stepY) { sample(yy * w * 4); sample((yy * w + w - 1) * 4); }
    function med(a) { a.sort(function (m, n2) { return m - n2; }); return a[Math.floor(a.length / 2)]; }
    var br = med(rs), bg = med(gs), bb = med(bs);
    var T = 46, bgm = new Uint8Array(n), q = new Int32Array(n), qh = 0, qt = 0;
    function far(k, r0, g0, b0) { var o = k * 4; return Math.max(Math.abs(p[o] - r0), Math.abs(p[o + 1] - g0), Math.abs(p[o + 2] - b0)); }
    function seed(k) { if (!bgm[k] && far(k, br, bg, bb) < T) { bgm[k] = 1; q[qt++] = k; } }
    for (xx = 0; xx < w; xx++) { seed(xx); seed((h - 1) * w + xx); }
    for (yy = 0; yy < h; yy++) { seed(yy * w); seed(yy * w + w - 1); }
    while (qh < qt) {
      var k = q[qh++], kx = k % w, o = k * 4;
      var nb = [kx > 0 ? k - 1 : -1, kx < w - 1 ? k + 1 : -1, k - w, k + w];
      for (var j = 0; j < 4; j++) {
        var m2 = nb[j]; if (m2 < 0 || m2 >= n || bgm[m2]) continue;
        var dBase = far(m2, br, bg, bb), dStep = far(m2, p[o], p[o + 1], p[o + 2]);
        if (dBase < T || (dStep < 9 && dBase < T * 1.8)) { bgm[m2] = 1; q[qt++] = m2; }
      }
    }
    var share = qt / n;
    if (share < 0.03 || share > 0.97) return false;
    for (i = 0; i < n; i++) {
      if (bgm[i]) { p[i * 4 + 3] = 0; continue; }
      var ix = i % w, edge = (ix > 0 && bgm[i - 1]) || (ix < w - 1 && bgm[i + 1]) || (i >= w && bgm[i - w]) || (i < n - w && bgm[i + w]);
      if (edge) p[i * 4 + 3] = 150; // soft 1 px edge
    }
    x.putImageData(d, 0, 0);
    return true;
  }

  /* inspo */
  var inspoCat = 'all';
  function panelInspo() {
    var cats = INSPO.categories || [];
    var items = INSPO.items || [];
    if (!items.length) { el.sheetBody.innerHTML = '<p class="czs-muted">' + esc(t('inspo_empty')) + '</p>'; return; }
    var de = DATA.locale && DATA.locale.indexOf('de') === 0;
    el.sheetBody.innerHTML =
      '<p class="czs-muted">' + esc(t('inspo_hint')) + '</p>' +
      '<div class="czs-chips" role="group">' + ['all'].concat(cats.map(function (c) { return c.id; })).map(function (id) {
        var c = cats.filter(function (x) { return x.id === id; })[0];
        var label = id === 'all' ? t('inspo_all') : (c && (de ? c.de : c.en));
        return '<button type="button" class="czs-chip" data-cat="' + esc(id) + '" aria-pressed="' + (id === inspoCat) + '">' + esc(label) + '</button>';
      }).join('') + '</div><div class="czs-inspo"></div>';
    renderInspoGrid();
    $('.czs-chips', el.sheetBody).addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-cat]'); if (!b) return;
      inspoCat = b.getAttribute('data-cat');
      $$('.czs-chip', el.sheetBody).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      if (b.scrollIntoView) b.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
      renderInspoGrid();
    });
    $('.czs-inspo', el.sheetBody).addEventListener('load', function (ev) {
      var img = ev.target; if (!img || img.tagName !== 'IMG') return;
      var r = img.naturalHeight / Math.max(1, img.naturalWidth), b = img.parentNode;
      b.classList.toggle('is-tall', r > 1.7); b.classList.toggle('is-wide', r < 0.55);
    }, true);
    $('.czs-inspo', el.sheetBody).addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-inspo]'); if (!b) return;
      addInspo(INSPO.items[+b.getAttribute('data-inspo')]);
    });
  }
  function renderInspoGrid() {
    var grid = $('.czs-inspo', el.sheetBody); if (!grid) return;
    var de = DATA.locale && DATA.locale.indexOf('de') === 0;
    grid.innerHTML = INSPO.items.map(function (it, i) {
      if (inspoCat !== 'all' && it.cat !== inspoCat) return '';
      var name = de ? it.de : it.en;
      return '<button type="button" data-inspo="' + i + '" aria-label="' + esc(name) + '" title="' + esc(name) + '"><img src="' + esc(it.thumb || it.src) + '" alt="" loading="lazy"></button>';
    }).join('');
  }
  function addInspo(it) {
    if (!it) return;
    var id = 'inspo-' + it.id;
    var ready = imgs[id] ? Promise.resolve() : loadImage(it.vec || it.src).then(function (img) {
      var w = img.naturalWidth || 1600, h = img.naturalHeight || 1600;
      var k = RASTER / Math.max(w, h);
      var c = document.createElement('canvas'); c.width = Math.round(w * k); c.height = Math.round(h * k);
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      imgs[id] = { raw: c.toDataURL('image/png'), clean: null, w: c.width, h: c.height, kind: 'inspo', inspo: it.id, vec: it.vec || null };
    });
    ready.then(function () { return addImageObject(id, 'inspo'); }).then(function () {
      onbEvent('content');
      if (isMobile()) closeTool();
    }).catch(function () { toast(t('error_generic'), true); });
  }

  /* text */
  var lastFont = store('font') || null;
  function scriptOf(txt) {
    if (/[؀-ۿݐ-ݿﭐ-﷿ﹰ-﻿]/.test(txt)) return 'ar';
    if (/[֐-׿יִ-ﭏ]/.test(txt)) return 'he';
    return 'latin';
  }
  function fontsFor(script) { return FONTS.filter(function (f) { return script === 'latin' ? f.scripts.indexOf('tr') > -1 : f.scripts.indexOf(script) > -1; }); }
  function fontByName(n) { for (var i = 0; i < FONTS.length; i++) if (FONTS[i].name === n) return FONTS[i]; return null; }
  function loadFont(f, sample) {
    if (!document.fonts || !f) return Promise.resolve();
    return document.fonts.load((f.style === 'italic' ? 'italic ' : '') + f.weight + ' 40px "' + f.family + '"', sample || 'Abg').catch(function () {});
  }
  function activeText() { var o = fc.getActiveObject(); return o && o.czKind === 'text' ? o : null; }
  function panelText() {
    var o = activeText();
    el.sheetBody.innerHTML =
      // phones: the panel covers the sheet, so the text shows here live in its font (white sheet, ink)
      '<div class="czs-tprev" aria-hidden="true"><span></span></div>' +
      '<textarea class="czs-field" rows="2" placeholder="' + esc(t('text_placeholder')) + '" aria-label="' + esc(t('text_title')) + '"></textarea>' +
      '<div class="czs-row"><button type="button" class="czs-btn" data-text-add>' + ICON.plus + esc(t('text_add')) + '</button></div>' +
      '<p class="czs-tip" data-script hidden></p>' +
      '<span class="czs-label">' + esc(t('text_align')) + '</span>' +
      '<div class="czs-align" role="group">' +
      '<button type="button" data-align="left" aria-label="' + esc(t('text_align_left')) + '">' + ICON.alignL + '</button>' +
      '<button type="button" data-align="center" aria-label="' + esc(t('text_align_center')) + '">' + ICON.alignC + '</button>' +
      '<button type="button" data-align="right" aria-label="' + esc(t('text_align_right')) + '">' + ICON.alignR + '</button></div>' +
      '<label class="czs-label" for="czs-spacing">' + esc(t('text_spacing')) + '</label>' +
      '<input id="czs-spacing" class="czs-range" type="range" min="-100" max="800" step="10" value="0">' +
      '<span class="czs-label">' + esc(t('text_font')) + '</span><div class="czs-fonts"></div>';
    var ta = $('textarea', el.sheetBody);
    ta.value = o ? o.text : '';
    ta.addEventListener('input', function () { onTextInput(ta.value); });
    $('[data-text-add]', el.sheetBody).addEventListener('click', function () { fc.discardActiveObject(); ta.value = ''; createText(t('text_default')).then(function (n) { ta.value = n.text; ta.focus(); ta.select(); }); });
    $('.czs-align', el.sheetBody).addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-align]'); var x = activeText(); if (!b || !x) return;
      x.set('textAlign', b.getAttribute('data-align')); fc.requestRenderAll(); pushHistory(); syncTextPanel();
    });
    $('#czs-spacing', el.sheetBody).addEventListener('input', function (ev) {
      var x = activeText(); if (!x) return;
      x.set('charSpacing', +ev.target.value); x.setCoords(); fc.requestRenderAll(); textPreview();
      clearTimeout(x._sp); x._sp = setTimeout(pushHistory, 300);
    });
    $('.czs-fonts', el.sheetBody).addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-font]'); if (!b) return;
      applyFont(fontByName(b.getAttribute('data-font')));
    });
    syncTextPanel();
    if (!o) createText(t('text_default')).then(function (n) { ta.value = n.text; if (!isTouch) { ta.focus(); ta.select(); } });
  }
  function focusTextInput() { var ta = $('textarea', el.sheetBody); if (ta) { ta.focus(); ta.select(); } }
  function renderFontList(script, current) {
    var box = $('.czs-fonts', el.sheetBody); if (!box) return;
    var list = fontsFor(script);
    var groups = script === 'ar' ? ['arabic', 'display'] : script === 'he' ? ['hebrew', 'display'] : ['script', 'gothic', 'serif', 'sans', 'display', 'arabic', 'hebrew'];
    var sample = (activeText() && activeText().text.split('\n')[0].slice(0, 22)) || t('text_default');
    var html = '';
    groups.forEach(function (g) {
      var fs = list.filter(function (f) { return f.group === g; });
      if (!fs.length) return;
      html += '<p class="czs-fontgroup">' + esc(t('group_' + g)) + '</p>';
      html += fs.map(function (f) {
        return '<button type="button" class="czs-font" data-font="' + esc(f.name) + '" aria-pressed="' + (current === f.name) + '" style="font-family:\'' + f.family + '\';font-weight:' + f.weight + ';font-style:' + f.style + '" dir="auto"><span>' + esc(sample) + '</span><small>' + esc(f.name) + '</small></button>';
      }).join('');
    });
    box.innerHTML = html;
  }
  function syncTextPanel() {
    if (state.tool !== 'text') return;
    var o = activeText();
    var ta = $('textarea', el.sheetBody);
    if (ta && o && document.activeElement !== ta) ta.value = o.text;
    var script = o ? scriptOf(o.text) : 'latin';
    var tip = $('[data-script]', el.sheetBody);
    if (tip) { tip.hidden = script === 'latin'; tip.textContent = script === 'ar' ? t('text_script_ar') : script === 'he' ? t('text_script_he') : ''; }
    $$('.czs-align button', el.sheetBody).forEach(function (b) { b.setAttribute('aria-pressed', o && o.textAlign === b.getAttribute('data-align') ? 'true' : 'false'); });
    var sp = $('#czs-spacing', el.sheetBody); if (sp && o) sp.value = o.charSpacing || 0;
    renderFontList(script, o ? o.czFont : lastFont);
    textPreview();
  }
  /* live preview of the active text in the text panel (shown on phones, where the panel covers the sheet):
     same font, weight, spacing and alignment; shrinks to fit the panel width */
  function textPreview() {
    var box = $('.czs-tprev', el.sheetBody); if (!box) return;
    var o = activeText(), s = box.firstChild;
    box.hidden = !o;
    if (!o) return;
    s.textContent = o.text || ' ';
    s.style.fontFamily = '"' + o.fontFamily + '"'; s.style.fontWeight = o.fontWeight; s.style.fontStyle = o.fontStyle;
    s.style.letterSpacing = ((o.charSpacing || 0) / 1000) + 'em'; s.style.textAlign = o.textAlign || 'center';
    s.dir = o.direction === 'rtl' ? 'rtl' : 'ltr';
    if (!box.offsetWidth) return;
    var size = 30; s.style.fontSize = size + 'px';
    for (var i = 0; i < 4; i++) {
      var room = box.clientWidth - 24, w = s.scrollWidth;
      if (w <= room || size <= 11) break;
      size = Math.max(11, Math.floor(size * room / w)); s.style.fontSize = size + 'px';
    }
  }
  function defaultFont(script) {
    var list = fontsFor(script);
    var pref = script === 'latin' ? (lastFont && fontByName(lastFont) && fontByName(lastFont).scripts.indexOf('tr') > -1 ? lastFont : 'Great Vibes') : (script === 'ar' ? 'Aref Ruqaa' : 'Frank Ruhl Libre');
    return (pref && fontByName(pref)) || list[0];
  }
  function createText(txt) {
    var script = scriptOf(txt);
    var f = defaultFont(script);
    return loadFont(f, txt).then(function () {
      var o = new F.Text(txt, {
        fontFamily: f.family, fontWeight: f.weight, fontStyle: f.style, fill: '#111111',
        fontSize: Math.max(18, Math.min(LW(), LH()) * 0.2), textAlign: 'center', originX: 'center', originY: 'center',
        left: LW() / 2, top: LH() / 2, direction: script === 'latin' ? 'ltr' : 'rtl', lineHeight: 1.05
      });
      o.czKind = 'text'; o.czFont = f.name; o.czScript = script; o._czAuto = true; // keeps filling the sheet while typing until resized by hand
      decorate(o);
      fitTextToPaper(o);
      fc.add(o); fc.setActiveObject(o); fc.requestRenderAll();
      onbEvent('content');
      syncTextPanel();
      return o;
    });
  }
  /* new text starts large (about 3/4 of the sheet width) but always inside the sheet */
  function fitTextToPaper(o) {
    var k = Math.min(LW() * 0.75 / o.getScaledWidth(), LH() * 0.45 / o.getScaledHeight());
    o.set({ scaleX: o.scaleX * k, scaleY: o.scaleY * k });
    o.setCoords();
  }
  var textTimer;
  function onTextInput(val) {
    var o = activeText();
    if (!o) { if (val.trim()) createText(val); return; }
    var script = scriptOf(val);
    var f = fontByName(o.czFont);
    var needSwitch = script !== 'latin' ? (!f || f.scripts.indexOf(script) < 0) : (!f || f.scripts.indexOf('tr') < 0);
    var next = needSwitch ? defaultFont(script) : f;
    loadFont(next, val).then(function () {
      o.set({ text: val || ' ', fontFamily: next.family, fontWeight: next.weight, fontStyle: next.style, direction: script === 'latin' ? 'ltr' : 'rtl' });
      o.czFont = next.name; o.czScript = script;
      if (o._czAuto && val.trim()) fitTextToPaper(o);
      o.setCoords(); fc.requestRenderAll(); positionObjbar();
      if (needSwitch || o._lastScript !== script) { o._lastScript = script; syncTextPanel(); }
      else { var box = $('.czs-fonts', el.sheetBody); if (box) $$('.czs-font span', box).forEach(function (s) { s.textContent = val.split('\n')[0].slice(0, 22) || t('text_default'); }); textPreview(); }
      clearTimeout(textTimer); textTimer = setTimeout(pushHistory, 400);
    });
  }
  function applyFont(f) {
    var o = activeText(); if (!f) return;
    lastFont = f.name; store('font', f.name);
    if (!o) { createText(t('text_default')); return; }
    loadFont(f, o.text).then(function () {
      o.set({ fontFamily: f.family, fontWeight: f.weight, fontStyle: f.style });
      o.czFont = f.name; if (o._czAuto) fitTextToPaper(o); o.setCoords();
      fc.requestRenderAll(); pushHistory(); positionObjbar();
      $$('.czs-font', el.sheetBody).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-font') === f.name ? 'true' : 'false'); });
      textPreview();
    });
  }

  /* draw */
  var brushCm = +(store('brush') || 0.2);
  function panelDraw() {
    el.sheetBody.innerHTML =
      '<p class="czs-muted">' + esc(t('draw_hint')) + '</p>' +
      '<label class="czs-label" for="czs-brush">' + esc(t('draw_size')) + ' <span data-bv></span></label>' +
      '<input id="czs-brush" class="czs-range" type="range" min="0.05" max="1" step="0.05" value="' + brushCm + '">' +
      '<button type="button" class="czs-btn czs-btn--accent czs-btn--block" data-act="close-tool">' + esc(t('draw_done')) + '</button>';
    var r = $('#czs-brush', el.sheetBody), bv = $('[data-bv]', el.sheetBody);
    function apply() {
      brushCm = +r.value; store('brush', String(brushCm));
      bv.textContent = '(' + fmtCm(brushCm.toFixed(2).replace(/0$/, '')) + ' ' + t('cm') + ')';
      fc.freeDrawingBrush = new F.PencilBrush(fc);
      fc.freeDrawingBrush.color = '#111111';
      fc.freeDrawingBrush.width = brushCm * LOGICAL;
      fc.freeDrawingBrush.decimate = 0.6;
    }
    r.addEventListener('input', apply);
    apply();
    fc.isDrawingMode = true;
  }

  /* ai */
  /* ---------- AI design: free generations of the studio backend (/api/freegen, no login, 10 per day) ----------
     The backend counts per session (signed token: httpOnly cookie + localStorage copy sent as
     X-Freegen-Token, because third-party cookies may be blocked), per IP and day, and globally. */
  var AI = { limit: 10, remaining: null, busy: false, loaded: false };
  function aiUrl() { return DATA.api ? DATA.api.replace(/\/$/, '') + '/api/freegen' : ''; }
  function aiFetch(opts) {
    var h = { Accept: 'application/json' }, tok = store('fg-token');
    if (tok) h['X-Freegen-Token'] = tok;
    if (opts && opts.body) h['Content-Type'] = 'application/json';
    return fetch(aiUrl(), Object.assign({ credentials: 'include', headers: h }, opts || {})).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (d) { d._status = res.status; aiTake(d); return d; });
    });
  }
  function zurichDay() { try { return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Zurich', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()); } catch (e) { return new Date().toISOString().slice(0, 10); } }
  function aiTake(d) {
    if (d.token) store('fg-token', d.token);
    if (typeof d.limit === 'number') AI.limit = d.limit;
    if (typeof d.remaining === 'number') { AI.remaining = d.remaining; store('fg-left', zurichDay() + '|' + d.remaining); }
  }
  function panelAi() {
    // cached count of today only (the limit resets at midnight Zurich time)
    if (AI.remaining === null) { var c = String(store('fg-left') || '').split('|'); if (c.length === 2 && c[0] === zurichDay() && c[1] !== '' && !isNaN(+c[1])) AI.remaining = +c[1]; }
    el.sheetBody.innerHTML = '<div class="czs-ai"></div>';
    renderAi();
    if (!AI.busy && aiUrl()) aiFetch({ method: 'GET' }).then(function () { AI.loaded = true; if (state.tool === 'ai' && !AI.busy) renderAi(); }, function () {});
  }
  function renderAi() {
    var box = $('.czs-ai', el.sheetBody); if (!box) return;
    var left = AI.remaining === null ? AI.limit : AI.remaining;
    var ta = $('textarea', box), draft = ta ? ta.value : '';
    var count = '<div class="czs-ai__credits"><b>' + esc(t('ai_free', { limit: AI.limit })) + '</b><span data-ai-left>' + esc(t('ai_free_left', { count: left, limit: AI.limit })) + '</span></div>';
    if (left <= 0) {
      box.innerHTML = count + '<p class="czs-ai__out">' + esc(t('ai_free_used', { limit: AI.limit })) + '</p>' +
        '<div class="czs-ai__alt"><button type="button" class="czs-btn czs-btn--block" data-ai-tool="inspo">' + ICON.inspo + '<span>' + esc(t('tool_inspo')) + '</span></button>' +
        '<button type="button" class="czs-btn czs-btn--block" data-ai-tool="upload">' + ICON.upload + '<span>' + esc(t('tool_upload')) + '</span></button></div>';
      $$('[data-ai-tool]', box).forEach(function (b) { b.addEventListener('click', function () { openTool(b.getAttribute('data-ai-tool')); }); });
      return;
    }
    box.innerHTML = '<p>' + esc(t('ai_intro')) + '</p>' + count +
      '<textarea class="czs-field" rows="3" maxlength="500" placeholder="' + esc(t('ai_placeholder')) + '" aria-label="' + esc(t('ai_title')) + '"></textarea>' +
      '<button type="button" class="czs-btn czs-btn--accent czs-btn--block" data-ai="go">' + ICON.ai + '<span>' + esc(t('ai_generate')) + '</span></button>' +
      '<div class="czs-ai__status" aria-live="polite" hidden></div>';
    $('textarea', box).value = draft;
    $('[data-ai="go"]', box).addEventListener('click', aiGenerate);
  }
  function aiStatus(msg, isError) {
    var st = $('.czs-ai__status', el.sheetBody); if (!st) { if (msg) toast(msg, isError); return; }
    st.hidden = !msg; st.classList.toggle('is-error', !!isError);
    st.innerHTML = msg ? (isError ? '' : '<span class="czs-spinner"></span>') + '<span>' + esc(msg) + '</span>' : '';
  }
  /* while the AI works the studio is locked behind a waiting screen with a little snake game made of
     ink drops (the drop of the Tattup logo) */
  var waitEl = null, snake = null;
  function dropPath(x, cx, cy, rr, ang) {
    x.save(); x.translate(cx, cy); x.rotate(ang || 0);
    x.beginPath();
    x.moveTo(0, -rr);
    x.bezierCurveTo(rr * 0.25, -rr * 0.55, rr * 0.82, -rr * 0.05, rr * 0.82, rr * 0.3);
    x.arc(0, rr * 0.3, rr * 0.82, 0, Math.PI);
    x.bezierCurveTo(-rr * 0.82, -rr * 0.05, -rr * 0.25, -rr * 0.55, 0, -rr);
    x.closePath(); x.fill(); x.restore();
  }
  function showAiWait() {
    if (waitEl) return;
    waitEl = document.createElement('div');
    waitEl.className = 'czs-wait';
    waitEl.innerHTML = '<div class="czs-wait__box"><p class="czs-wait__title"><span class="czs-spinner"></span><span>' + esc(t('ai_working')) + '</span></p>' +
      '<p class="czs-wait__sub">' + esc(t('ai_snake')) + '</p><div class="czs-wait__game"><canvas></canvas><button type="button" class="czs-btn czs-btn--accent" data-snake="start">' + esc(t('ai_snake_start')) + '</button></div>' +
      '<p class="czs-wait__score"><span>' + esc(t('ai_snake_score')) + ' <b>0</b></span><span>' + esc(t('ai_snake_best')) + ' <b data-best>' + (+(store('snake-best') || 0)) + '</b></span></p></div>';
    root.appendChild(waitEl);
    lockScroll('wait', true);
    initSnake($('canvas', waitEl));
    $('[data-snake="start"]', waitEl).addEventListener('click', function () { startSnake(); });
  }
  function hideAiWait() {
    if (!waitEl) return;
    if (snake) { clearInterval(snake.timer); document.removeEventListener('keydown', snake.key, true); }
    snake = null; waitEl.remove(); waitEl = null; lockScroll('wait', false);
  }
  function initSnake(cv) {
    var N = 18, box = cv.parentNode.getBoundingClientRect(), size = Math.floor(Math.min(box.width, 420) / N) * N;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    cv.width = size * dpr; cv.height = size * dpr; cv.style.width = size + 'px'; cv.style.height = size + 'px';
    var x = cv.getContext('2d'); x.scale(dpr, dpr);
    snake = { cv: cv, x: x, N: N, c: size / N, body: [], dir: [1, 0], next: [1, 0], food: null, score: 0, timer: 0, on: false };
    snake.key = function (ev) {
      var k = ev.key, d = { ArrowUp: [0, -1], ArrowDown: [0, 1], ArrowLeft: [-1, 0], ArrowRight: [1, 0], w: [0, -1], s: [0, 1], a: [-1, 0], d: [1, 0] }[k];
      if (d) { ev.preventDefault(); ev.stopPropagation(); turn(d); }
      else if ((k === ' ' || k === 'Enter') && !snake.on) { ev.preventDefault(); startSnake(); }
    };
    document.addEventListener('keydown', snake.key, true);
    var t0 = null;
    cv.addEventListener('touchstart', function (ev) { var p = ev.touches[0]; t0 = { x: p.clientX, y: p.clientY }; }, { passive: true });
    cv.addEventListener('touchmove', function (ev) { ev.preventDefault(); }, { passive: false });
    cv.addEventListener('touchend', function (ev) {
      if (!t0) return; var p = ev.changedTouches[0], dx = p.clientX - t0.x, dy = p.clientY - t0.y; t0 = null;
      if (Math.max(Math.abs(dx), Math.abs(dy)) < 18) { if (!snake.on) startSnake(); return; }
      turn(Math.abs(dx) > Math.abs(dy) ? [dx > 0 ? 1 : -1, 0] : [0, dy > 0 ? 1 : -1]);
    });
    drawSnake();
  }
  function turn(d) { if (!snake || !snake.on) return; if (d[0] === -snake.dir[0] && d[1] === -snake.dir[1]) return; snake.next = d; }
  function placeFood() {
    var free; do { free = [Math.floor(Math.random() * snake.N), Math.floor(Math.random() * snake.N)]; }
    while (snake.body.some(function (b) { return b[0] === free[0] && b[1] === free[1]; }));
    snake.food = free;
  }
  function startSnake() {
    if (!snake) return;
    var m = Math.floor(snake.N / 2);
    snake.body = [[m, m], [m - 1, m], [m - 2, m]]; snake.dir = [1, 0]; snake.next = [1, 0]; snake.score = 0; snake.on = true;
    placeFood(); setScore();
    var btn = waitEl && $('[data-snake="start"]', waitEl); if (btn) btn.hidden = true;
    clearInterval(snake.timer); snake.timer = setInterval(stepSnake, 130);
  }
  function setScore() { if (!waitEl) return; $('.czs-wait__score b', waitEl).textContent = snake.score; }
  function stepSnake() {
    var S = snake; S.dir = S.next;
    // no walls: the snake leaves one side and comes back on the other (owner 27.10.2026); only biting itself ends the round
    var h = [(S.body[0][0] + S.dir[0] + S.N) % S.N, (S.body[0][1] + S.dir[1] + S.N) % S.N];
    var dead = S.body.some(function (b) { return b[0] === h[0] && b[1] === h[1]; });
    if (dead) {
      S.on = false; clearInterval(S.timer);
      var best = +(store('snake-best') || 0); if (S.score > best) { store('snake-best', String(S.score)); $('[data-best]', waitEl).textContent = S.score; }
      var btn = $('[data-snake="start"]', waitEl); if (btn) { btn.textContent = t('ai_snake_again'); btn.hidden = false; }
      drawSnake(); return;
    }
    S.body.unshift(h);
    if (h[0] === S.food[0] && h[1] === S.food[1]) { S.score++; setScore(); placeFood(); } else S.body.pop();
    drawSnake();
  }
  function drawSnake() {
    var S = snake, x = S.x, c = S.c, size = c * S.N;
    x.clearRect(0, 0, size, size);
    x.fillStyle = 'rgba(255,255,255,0.03)';
    for (var i = 0; i < S.N; i++) for (var j = 0; j < S.N; j++) if ((i + j) % 2) x.fillRect(i * c, j * c, c, c);
    if (S.food) { x.fillStyle = '#dfff4f'; dropPath(x, (S.food[0] + 0.5) * c, (S.food[1] + 0.5) * c, c * 0.42, 0); }
    x.fillStyle = '#ffffff';
    S.body.forEach(function (b, k) {
      var prev = k === 0 ? [b[0] + S.dir[0], b[1] + S.dir[1]] : S.body[k - 1];
      var ang = Math.atan2(prev[1] - b[1], prev[0] - b[0]) - Math.PI / 2; // round side leads, tip trails like a falling drop
      dropPath(x, (b[0] + 0.5) * c, (b[1] + 0.5) * c, c * (k === 0 ? 0.5 : 0.42), ang + Math.PI);
    });
  }
  function aiGenerate() {
    if (AI.busy) return;
    var ta = $('.czs-ai textarea', el.sheetBody), prompt = ta ? ta.value.trim() : '';
    if (!prompt) { if (ta) ta.focus(); return; }
    if (!aiUrl()) { aiStatus(t('ai_failed'), true); return; }
    var sz = curSize(), aspect = sz && Math.abs(sz.w - sz.h) / Math.max(sz.w, sz.h) < 0.15 ? 'square' : 'portrait';
    AI.busy = true; aiStatus(t('ai_working')); showAiWait();
    aiFetch({ method: 'POST', body: JSON.stringify({ prompt: prompt, aspect: aspect }) }).then(function (d) {
      AI.busy = false; hideAiWait();
      if (d.image) { aiStatus(''); if (state.tool === 'ai') renderAi(); aiInsert(d.image, prompt); return; }
      if (state.tool === 'ai') renderAi();
      var e = d.error;
      aiStatus(e === 'session_limit' ? '' : e === 'busy' ? t('ai_busy') : e === 'ip_limit' || e === 'daily_limit' ? t('ai_daily') : e === 'blocked' ? t('ai_blocked') : t('ai_failed'), true);
    }).catch(function () { AI.busy = false; hideAiWait(); aiStatus(t('ai_failed'), true); });
  }
  /* the generated image goes onto the canvas like an upload (background removed automatically) */
  function aiInsert(url, prompt) {
    toast(t('upload_processing'));
    fetch(url, { mode: 'cors' }).then(function (res) { if (!res.ok) throw new Error('img'); return res.blob(); }).then(function (blob) {
      var type = blob.type || 'image/png', file = new File([blob], 'ki-design.' + (type.split('/')[1] || 'png').replace('jpeg', 'jpg'), { type: type });
      return addUpload(file, { trim: true, ai: true, aiUrl: url, prompt: prompt || null });
    }).then(function () { if (isMobile()) closeTool(); }).catch(function () { toast(t('error_generic'), true); });
  }

  function updateEmpty() {
    var emptyNow = fc.getObjects().length === 0;
    el.empty.hidden = !emptyNow;
    root.classList.toggle('is-empty', emptyNow);
    el.empty.textContent = emptyNow ? t('empty_design') : '';
  }

  /* zoom (design, desktop buttons) */
  root.addEventListener('click', function (ev) {
    var z = ev.target.closest('[data-zoom]'); if (!z) return;
    var v = z.getAttribute('data-zoom');
    state.zoom = v === 'in' ? Math.min(state.zoom * 1.25, 4) : v === 'out' ? Math.max(state.zoom / 1.25, 0.2) : 1;
    layoutPaper();
  });

  /* ---------- mode ---------- */
  $('.czs-mode').addEventListener('click', function (ev) {
    if (isMobile()) { setMode(state.mode === 'design' ? 'skin' : 'design'); return; }
    var b = ev.target.closest('[data-mode]'); if (b) setMode(b.getAttribute('data-mode'));
  });
  function setMode(mode) {
    if (mode !== 'design') hideNudge();
    state.mode = mode;
    root.setAttribute('data-mode', mode);
    $$('.czs-mode [data-mode]').forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-mode') === mode ? 'true' : 'false'); });
    if (mode === 'skin') {
      state.skinVisited = true;
      if (state.tool) closeTool();
      fc.discardActiveObject(); fc.requestRenderAll(); hideObjbar();
      renderSpots(); resizeSkin(); markSkinDirty(false);
      onbEvent('skin');
    } else {
      requestAnimationFrame(layoutPaper);
    }
  }

  /* ---------- skin view (visualizer) ---------- */
  var skin = { ctx: el.skinCanvas.getContext('2d'), photo: {}, mask: {}, design: null, designKey: '', view: { zoom: 1, panX: 0, panY: 0 }, drag: null };
  /* the customer's own body photo works like a mockup (id 'own'): its scale is unknown, so its ppc is
     set by the customer (scale handle / pinch on the tattoo). Kept only in this browser (KV 'own-photo'). */
  var OWN = null;
  // owner 20.10.2026: no own body photos – their scale can never be exact, only the calibrated studio photos count
  var OWN_PHOTO = false;
  function compatibleMockups(g) {
    var code = curSize().code;
    var list = MOCK.list.filter(function (m) { return m.g === (g || state.gender || 'f') && m.sizes.indexOf(code) > -1; });
    return OWN ? [OWN].concat(list) : list;
  }
  function currentMockup(noOwn) {
    if (state.ownActive && OWN && !noOwn) return OWN;
    var list = compatibleMockups().filter(function (m) { return !m.own; }); if (!list.length) return null;
    var g = state.gender || 'f';
    // one chosen body area per gender that stays when the size changes; the default for every size is the arm
    // from the side (owner 20.10.2026: no jumping between body areas)
    var id = state.spot[g];
    var found = list.filter(function (m) { return m.id === id; })[0];
    if (!found) found = list.filter(function (m) { return m.spot === 'armside'; })[0] || list.filter(function (m) { return m.spot !== 'full'; })[0] || list[0];
    return found;
  }
  function spotTile(m, cur, big) {
    return '<button type="button" class="czs-spot' + (big ? ' czs-spot--big' : '') + (m.own ? ' czs-spot--own' : '') + '" data-spot="' + m.id + '" aria-pressed="' + (!!cur && cur.id === m.id) + '"><img src="' + esc(m.thumb) + '" alt="" loading="lazy"><span>' + esc(t('spot_' + m.spot)) + '</span></button>';
  }
  function ownAddTile(big) {
    return OWN || !OWN_PHOTO ? '' : '<button type="button" class="czs-spot czs-spot--add' + (big ? ' czs-spot--big' : '') + '" data-own="add"><span class="czs-spot__ic">' + ICON.camera + '</span><span>' + esc(t('spot_own')) + '</span></button>';
  }
  function renderSpots() {
    var g = state.gender || 'f';
    $$('.czs-seg [data-gender]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-gender') === g ? 'true' : 'false'); });
    var list = compatibleMockups();
    var cur = currentMockup();
    el.spots.innerHTML = ownAddTile(false) + list.map(function (m) { return spotTile(m, cur, false); }).join('');
    $('span', el.spotBtn).textContent = cur ? t('spot_' + cur.spot) : t('spot_choose');
    el.spotBtn.disabled = false;
    $('.czs-realnote').textContent = t('skin_real') + ' · ' + sizeLabel();
    var own = !!(cur && cur.own);
    // the 60 cm sleeve is longer than the average arm of both models (from the side of the shoulder to the wrist)
    var sleeveF = curSize().code === 'sleeve' && !own;
    el.note.hidden = !sleeveF || store('note-sleeve') === '1';
    $('span', el.note).textContent = sleeveF ? t('sleeve_hint') : '';
    el.ownNew.hidden = !own;
    el.skinScale.hidden = !own;
  }
  function selectSpot(id) {
    if (id === 'own') { if (!OWN) return; state.ownActive = true; }
    else { state.ownActive = false; state.spot[state.gender || 'f'] = id; }
    skin.view = { zoom: 1, panX: 0, panY: 0 };
    autosave();
    renderSpots(); markSkinDirty(false); onbEvent('spot');
  }
  function onSpotClick(ev, after) {
    var add = ev.target.closest('[data-own="add"]');
    if (add) { if (after) after(); pickOwnPhoto(); return; }
    var b = ev.target.closest('[data-spot]'); if (b) { selectSpot(b.getAttribute('data-spot')); if (after) after(); }
  }
  el.spots.addEventListener('click', function (ev) { onSpotClick(ev); });
  function openSpotSheet() {
    var list = compatibleMockups(), cur = currentMockup();
    var m = openModal('<h2>' + esc(t('spot_choose')) + '</h2><div class="czs-spotgrid">' + ownAddTile(true) + list.map(function (x) { return spotTile(x, cur, true); }).join('') + '</div>', { sheet: true });
    m.addEventListener('click', function (ev) { onSpotClick(ev, closeModal); });
  }
  $('.czs-seg').addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-gender]'); if (b) setGender(b.getAttribute('data-gender'));
  });
  function setGender(g) {
    state.gender = g; store('gender', g);
    state.ownActive = false;
    skin.view = { zoom: 1, panX: 0, panY: 0 };
    renderSpots(); markSkinDirty(false);
  }

  /* ---------- own body photo ---------- */
  function pickOwnPhoto() { el.ownFile.value = ''; el.ownFile.click(); }
  el.ownFile.addEventListener('change', function () { var f = el.ownFile.files && el.ownFile.files[0]; el.ownFile.value = ''; if (f) addOwnPhoto(f); });
  function addOwnPhoto(file) {
    var name = (file.name || '').toLowerCase();
    var isHeic = /heic|heif/.test(file.type) || /\.(heic|heif)$/.test(name);
    if (!/^image\//.test(file.type) && !isHeic && !/\.(png|jpe?g|webp)$/.test(name)) { toast(t('upload_error_type'), true); return; }
    if (file.size > MAX_PHOTO) { toast(t('own_error_size'), true); return; }
    toast(t('own_processing'));
    var url = URL.createObjectURL(file);
    loadImage(url).catch(function () { throw new Error(isHeic ? 'heic' : 'decode'); }).then(function (img) {
      URL.revokeObjectURL(url);
      var k = Math.min(1, 2048 / Math.max(img.naturalWidth, img.naturalHeight));
      var w = Math.max(1, Math.round(img.naturalWidth * k)), h = Math.max(1, Math.round(img.naturalHeight * k));
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      c.getContext('2d').drawImage(img, 0, 0, w, h);
      var rec = { v: 2, img: c.toDataURL('image/jpeg', 0.88), w: w, h: h, ppc: 0 };
      return setupOwn(rec, true).then(function () {
        KV.set('own-photo', rec);
        state.ownActive = true; skin.view = { zoom: 1, panX: 0, panY: 0 };
        if (state.mode !== 'skin') setMode('skin'); else { renderSpots(); markSkinDirty(false); }
        toast(t('own_ready'));
      });
    }).catch(function (err) { toast(err && err.message === 'heic' ? t('upload_error_heic') : t('error_generic'), true); });
  }
  function saveOwn() { if (OWN && OWN.rec) { OWN.rec.ppc = OWN.ppc; KV.set('own-photo', OWN.rec); } }
  /* builds the pseudo mockup from a stored record: photo, start position (centre) and scale. No skin mask:
     the design is simply shown on the customer's photo. */
  function setupOwn(rec, fresh) {
    return loadImage(rec.img).then(function (img) {
      var thumb = document.createElement('canvas'), tk = 160 / Math.max(rec.w, rec.h);
      thumb.width = Math.round(rec.w * tk); thumb.height = Math.round(rec.h * tk);
      thumb.getContext('2d').drawImage(img, 0, 0, thumb.width, thumb.height);
      var o = { id: 'own', own: true, g: '*', spot: 'own', w: rec.w, h: rec.h, img: rec.img, thumb: thumb.toDataURL('image/jpeg', 0.8), sizes: SIZES.map(function (s) { return s.code; }), r: 14, rec: rec, imgEl: img, ppc: rec.ppc || 0, anchor: { 'default': [rec.w / 2, rec.h / 2, 0] } };
      // first guess: the sheet's long side about 40 % of the photo's short side; the customer then adjusts it
      if (!o.ppc) { var sz = curSize(); o.ppc = clamp(0.4 * Math.min(o.w, o.h) / Math.max(sz.w, sz.h), 2, 400); rec.ppc = o.ppc; }
      if (fresh) Object.keys(state.place).forEach(function (k) { if (k.indexOf('own:') === 0) delete state.place[k]; });
      OWN = o;
      delete skin.photo.own; delete skin.mask.own;
      return o;
    });
  }
  function loadOwnPhoto() {
    if (!OWN_PHOTO) return Promise.resolve();
    return KV.get('own-photo').then(function (rec) { if (rec && rec.img) return setupOwn(rec, false); }).catch(function () {});
  }

  function placementKey(m) { return m.id + ':' + curSize().code; }
  function anchorFor(m) { var a = m.anchor[curSize().code] || m.anchor['default']; return { x: a[0], y: a[1], angle: a[2] || 0, r: a[3] || m.r, k: a[4] || 1 }; }
  function placement(m) {
    var k = placementKey(m);
    if (!state.place[k]) { var a = anchorFor(m); state.place[k] = { x: a.x, y: a.y, rot: 0 }; }
    return state.place[k];
  }
  /* the ink is rendered at inkPpc (photo px per cm, before INK_SCALE); for the own photo it changes in
     steps while the customer scales, the rest is a draw-time factor (inkK) */
  function inkPpc(m) {
    if (!m.own) return m.ppc;
    var sz = curSize(), b = Math.pow(2, Math.ceil(Math.log(m.ppc) / Math.LN2 * 2) / 2);
    return Math.min(b, 4000 / (Math.max(sz.w, sz.h) * INK_SCALE));
  }
  function inkK(m) { return m.own ? m.ppc / inkPpc(m) : 1; }
  /* the whole sheet turns in the skin view (placement.rot, degrees): handle on the frame, two-finger
     twist or arrow keys on the focused handle. Snaps to straight / quarter turns near them. */
  function normRot(r) { r = ((r + 180) % 360 + 360) % 360 - 180; var q = Math.round(r / 90) * 90; return Math.abs(r - q) < 4 ? (q === -180 ? 180 : q) : Math.round(r); }
  function setSkinRot(r) { var m = currentMockup(); if (!m) return; placement(m).rot = normRot(r); markSkinDirty(false); }
  el.skinRot.addEventListener('keydown', function (ev) {
    var m = currentMockup(); if (!m) return;
    var d = ev.key === 'ArrowRight' || ev.key === 'ArrowUp' ? 5 : ev.key === 'ArrowLeft' || ev.key === 'ArrowDown' ? -5 : 0;
    if (!d) return;
    ev.preventDefault(); setSkinRot(placement(m).rot + d);
  });
  el.skinScale.addEventListener('keydown', function (ev) {
    var m = currentMockup(); if (!m || !m.own) return;
    var d = ev.key === 'ArrowRight' || ev.key === 'ArrowUp' ? 1.05 : ev.key === 'ArrowLeft' || ev.key === 'ArrowDown' ? 1 / 1.05 : 0;
    if (!d) return;
    ev.preventDefault(); m.ppc = clamp(m.ppc * d, 2, 400); saveOwn(); markSkinDirty(false);
  });
  root.addEventListener('click', function (ev) {
    var z = ev.target.closest('[data-szoom]'); if (!z) return;
    var v = z.getAttribute('data-szoom');
    if (v === 'reset') { var m = currentMockup(); if (m) delete state.place[placementKey(m)]; skin.view = { zoom: 1, panX: 0, panY: 0 }; }
    else zoomSkin(clamp(skin.view.zoom * (v === 'in' ? 1.4 : 1 / 1.4), 1, 6));
    markSkinDirty(false);
  });

  function zoomSkin(z) {
    var m = currentMockup(); if (!m || !skin.cw) { skin.view.zoom = z; return; }
    var pl = placement(m);
    var s0 = Math.min(skin.cw / m.w, skin.ch / m.h);
    var sc = s0 * z;
    skin.view.zoom = z;
    skin.view.panX = (skin.cw / 2 - pl.x * sc) - (skin.cw - m.w * sc) / 2;
    skin.view.panY = (skin.ch / 2 - pl.y * sc) - (skin.ch - m.h * sc) / 2;
  }
  var skinRaf = 0;
  function markSkinDirty(designChanged) {
    if (designChanged) { skin.design = null; skin.warpKey = ''; }
    if (state.mode !== 'skin' || skinRaf) return;
    skinRaf = requestAnimationFrame(function () { skinRaf = 0; drawSkin(); });
  }
  function resizeSkin() {
    var r = el.skinWrap.getBoundingClientRect();
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    el.skinCanvas.width = Math.max(1, Math.round(r.width * dpr));
    el.skinCanvas.height = Math.max(1, Math.round(r.height * dpr));
    skin.dpr = dpr; skin.cw = r.width; skin.ch = r.height;
    markSkinDirty(false);
  }
  function getPhoto(m) {
    if (skin.photo[m.id]) return skin.photo[m.id];
    var p = skin.photo[m.id] = { ready: false };
    if (m.own) { p.img = m.imgEl; p.ready = true; return p; }
    loadImage(m.img).then(function (img) { p.img = img; p.ready = true; markSkinDirty(false); }).catch(function () { delete skin.photo[m.id]; });
    return p;
  }
  function getMask(m) {
    if (skin.mask[m.id]) return skin.mask[m.id];
    var p = skin.mask[m.id] = { ready: false };
    if (m.own) { p.canvas = null; p.ready = true; return p; }
    loadImage(m.mask).then(function (img) {
      var c = document.createElement('canvas'); c.width = m.w; c.height = m.h;
      var x = c.getContext('2d', { willReadFrequently: true });
      x.drawImage(img, 0, 0, m.w, m.h);
      var d = x.getImageData(0, 0, m.w, m.h), a = d.data;
      // hard edge: only confident skin carries ink (nothing bleeds onto clothing)
      for (var i = 0; i < a.length; i += 4) { a[i + 3] = Math.max(0, Math.min(255, (a[i] - 140) * 3)); a[i] = a[i + 1] = a[i + 2] = 0; }
      x.putImageData(d, 0, 0);
      p.canvas = c; p.ready = true; markSkinDirty(false);
    }).catch(function () { delete skin.mask[m.id]; });
    return p;
  }
  /* view transform: fit the photo into the wrap (contain), then zoom/pan */
  function viewTransform(m, cw, ch, sv) {
    cw = cw || skin.cw; ch = ch || skin.ch; sv = sv || skin.view;
    var s0 = Math.min(cw / m.w, ch / m.h);
    var s = s0 * sv.zoom;
    var ox = (cw - m.w * s) / 2 + sv.panX;
    var oy = (ch - m.h * s) / 2 + sv.panY;
    if (sv.zoom > 1) {
      ox = clamp(ox, Math.min(0, cw - m.w * s), Math.max(0, cw - m.w * s));
      oy = clamp(oy, Math.min(0, ch - m.h * s), Math.max(0, ch - m.h * s));
      sv.panX = ox - (cw - m.w * s) / 2; sv.panY = oy - (ch - m.h * s) / 2;
    } else { sv.panX = 0; sv.panY = 0; ox = (cw - m.w * s) / 2; oy = (ch - m.h * s) / 2 + (m.dy || 0) * ch; } // dy: start a bit lower (shoulder clear of the mode switch)
    return { s: s, ox: ox, oy: oy };
  }
  /* design rendered as tattoo ink at INK_SCALE × the mockup's scale (async, cached) */
  function designInk(m) {
    var sz = curSize();
    var k = anchorFor(m).k, ip = inkPpc(m);
    var tw = Math.max(4, Math.round(sz.w * ip * k * INK_SCALE)), th = Math.max(4, Math.round(sz.h * ip * k * INK_SCALE));
    var key = m.id + '|' + sz.code + '|' + ip + '|' + hIndex + '|' + history.length;
    if (skin.design && skin.designKey === key) return Promise.resolve(skin.design);
    if (skin.pending && skin.pendingKey === key) return skin.pending;
    skin.pendingKey = key;
    skin.pending = renderOff(tw, null).then(function (src) { return inkFrom(src, tw, th, key); }).catch(function (e) { skin.pending = null; skin.pendingKey = ''; throw e; });
    return skin.pending;
  }
  function inkFrom(src, tw, th, key) {
    var c = document.createElement('canvas'); c.width = tw; c.height = th;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(src, 0, 0, tw, th);
    var d = x.getImageData(0, 0, tw, th), p = d.data;
    for (var i = 0; i < p.length; i += 4) {
      var lum = (0.299 * p[i] + 0.587 * p[i + 1] + 0.114 * p[i + 2]) / 255;
      var a = (p[i + 3] / 255) * clamp((1 - lum) * 1.2, 0, 1);
      p[i] = INK[0]; p[i + 1] = INK[1]; p[i + 2] = INK[2]; p[i + 3] = Math.round(a * 255);
    }
    x.putImageData(d, 0, 0);
    skin.design = c; skin.designKey = key; skin.warpKey = ''; skin.pending = null;
    return c;
  }
  /* every text font is loaded (and the text measured again) before the design is rendered: a font that
     was never shown on screen – e.g. a design restored after a reload – would otherwise be drawn in a
     fallback font into the print file */
  function ensureFonts(objs) {
    if (!document.fonts) return Promise.resolve();
    var texts = (objs || fc.getObjects()).filter(function (o) { return o.czKind === 'text'; });
    return Promise.all(texts.map(function (o) {
      var f = fontByName(o.czFont) || { family: o.fontFamily, weight: o.fontWeight, style: o.fontStyle };
      var spec = (f.style === 'italic' ? 'italic ' : '') + f.weight + ' 40px "' + f.family + '"';
      var ok = false; try { ok = document.fonts.check(spec, o.text || 'A'); } catch (e) {}
      if (ok && o._czMeasured === f.family) return null;
      return loadFont(f, o.text).then(function () {
        o._czMeasured = f.family;
        if (F.cache && F.cache.clearFontCache) F.cache.clearFontCache(o.fontFamily);
        if (o.initDimensions) { o.initDimensions(); o.setCoords(); o.dirty = true; }
      });
    }));
  }
  /* render the design off-screen in logical space (independent of the visible, zoomed canvas). No object
     cache: fabric limits a cache to about 2 megapixels, which would blur large texts and images in the
     300 DPI print file */
  function toVector(o, mult) {
    var im = o.czKind === 'inspo' && imgs[o.czId];
    if (!im || !im.vec || o.getScaledWidth() * mult <= im.w) return Promise.resolve(o);
    var sw = o.getScaledWidth(), sh = o.getScaledHeight();
    return o.setSrc(im.vec).then(function () { o.set({ scaleX: sw / o.width, scaleY: sh / o.height }); return o; }).catch(function () { return o; });
  }
  function renderOff(targetW, background) {
    var mult = targetW / LW();
    return ensureFonts().then(function () {
      return Promise.all(fc.getObjects().map(function (o) { return o.clone(PROPS).then(function (cl) { cl.objectCaching = false; return toVector(cl, mult); }); }));
    }).then(function (clones) {
      var c = document.createElement('canvas');
      var sc = new F.StaticCanvas(c, { width: LW(), height: LH(), enableRetinaScaling: false, renderOnAddRemove: false, backgroundColor: background || null });
      clones.forEach(function (o) { sc.add(o); });
      sc.renderAll();
      var out = sc.toCanvasElement(mult);
      sc.dispose();
      return out;
    });
  }
  /* rotate the whole sheet inside the limb frame, then wrap it around a cylinder along the limb. The
     curve is limited so the whole design always stays visible (nothing disappears behind the limb) */
  var WRAP_MAX = 0.9; // max. wrap angle on each side in radians (about 52°)
  function warp(src, rot, R) {
    var rad = rot * Math.PI / 180;
    var cw = Math.ceil(Math.abs(src.width * Math.cos(rad)) + Math.abs(src.height * Math.sin(rad)));
    var ch = Math.ceil(Math.abs(src.width * Math.sin(rad)) + Math.abs(src.height * Math.cos(rad)));
    var r1 = document.createElement('canvas'); r1.width = cw; r1.height = ch;
    var x1 = r1.getContext('2d');
    x1.translate(cw / 2, ch / 2); x1.rotate(rad); x1.drawImage(src, -src.width / 2, -src.height / 2);
    var out = document.createElement('canvas');
    R = Math.max(R, cw / 2 / WRAP_MAX);
    out.width = Math.max(2, Math.ceil(2 * R * Math.sin(cw / 2 / R)) + 2); out.height = ch;
    var xo = out.getContext('2d');
    var strip = 2;
    for (var sx = 0; sx < cw; sx += strip) {
      var th0 = (sx - cw / 2) / R, th1 = (sx + strip - cw / 2) / R;
      var x0 = R * Math.sin(th0) + out.width / 2, x1 = R * Math.sin(th1) + out.width / 2;
      // strips overlap by a pixel so no seams show
      xo.drawImage(r1, sx, 0, Math.min(strip, cw - sx), ch, x0 - 0.5, 0, Math.max(0.5, x1 - x0) + 1, ch);
    }
    return out;
  }
  function warpedDesign(m, ink, pl, R) {
    var key = skin.designKey + '|' + Math.round(pl.rot) + '|' + R;
    if (skin.warp && skin.warpKey === key) return skin.warp;
    skin.warp = warp(ink, pl.rot, R); skin.warpKey = key;
    return skin.warp;
  }
  var layer = document.createElement('canvas');
  function drawSkin() {
    if (state.mode !== 'skin') return;
    if (!skin.cw) { resizeSkin(); return; }
    var m = currentMockup();
    var hasDesign = fc.getObjects().length > 0;
    el.skinEmpty.hidden = !!m && hasDesign;
    // a set from the Hand Tattoo Builder (unchanged since): show the hand from the builder, editable there
    var hv = $('.czs-handview'), handSet = state.handPreview && state.handPreview.at === hIndex && !(m && m.own);
    hv.hidden = !handSet;
    if (handSet && $('img', hv).getAttribute('src') !== state.handPreview.url) $('img', hv).setAttribute('src', state.handPreview.url);
    if (handSet) { var hb = $('.czs-btn', hv), hk = state.handPreview.kind === 'sleeve' || state.handPreview.kind === 'script' ? state.handPreview.kind : 'hand'; hb.setAttribute('data-act', hk); $('span', hb).textContent = t(hk + '_edit'); }
    if (!m) { $('p', el.skinEmpty).textContent = t('skin_none'); clearSkin(); el.skinUi.hidden = true; return; }
    if (!hasDesign) $('p', el.skinEmpty).textContent = t('skin_empty');
    var photo = getPhoto(m), mask = getMask(m);
    if (!photo.ready) return;
    if (!hasDesign || !mask.ready || handSet) el.skinUi.hidden = true;
    if (!hasDesign || !mask.ready) { paintSkin(skin.ctx, m, null, skin.cw, skin.ch, skin.dpr || 1, skin.view, true); return; }
    designInk(m).then(function (ink) {
      if (state.mode !== 'skin') return;
      if (currentMockup() !== m) { markSkinDirty(false); return; }
      paintSkin(skin.ctx, m, ink, skin.cw, skin.ch, skin.dpr || 1, skin.view, true);
      if (!handSet) positionSkinUI(m); else el.skinUi.hidden = true;
    }).catch(function () { setTimeout(function () { markSkinDirty(true); }, 400); });
  }
  /* sheet point (cm from the sheet centre) → screen point inside the skin wrap: the same chain as
     paintSkin/warp (turn the sheet, wrap it around the limb, anchor angle, photo → view) */
  function sheetToScreen(m, xcm, ycm) {
    var sz = curSize(), a = anchorFor(m), pl = placement(m), v = viewTransform(m), ip = inkPpc(m), dk = inkK(m);
    var k = ip * a.k * INK_SCALE, w = sz.w * k, h = sz.h * k;
    var rad = pl.rot * Math.PI / 180, c = Math.cos(rad), s = Math.sin(rad);
    var bw = Math.abs(w * c) + Math.abs(h * s);
    var R = Math.max(Math.max(1, a.r * ip * INK_SCALE), bw / 2 / WRAP_MAX);
    var x = xcm * k, y = ycm * k;
    var xr = x * c - y * s, yr = x * s + y * c;
    var xw = R * Math.sin(xr / R);
    var A = a.angle * Math.PI / 180, ca = Math.cos(A), sa = Math.sin(A);
    var px = pl.x + (xw * ca - yr * sa) * dk / INK_SCALE, py = pl.y + (xw * sa + yr * ca) * dk / INK_SCALE;
    return { x: v.ox + px * v.s, y: v.oy + py * v.s };
  }
  /* union of all elements on the sheet in cm (only the printed part inside the sheet), from the sheet's top left */
  function designBox() {
    var x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    fc.getObjects().forEach(function (o) { o.getCoords().forEach(function (p) { x0 = Math.min(x0, p.x); x1 = Math.max(x1, p.x); y0 = Math.min(y0, p.y); y1 = Math.max(y1, p.y); }); });
    if (x0 === Infinity) return null;
    x0 = clamp(x0, 0, LW()); x1 = clamp(x1, 0, LW()); y0 = clamp(y0, 0, LH()); y1 = clamp(y1, 0, LH());
    return { x0: x0 / LOGICAL, y0: y0 / LOGICAL, x1: x1 / LOGICAL, y1: y1 / LOGICAL, w: (x1 - x0) / LOGICAL, h: (y1 - y0) / LOGICAL };
  }
  /* the sheet's frame (faint; stronger while the tattoo is selected – the sheet is never painted on the skin), the rotation handle
     on its top edge and, on the own photo, the scale handle at its corner.
     The controls floating over the preview (mode switch, zoom column, chips, hint) are keep-out zones: if
     the top edge runs under one of them (large sizes), the width figure and the handle move along that edge,
     then to the bottom edge, and as a last resort just out of the control's way. */
  function positionSkinUI(m) {
    var sz = curSize(), hw = sz.w / 2, hh = sz.h / 2;
    var cw = skin.cw, ch = skin.ch, ui = el.skinUi;
    ui.hidden = false;
    function edge(xcm, ycm, dx, dy) {
      var p = sheetToScreen(m, xcm, ycm), q = sheetToScreen(m, xcm + dx, ycm + dy);
      var nx = q.x - p.x, ny = q.y - p.y, n = Math.hypot(nx, ny) || 1;
      return { x: p.x, y: p.y, nx: nx / n, ny: ny / n };
    }
    var wr = el.skinWrap.getBoundingClientRect(), keep = [];
    $$('.czs-mode, .czs-sizebtn, .czs-real, .czs-ownnew, .czs-skin__ctrl, .czs-meas, .czs-note').forEach(function (n) {
      var r = n.getBoundingClientRect(); if (!r.width || !r.height) return;
      keep.push({ x0: r.left - wr.left - 6, y0: r.top - wr.top - 6, x1: r.right - wr.left + 6, y1: r.bottom - wr.top + 6 });
    });
    function rect(p) { return { x0: p.x - p.w / 2, y0: p.y - p.h / 2, x1: p.x + p.w / 2, y1: p.y + p.h / 2 }; }
    function meets(a, b) { return a.x0 < b.x1 && a.x1 > b.x0 && a.y0 < b.y1 && a.y1 > b.y0; }
    function hit(p, extra) { var r = rect(p); return keep.concat(extra || []).filter(function (k) { return meets(r, k); })[0]; }
    // position beyond the edge, kept inside the preview; off = how far the clamp pulled it from the edge
    function spot(node, e, gap, margin) {
      var bw = node.offsetWidth, bh = node.offsetHeight;
      var o = gap + Math.abs(e.nx) * bw / 2 + Math.abs(e.ny) * bh / 2, ux = e.x + e.nx * o, uy = e.y + e.ny * o;
      var x = clamp(ux, bw / 2 + margin, cw - bw / 2 - margin), y = clamp(uy, bh / 2 + margin, ch - bh / 2 - margin);
      return { x: x, y: y, w: bw, h: bh, m: margin, off: Math.hypot(x - ux, y - uy) };
    }
    // last resort: the nearest free spot around a box that still sits under a control (inside the preview)
    function free(p, extra) {
      if (!hit(p, extra)) return p;
      var mx = p.w / 2 + p.m, my = p.h / 2 + p.m;
      for (var d = 8; d < cw + ch; d += 8) {
        for (var a = 0; a < 16; a++) {
          var q = { x: clamp(p.x + d * Math.cos(a * Math.PI / 8), mx, cw - mx), y: clamp(p.y + d * Math.sin(a * Math.PI / 8), my, ch - my), w: p.w, h: p.h, m: p.m, off: p.off };
          if (!hit(q, extra)) return q;
        }
      }
      return p;
    }
    function set(node, p) { node.style.left = p.x + 'px'; node.style.top = p.y + 'px'; }
    // the usual spot (first in the list) unless a control covers it, or while the handle is being turned the
    // spot it already had; otherwise the free candidate that is least clamped and closest to the usual spot
    function pick(list, score, keepIdx) {
      if (list[keepIdx] && score(list[keepIdx]) < 1e6) return { c: list[keepIdx], i: keepIdx };
      if (score(list[0]) < 1e6) return { c: list[0], i: 0 };
      var best = null; list.forEach(function (c, i) { var s = score(c) + i * 4; if (!best || s < best.s) best = { c: c, s: s, i: i }; }); return best;
    }
    // the frame is the whole sheet, without cm figures (owner 20.10.2026: only the sheet size counts)
    var box = { x0: 0, y0: 0, x1: sz.w, y1: sz.h, w: sz.w, h: sz.h };
    var bx0 = box.x0 - hw, by0 = box.y0 - hh, bx1 = box.x1 - hw, by1 = box.y1 - hh;
    var dw = $('[data-sdim="w"]', ui), dh = $('[data-sdim="h"]', ui);
    dw.textContent = dh.textContent = ''; dw.hidden = dh.hidden = true;
    var FR = [0, -0.2, 0.2, -0.4, 0.4], extra = [];
    // own photo: scale handle at the design's bottom right corner
    if (m.own) {
      var cr = sheetToScreen(m, bx1, by1), c0 = sheetToScreen(m, (bx0 + bx1) / 2, (by0 + by1) / 2), dx = cr.x - c0.x, dy = cr.y - c0.y, dn = Math.hypot(dx, dy) || 1;
      var sx = clamp(cr.x + dx / dn * 16, 18, cw - 18), sy = clamp(cr.y + dy / dn * 16, 18, ch - 18);
      el.skinScale.style.left = sx + 'px'; el.skinScale.style.top = sy + 'px';
      extra.push(rect({ x: sx, y: sy, w: el.skinScale.offsetWidth + 8, h: el.skinScale.offsetHeight + 8 }));
    }
    // height figure on the right edge (left edge if the right one is covered)
    var hc = [];
    [[bx1, 1], [bx0, -1]].forEach(function (s) { FR.forEach(function (f) { hc.push(spot(dh, edge(s[0], (by0 + by1) / 2 + f * (by1 - by0), s[1], 0), 6, 4)); }); });
    var hb = free(pick(hc, function (p) { return (hit(p, extra) ? 1e6 : 0) + p.off; }, -1).c, extra);
    set(dh, hb); extra.push(rect(hb));
    // width figure and rotation handle beyond it, together on the top edge (bottom edge if needed)
    var gc = [];
    [[by1, 1], [by0, -1]].forEach(function (s) { // bottom edge first (owner 20.10.2026: same place for woman and man), top as fallback
      FR.forEach(function (f) {
        var e = edge((bx0 + bx1) / 2 + f * (bx1 - bx0), s[0], 0, s[1]);
        var w = spot(dw, e, 6, 4), r = spot(el.skinRot, e, 6 + 2 * (Math.abs(e.nx) * w.w / 2 + Math.abs(e.ny) * w.h / 2) + 6, 6);
        gc.push({ e: e, w: w, r: r });
      });
    });
    var g = pick(gc, function (c) { return (hit(c.w, extra) || hit(c.r, extra.concat([rect(c.w)])) ? 1e6 : 0) + c.w.off + c.r.off; }, skin.drag && skin.drag.type === 'rot' ? skin.uiPick : -1);
    skin.uiPick = g.i;
    var wb = free(g.c.w, extra); set(dw, wb);
    var hp = free(g.c.r, extra.concat([rect(wb)])); set(el.skinRot, hp);
    // the design's frame (follows rotation and wrap)
    var pts = [], N = 10, i;
    for (i = 0; i <= N; i++) pts.push(sheetToScreen(m, bx0 + (bx1 - bx0) * i / N, by0));
    for (i = 0; i <= N; i++) pts.push(sheetToScreen(m, bx1, by0 + (by1 - by0) * i / N));
    for (i = 0; i <= N; i++) pts.push(sheetToScreen(m, bx1 - (bx1 - bx0) * i / N, by1));
    for (i = 0; i <= N; i++) pts.push(sheetToScreen(m, bx0, by1 - (by1 - by0) * i / N));
    skin.frame = pts; // screen outline of the sheet: a press inside it moves the tattoo (insideSheet)
    $('.czs-skinui__box', ui).setAttribute('points', pts.map(function (p) { return Math.round(p.x * 10) / 10 + ',' + Math.round(p.y * 10) / 10; }).join(' '));
    // link line from the frame edge to the rotation handle
    var ln = $('line', ui);
    ln.setAttribute('x1', g.c.e.x); ln.setAttribute('y1', g.c.e.y); ln.setAttribute('x2', hp.x); ln.setAttribute('y2', hp.y);
  }
  function clearSkin() { var c = skin.ctx; c.setTransform(1, 0, 0, 1, 0, 0); c.clearRect(0, 0, el.skinCanvas.width, el.skinCanvas.height); }
  /* paints photo + masked tattoo into ctx (screen canvas or snapshot canvas) */
  function paintSkin(ctx, m, ink, cw, ch, dpr, sv, live) {
    var W = Math.round(cw * dpr), H = Math.round(ch * dpr);
    ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, W, H);
    var v = viewTransform(m, cw, ch, sv);
    ctx.setTransform(dpr * v.s, 0, 0, dpr * v.s, dpr * v.ox, dpr * v.oy);
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(skin.photo[m.id].img, 0, 0, m.w, m.h);
    if (!ink) return;
    var a = anchorFor(m), pl = placement(m), ip = inkPpc(m), dk = inkK(m);
    var R = Math.max(1, a.r * ip * INK_SCALE);
    var warped = warpedDesign(m, ink, pl, R);
    if (layer.width !== W || layer.height !== H) { layer.width = W; layer.height = H; }
    function draw(target, img, op, alpha, unmasked) {
      var lx = target.getContext('2d');
      lx.setTransform(1, 0, 0, 1, 0, 0); lx.clearRect(0, 0, W, H);
      lx.setTransform(dpr * v.s, 0, 0, dpr * v.s, dpr * v.ox, dpr * v.oy);
      lx.save();
      lx.translate(pl.x, pl.y); lx.rotate(a.angle * Math.PI / 180); lx.scale(dk / INK_SCALE, dk / INK_SCALE);
      lx.drawImage(img, -img.width / 2, -img.height / 2);
      lx.restore();
      // studio photos: ink only on skin (mask); the customer's own photo has no mask
      if (!unmasked && skin.mask[m.id] && skin.mask[m.id].canvas) {
        lx.globalCompositeOperation = 'destination-in';
        lx.drawImage(skin.mask[m.id].canvas, 0, 0, m.w, m.h);
        lx.globalCompositeOperation = 'source-over';
      }
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.globalCompositeOperation = op;
      ctx.globalAlpha = alpha == null ? 1 : alpha;
      ctx.drawImage(target, 0, 0);
      ctx.globalAlpha = 1;
      ctx.globalCompositeOperation = 'source-over';
    }
    // two states (owner 20.10.2026): tapped / moved = the whole design shows, lighter beyond the skin, and the sheet frame
    // is a bit stronger; otherwise the tattoo hugs the body, nothing outside the skin, the frame almost invisible.
    // The sheet itself is never painted on the skin.
    if (live && (skin.active || skin.drag && (skin.drag.type === 'move' || skin.drag.type === 'rot'))) draw(layer, warped, 'source-over', 0.45, true);
    draw(layer, warped, 'multiply');
  }
  /* drag the tattoo to move it, turn it with the handle on the frame (or a two-finger twist), pan
     when zoomed, pinch / ctrl+wheel to zoom. On the own photo: the corner handle or a pinch on the
     tattoo scales it. */
  (function () {
    var pts = {}, pinch = null;
    function toPhoto(m, cx, cy) { var r = el.skinWrap.getBoundingClientRect(); var v = viewTransform(m); return { x: (cx - r.left - v.ox) / v.s, y: (cy - r.top - v.oy) / v.s }; }
    function pivot(m) { var r = el.skinWrap.getBoundingClientRect(), c = sheetToScreen(m, 0, 0); return { x: r.left + c.x, y: r.top + c.y }; }
    // owner 20.10.2026: the tattoo moves only when the press is inside the sheet's outline; outside it pans (zoomed) or deselects
    function insideSheet(ev) {
      var f = skin.frame; if (!f || !f.length || el.skinUi.hidden || !fc.getObjects().length) return false;
      var r = el.skinWrap.getBoundingClientRect(), x = ev.clientX - r.left, y = ev.clientY - r.top, inside = false;
      for (var i = 0, j = f.length - 1; i < f.length; j = i++) { if ((f[i].y > y) !== (f[j].y > y) && x < (f[j].x - f[i].x) * (y - f[i].y) / (f[j].y - f[i].y) + f[i].x) inside = !inside; }
      return inside;
    }
    function nearTattoo(m, p) { var sz = curSize(), pl = placement(m); return fc.getObjects().length > 0 && Math.hypot(p.x - pl.x, p.y - pl.y) < Math.max(sz.w, sz.h) * m.ppc * 0.55 + 24; }
    el.skinWrap.addEventListener('pointerdown', function (ev) {
      var m = currentMockup(); if (!m) return;
      if (ev.pointerType === 'mouse' && ev.button !== 0) return;
      el.skinWrap.setPointerCapture(ev.pointerId);
      pts[ev.pointerId] = { x: ev.clientX, y: ev.clientY };
      var ids = Object.keys(pts);
      if (ids.length === 2) {
        var a = pts[ids[0]], b = pts[ids[1]];
        var m0 = currentMockup();
        var mid = m0 ? toPhoto(m0, (a.x + b.x) / 2, (a.y + b.y) / 2) : null;
        pinch = { d: Math.hypot(a.x - b.x, a.y - b.y), zoom: skin.view.zoom, ang: Math.atan2(b.y - a.y, b.x - a.x), rot: m0 ? placement(m0).rot : 0, turning: false,
          scale: !!(m0 && m0.own && mid && nearTattoo(m0, mid)), ppc: m0 ? m0.ppc : 0 };
        skin.drag = null; el.skinWrap.classList.remove('is-rotating'); return;
      }
      if (ids.length > 2) return;
      var p = toPhoto(m, ev.clientX, ev.clientY), pl = placement(m);
      if (ev.target.closest && ev.target.closest('.czs-skinrot') && !el.skinUi.hidden) {
        ev.preventDefault();
        var c = pivot(m);
        skin.drag = { type: 'rot', cx: c.x, cy: c.y, a0: Math.atan2(ev.clientY - c.y, ev.clientX - c.x), r0: pl.rot }; clearTimeout(skin.idleT); skin.active = true; el.skinUi.classList.add('is-active');
        el.skinWrap.classList.add('is-dragging', 'is-rotating');
        return;
      }
      if (m.own && ev.target.closest && ev.target.closest('.czs-skinscale') && !el.skinUi.hidden) {
        ev.preventDefault();
        var c2 = pivot(m);
        skin.drag = { type: 'scale', cx: c2.x, cy: c2.y, d0: Math.max(8, Math.hypot(ev.clientX - c2.x, ev.clientY - c2.y)), ppc0: m.ppc };
        el.skinWrap.classList.add('is-dragging');
        return;
      }
      skin.drag = insideSheet(ev) ? { type: 'move', dx: p.x - pl.x, dy: p.y - pl.y } : { type: 'pan', x: ev.clientX, y: ev.clientY, px: skin.view.panX, py: skin.view.panY };
      // a tap on the tattoo selects it, a tap beside it lets it go (see paintSkin)
      clearTimeout(skin.idleT); skin.moved = false; skin.active = skin.drag.type === 'move'; el.skinUi.classList.toggle('is-active', skin.active); markSkinDirty(false);
      el.skinWrap.classList.add('is-dragging');
    });
    el.skinWrap.addEventListener('pointermove', function (ev) {
      if (!pts[ev.pointerId]) return;
      pts[ev.pointerId] = { x: ev.clientX, y: ev.clientY };
      var m = currentMockup(); if (!m) return;
      var ids = Object.keys(pts);
      if (pinch && ids.length === 2) {
        var a = pts[ids[0]], b = pts[ids[1]], f = Math.hypot(a.x - b.x, a.y - b.y) / pinch.d;
        if (pinch.scale) m.ppc = clamp(pinch.ppc * f, 2, 400);
        else zoomSkin(clamp(pinch.zoom * f, 1, 6));
        // twisting two fingers turns the tattoo (starts after a small dead zone)
        var dAng = (Math.atan2(b.y - a.y, b.x - a.x) - pinch.ang) * 180 / Math.PI;
        if (dAng > 180) dAng -= 360; if (dAng < -180) dAng += 360;
        if (pinch.turning || Math.abs(dAng) > 10) { pinch.turning = true; placement(m).rot = normRot(pinch.rot + dAng); }
        markSkinDirty(false); return;
      }
      if (!skin.drag) return;
      if (skin.drag.type === 'rot') {
        var d = skin.drag, ang = (Math.atan2(ev.clientY - d.cy, ev.clientX - d.cx) - d.a0) * 180 / Math.PI;
        placement(m).rot = normRot(d.r0 + ang); skin.moved = true;
      } else if (skin.drag.type === 'scale') {
        m.ppc = clamp(skin.drag.ppc0 * Math.hypot(ev.clientX - skin.drag.cx, ev.clientY - skin.drag.cy) / skin.drag.d0, 2, 400);
      } else if (skin.drag.type === 'move') {
        skin.moved = true;
        var p = toPhoto(m, ev.clientX, ev.clientY), pl = placement(m);
        pl.x = clamp(p.x - skin.drag.dx, 0, m.w); pl.y = clamp(p.y - skin.drag.dy, 0, m.h);
      } else if (skin.view.zoom > 1) {
        skin.view.panX = skin.drag.px + ev.clientX - skin.drag.x; skin.view.panY = skin.drag.py + ev.clientY - skin.drag.y;
      }
      markSkinDirty(false);
    });
    function end(ev) {
      if (!pts[ev.pointerId]) return;
      delete pts[ev.pointerId];
      var m = currentMockup();
      if (m && m.own && (pinch && pinch.scale || skin.drag && skin.drag.type === 'scale')) saveOwn();
      if (Object.keys(pts).length < 2) pinch = null;
      // let go after moving / turning: at once only the arm with the hugging tattoo is left (owner 20.10.2026); a plain tap
      // keeps the tattoo selected (whole design + rotate handle) until a tap beside it
      if (!Object.keys(pts).length && skin.active) { clearTimeout(skin.idleT); if (skin.moved) { skin.active = false; el.skinUi.classList.remove('is-active'); markSkinDirty(false); } }
      if (!Object.keys(pts).length) { var was = skin.drag; skin.drag = null; el.skinWrap.classList.remove('is-dragging', 'is-rotating'); if (was) markSkinDirty(false); autosave(); }
    }
    el.skinWrap.addEventListener('pointerup', end);
    el.skinWrap.addEventListener('pointercancel', end);
    // plain wheel scrolls the page; zoom only with ctrl/⌘ (trackpad pinch)
    el.skinWrap.addEventListener('wheel', function (ev) {
      if (!ev.ctrlKey && !ev.metaKey) return;
      ev.preventDefault(); zoomSkin(clamp(skin.view.zoom * (ev.deltaY < 0 ? 1.08 : 1 / 1.08), 1, 6)); markSkinDirty(false);
    }, { passive: false });
  })();

  /* snapshot of the skin view for confirm / cart / dashboard. If the customer never opened the skin
     view, focus on the tattoo so small sizes are visible; otherwise reproduce what they last saw.
     forUpload: never the customer's own body photo (it stays in the browser) – then a studio mockup. */
  function skinSnapshot(maxW, forUpload) {
    if (state.handPreview && state.handPreview.at === hIndex) {
      return loadImage(state.handPreview.url).then(function (img) {
        var k = Math.min(1, (maxW || 1000) / img.naturalWidth);
        var c = document.createElement('canvas'); c.width = Math.round(img.naturalWidth * k); c.height = Math.round(img.naturalHeight * k);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        return c;
      });
    }
    var m = currentMockup(!!forUpload); if (!m || !fc.getObjects().length) return Promise.resolve(null);
    var seen = state.skinVisited && !(forUpload && state.ownActive);
    return Promise.all([waitReady(getPhoto(m)), waitReady(getMask(m)), designInk(m)]).then(function (res) {
      var ink = res[2];
      var cw = seen && skin.cw ? skin.cw : 600, ch = seen && skin.ch ? skin.ch : 800;
      var sv = { zoom: skin.view.zoom, panX: skin.view.panX, panY: skin.view.panY };
      if (!seen) {
        var sz = curSize(), s0 = Math.min(cw / m.w, ch / m.h);
        var tattooPx = Math.max(sz.w, sz.h) * m.ppc * s0;
        var z = clamp((ch * 0.42) / tattooPx, 1, 5);
        var pl = placement(m), sc = s0 * z;
        sv = { zoom: z, panX: (cw / 2 - pl.x * sc) - (cw - m.w * sc) / 2, panY: (ch / 2 - pl.y * sc) - (ch - m.h * sc) / 2 };
      }
      var k = Math.min(2, (maxW || 1000) / cw);
      var c = document.createElement('canvas'); c.width = Math.round(cw * k); c.height = Math.round(ch * k);
      paintSkin(c.getContext('2d'), m, ink, cw, ch, k, sv, false);
      // keep only the photo (the stage around a portrait photo is empty)
      var v = viewTransform(m, cw, ch, sv);
      var x0 = Math.max(0, v.ox), y0 = Math.max(0, v.oy), x1 = Math.min(cw, v.ox + m.w * v.s), y1 = Math.min(ch, v.oy + m.h * v.s);
      if (x1 - x0 < 20 || y1 - y0 < 20) return c;
      var out = document.createElement('canvas'); out.width = Math.round((x1 - x0) * k); out.height = Math.round((y1 - y0) * k);
      out.getContext('2d').drawImage(c, Math.round(x0 * k), Math.round(y0 * k), out.width, out.height, 0, 0, out.width, out.height);
      return out;
    });
  }
  function waitReady(p) { return new Promise(function (res, rej) { var n = 0; (function chk() { if (p.ready) res(); else if (++n > 200) rej(new Error('timeout')); else setTimeout(chk, 50); })(); }); }

  /* ---------- gender picker ---------- */
  function openGender(then) {
    var f = MOCK.list.filter(function (m) { return m.id === 'f-full'; })[0], mm = MOCK.list.filter(function (m) { return m.id === 'm-full'; })[0];
    var m = openModal(
      '<h2>' + t('gender_title_html') + '</h2><p>' + esc(t('gender_text')) + '</p>' +
      '<div class="czs-gender">' +
      '<button type="button" data-g="f"><img src="' + esc(f && f.thumb) + '" alt=""><span>' + esc(t('gender_f')) + '</span></button>' +
      '<button type="button" data-g="m"><img src="' + esc(mm && mm.thumb) + '" alt=""><span>' + esc(t('gender_m')) + '</span></button>' +
      '</div>', { locked: true, scoped: true });
    m.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-g]'); if (!b) return;
      setGender(b.getAttribute('data-g'));
      closeModal();
      if (then) then();
    });
  }

  /* ---------- onboarding (interactive guide; page scrolling is locked meanwhile) ---------- */
  var onb = null;
  /* tour + upload hint dim only the studio itself, never the landing content below it: the fixed overlay is clipped to
     the part of the screen the studio covers (clip-path also lets clicks outside it through) */
  function clipToRoot(el) {
    if (!el) return;
    var rb = root.getBoundingClientRect();
    el.style.clipPath = 'inset(' + Math.max(0, Math.round(rb.top)) + 'px 0 ' + Math.max(0, Math.round(window.innerHeight - rb.bottom)) + 'px 0)';
  }
  function clipScoped() { if (modalEl && modalEl.__scoped) clipToRoot(modalEl); }
  window.addEventListener('scroll', clipScoped, { passive: true });
  window.addEventListener('resize', clipScoped);
  /* steps follow the current layout: desktop has the size strip, the quantity list and the cart button in
     the side panel; phones have size + cart button in the bottom bar and pick the quantity in the confirm step */
  function unionRect(nodes) {
    var r = null;
    nodes.forEach(function (n) { var b = n.getBoundingClientRect(); if (!b.width) return; r = r ? { left: Math.min(r.left, b.left), top: Math.min(r.top, b.top), right: Math.max(r.right, b.right), bottom: Math.max(r.bottom, b.bottom) } : { left: b.left, top: b.top, right: b.right, bottom: b.bottom }; });
    if (r) { r.right = Math.min(r.right, window.innerWidth - 8); r.width = r.right - r.left; r.height = r.bottom - r.top; }
    return r;
  }
  function toDesign() { if (state.mode !== 'design') setMode('design'); }
  var ONB = [
    { key: 'onb_1', target: function () { return isMobile() ? $('.czs-sizebar') : unionRect($$('.czs-size')); }, wait: 'size', before: toDesign },
    { key: 'onb_2', target: function () { return el.tools; }, wait: 'content', before: toDesign },
    { key: 'onb_3', target: function () { return $('.czs-mode'); }, wait: 'skin', before: toDesign },
    { key: 'onb_4', target: function () { return isMobile() ? $('.czs-skinbar__row') : el.spots; }, wait: 'spot', before: function () { if (state.mode !== 'skin') setMode('skin'); } },
    { key: 'onb_5', only: 'desk', target: function () { return el.qty; }, wait: 'qty', before: toDesign },
    { key: 'onb_6', mobKey: 'onb_6m', target: function () { return isMobile() ? $('.czs-buybar .czs-cta') : $('.czs-summary .czs-cta'); }, wait: null, before: toDesign },
    { key: 'onb_7', target: function () { return $('.czs-cartbtn'); }, wait: null }
  ];
  function startOnboarding(force) {
    if (!force && store('onb-done') === '1') return;
    hideNudge();
    closeTool(); closeModal();
    window.scrollTo(0, 0);
    lockScroll('onb', true);
    onb = { i: 0, steps: ONB.filter(function (st) { return !st.only || st.only === (isMobile() ? 'mob' : 'desk'); }) };
    onb.el = document.createElement('div');
    onb.el.className = 'czs-onb';
    onb.el.innerHTML = '<div class="czs-onb__hole"></div><div class="czs-onb__card" role="dialog" aria-live="polite"><p></p><div class="czs-onb__foot"><div class="czs-onb__dots"></div><div class="czs-row"><button type="button" class="czs-onb__skip">' + esc(t('onb_skip')) + '</button><button type="button" class="czs-btn czs-btn--accent" data-onb-next>' + esc(t('onb_next')) + '</button></div></div></div>';
    root.appendChild(onb.el);
    onb.el.querySelector('.czs-onb__skip').addEventListener('click', endOnboarding);
    onb.el.querySelector('[data-onb-next]').addEventListener('click', function () { nextOnb(); });
    // block wheel / touch scrolling of the page while the guide is open
    onb.block = function (ev) { if (!ev.target.closest || !ev.target.closest('.czs-onb__card')) ev.preventDefault(); };
    window.addEventListener('wheel', onb.block, { passive: false });
    window.addEventListener('touchmove', onb.block, { passive: false });
    // page moved away from the studio anyway (anchor, keyboard): the tour ends like "skip" instead of covering the page
    onb.leave = function () { if (!onb) return; clipToRoot(onb.el); if (root.getBoundingClientRect().bottom < window.innerHeight * 0.5) endOnboarding(); };
    window.addEventListener('scroll', onb.leave, { passive: true });
    showOnb();
  }
  function showOnb() {
    if (!onb) return;
    var step = onb.steps[onb.i];
    if (step.before) step.before();
    setTimeout(function () {
      if (!onb) return;
      var tgt = step.target();
      var card = onb.el.querySelector('.czs-onb__card'), hole = onb.el.querySelector('.czs-onb__hole');
      clipToRoot(onb.el);
      card.querySelector('p').textContent = t(isMobile() && step.mobKey ? step.mobKey : step.key);
      onb.el.querySelector('.czs-onb__dots').innerHTML = onb.steps.map(function (_, i) { return '<i class="' + (i === onb.i ? 'is-on' : '') + '"></i>'; }).join('');
      onb.el.querySelector('[data-onb-next]').textContent = onb.i === onb.steps.length - 1 ? t('onb_done') : t('onb_next');
      if (!tgt) return;
      var r = tgt.getBoundingClientRect ? tgt.getBoundingClientRect() : tgt, pad = 6;
      hole.style.left = (r.left - pad) + 'px'; hole.style.top = (r.top - pad) + 'px';
      hole.style.width = (r.width + pad * 2) + 'px'; hole.style.height = (r.height + pad * 2) + 'px';
      var cw = card.offsetWidth || 300, chh = card.offsetHeight || 140;
      // a bar over the bottom (cookie banner, preview bar) hides the screen below the studio: the card stays above it
      var vb = window.innerHeight - Math.max(0, inset);
      var below = r.bottom + 18, above = r.top - chh - 18;
      var top = below + chh < vb - 8 ? below : (above > 8 ? above : Math.max(8, vb / 2 - chh / 2));
      var left = clamp(r.left + r.width / 2 - cw / 2, 12, window.innerWidth - cw - 12);
      if (r.width < 140 && r.height > 200 && !isMobile()) { left = Math.min(r.right + 18, window.innerWidth - cw - 12); top = clamp(r.top + 20, 8, vb - chh - 8); }
      card.style.left = left + 'px'; card.style.top = top + 'px';
    }, step.before ? 160 : 0);
  }
  function nextOnb() {
    if (!onb) return;
    if (onb.i >= onb.steps.length - 1) { endOnboarding(); return; }
    onb.i++; showOnb();
  }
  function onbEvent(name) { if (name === 'content') hideNudge(); if (onb && onb.steps[onb.i].wait === name) setTimeout(nextOnb, 350); }
  function endOnboarding() {
    store('onb-done', '1');
    if (onb) {
      window.removeEventListener('wheel', onb.block);
      window.removeEventListener('touchmove', onb.block);
      window.removeEventListener('scroll', onb.leave);
      if (onb.el) onb.el.remove();
    }
    onb = null;
    lockScroll('onb', false);
    if (state.mode !== 'design') setMode('design');
    // right after the tour: keep the screen dimmed and point at the upload button until the first
    // upload or any tap / click (nothing is blocked, the tap itself still works)
    if (!fc.getObjects().length) setTimeout(showNudge, 260);
  }
  window.addEventListener('resize', function () { if (onb) showOnb(); });

  var nudge = null;
  function showNudge() {
    if (onb || modalEl || state.mode !== 'design' || fc.getObjects().length) return;
    hideNudge();
    nudge = { el: document.createElement('div') };
    nudge.el.className = 'czs-nudge';
    nudge.el.setAttribute('role', 'status');
    nudge.el.innerHTML = '<div class="czs-onb__hole"></div><div class="czs-onb__card czs-nudge__card"><p>' + ICON.upload + '<span>' + esc(t('onb_nudge')) + '</span></p></div>';
    root.appendChild(nudge.el);
    nudge.off = function () { hideNudge(); };
    nudge.key = function (ev) { if (ev.key === 'Escape' || ev.key === 'Tab') hideNudge(); };
    nudge.pos = function () { placeNudge(); };
    document.addEventListener('pointerdown', nudge.off, true);
    document.addEventListener('keydown', nudge.key, true);
    window.addEventListener('resize', nudge.pos);
    window.addEventListener('scroll', nudge.pos, { passive: true });
    placeNudge();
    // follow late layout shifts (bars of other apps, fonts): re-place when the button moves
    (function follow() { if (!nudge) return; var r = $('.czs-tool--upload').getBoundingClientRect(), k = Math.round(r.left) + ',' + Math.round(r.top) + ',' + Math.round(r.width); if (k !== nudge.last) { nudge.last = k; placeNudge(); } nudge.raf = requestAnimationFrame(follow); })();
  }
  function placeNudge() {
    if (!nudge) return;
    var tgt = $('.czs-tool--upload'); if (!tgt) { hideNudge(); return; }
    clipToRoot(nudge.el);
    var hole = nudge.el.querySelector('.czs-onb__hole'), card = nudge.el.querySelector('.czs-nudge__card');
    var r = tgt.getBoundingClientRect(), pad = 6;
    hole.style.left = (r.left - pad) + 'px'; hole.style.top = (r.top - pad) + 'px';
    hole.style.width = (r.width + pad * 2) + 'px'; hole.style.height = (r.height + pad * 2) + 'px';
    var cw = card.offsetWidth || 260, chh = card.offsetHeight || 60, vw = window.innerWidth, vh = window.innerHeight, left, top;
    if (r.right + 22 + cw < vw - 8 && !isMobile()) { left = r.right + 22; top = clamp(r.top + r.height / 2 - chh / 2, 8, vh - chh - 8); card.setAttribute('data-side', 'right'); }
    else if (r.top - chh - 22 > 8) { left = clamp(r.left + r.width / 2 - cw / 2, 12, vw - cw - 12); top = r.top - chh - 22; card.setAttribute('data-side', 'top'); }
    else { left = clamp(r.left + r.width / 2 - cw / 2, 12, vw - cw - 12); top = Math.min(r.bottom + 22, vh - chh - 8); card.setAttribute('data-side', 'bottom'); }
    card.style.left = left + 'px'; card.style.top = top + 'px';
    // the little arrow points at the button
    card.style.setProperty('--ax', clamp(r.left + r.width / 2 - left, 18, cw - 18) + 'px');
  }
  function hideNudge() {
    if (!nudge) return;
    document.removeEventListener('pointerdown', nudge.off, true);
    document.removeEventListener('keydown', nudge.key, true);
    window.removeEventListener('resize', nudge.pos);
    window.removeEventListener('scroll', nudge.pos);
    cancelAnimationFrame(nudge.raf);
    nudge.el.remove();
    nudge = null;
  }

  /* ---------- export: print file (300 DPI PNG), preview ---------- */
  function renderDesignCanvas(ppc, background) {
    var w = Math.round(curSize().w * ppc), h = Math.round(curSize().h * ppc);
    return renderOff(w, background).then(function (c) {
      if (c.width === w && c.height === h) return c;
      var r = document.createElement('canvas'); r.width = w; r.height = h; r.getContext('2d').drawImage(c, 0, 0, w, h); return r;
    });
  }
  function canvasBlob(c, type, q) { return new Promise(function (res) { c.toBlob(function (b) { res(b); }, type, q); }); }
  var CRC = (function () { var tb = []; for (var n = 0; n < 256; n++) { var c = n; for (var k = 0; k < 8; k++) c = c & 1 ? 0xEDB88320 ^ (c >>> 1) : c >>> 1; tb[n] = c >>> 0; } return tb; })();
  function crc32(bytes) { var c = 0xFFFFFFFF; for (var i = 0; i < bytes.length; i++) c = CRC[(c ^ bytes[i]) & 0xFF] ^ (c >>> 8); return (c ^ 0xFFFFFFFF) >>> 0; }
  /* PNG with a pHYs chunk so print tools read 300 DPI */
  function withDpi(blob, dpi) {
    return blob.arrayBuffer().then(function (buf) {
      var src = new Uint8Array(buf);
      var ppm = Math.round(dpi / 0.0254);
      var chunk = new Uint8Array(21);
      var dv = new DataView(chunk.buffer);
      dv.setUint32(0, 9);
      chunk.set([0x70, 0x48, 0x59, 0x73], 4);
      dv.setUint32(8, ppm); dv.setUint32(12, ppm); chunk[16] = 1;
      dv.setUint32(17, crc32(chunk.subarray(4, 17)));
      var at = 8 + 25;
      var out = new Uint8Array(src.length + 21);
      out.set(src.subarray(0, at), 0); out.set(chunk, at); out.set(src.subarray(at), at + 21);
      return new Blob([out], { type: 'image/png' });
    });
  }
  /* the print file holds ink only. The customer designs on a white sheet, and removed photo backgrounds
     leave soft pixels that still carry the light paper tone (half-transparent light grey). On white they
     look right, but the print shop and any viewer without a white background see a grey haze, light halos
     around lines and washed-out shading. Every pixel is therefore un-mixed from white (colour-to-alpha
     against white): over white the file looks exactly like the design, white turns into transparency and
     every visible pixel keeps its true ink tone. Done in strips to keep the memory low on phones. */
  function inkOnly(c) {
    var x = c.getContext('2d', { willReadFrequently: true }), W = c.width, H = c.height, STRIP = 256;
    for (var y = 0; y < H; y += STRIP) {
      var h = Math.min(STRIP, H - y), d = x.getImageData(0, y, W, h), p = d.data;
      for (var i = 0; i < p.length; i += 4) {
        var a = p[i + 3];
        if (!a) continue;
        var k = a / 255;
        // the pixel as it looks on the white sheet
        var r = 255 - (255 - p[i]) * k, g = 255 - (255 - p[i + 1]) * k, b = 255 - (255 - p[i + 2]) * k;
        var A = Math.max(255 - r, 255 - g, 255 - b) / 255;
        if (A < 0.5 / 255) { p[i] = p[i + 1] = p[i + 2] = p[i + 3] = 0; continue; }
        p[i] = Math.round(255 - (255 - r) / A); p[i + 1] = Math.round(255 - (255 - g) / A); p[i + 2] = Math.round(255 - (255 - b) / A);
        p[i + 3] = Math.round(A * 255);
      }
      x.putImageData(d, 0, y);
    }
    return c;
  }
  function exportPrint() {
    return renderDesignCanvas(PRINT_PPC, null).then(function (c) { return canvasBlob(inkOnly(c), 'image/png'); }).then(function (b) { return withDpi(b, 300); });
  }

  /* ---------- checkout ---------- */
  function designSummary() {
    var texts = [], fonts = [], inspo = [];
    fc.getObjects().forEach(function (o) {
      if (o.czKind === 'text') { texts.push(o.text); if (fonts.indexOf(o.czFont) < 0) fonts.push(o.czFont); }
      if (o.czKind === 'inspo' && imgs[o.czId] && imgs[o.czId].inspo && inspo.indexOf(imgs[o.czId].inspo) < 0) inspo.push(imgs[o.czId].inspo);
    });
    var elements = fc.getObjects().map(elementData);
    return { texts: texts, fonts: fonts, inspo: inspo, elements: elements };
  }
  /* production data of one element (dashboard + ZIP): what it is, where it comes from, where it sits on
     the sheet (cm, from the sheet's top left corner) and, for texts, text + font + size */
  var MOTIF_BY_ID = null;
  function motifById(id) {
    if (!MOTIF_BY_ID) {
      MOTIF_BY_ID = {};
      INSPO_BASE.items.concat(HAND_SRC.items, SLEEVE_SRC.items).forEach(function (it) { if (it && it.id && !MOTIF_BY_ID[it.id]) MOTIF_BY_ID[it.id] = it; });
    }
    return MOTIF_BY_ID[id] || null;
  }
  function absUrl(u) { if (!u || /^data:|^blob:/.test(u)) return null; try { return new URL(u, location.href).href; } catch (e) { return null; } }
  function cm2(v) { return Math.round(v / LOGICAL * 100) / 100; }
  function elementData(o, i) {
    var im = imgs[o.czId] || {}, c = o.getCenterPoint(), pts = o.getCoords();
    var xs = pts.map(function (p) { return p.x; }), ys = pts.map(function (p) { return p.y; });
    var x0 = Math.min.apply(null, xs), y0 = Math.min.apply(null, ys);
    var e = {
      kind: o.czKind || 'element', z: i,
      w: cm2(o.getScaledWidth()), h: cm2(o.getScaledHeight()), angle: Math.round(o.angle || 0), flip: !!o.flipX,
      x: cm2(c.x), y: cm2(c.y),
      box: [cm2(x0), cm2(y0), cm2(Math.max.apply(null, xs) - x0), cm2(Math.max.apply(null, ys) - y0)]
    };
    if (o.czKind === 'text') {
      var fsCm = o.fontSize * (o.scaleY || 1) / LOGICAL;
      e.text = String(o.text || '');
      e.name = e.text.slice(0, 60);
      e.font = o.czFont || o.fontFamily; e.fontFamily = o.fontFamily; e.fontWeight = o.fontWeight; e.fontStyle = o.fontStyle;
      e.fontSizeCm = Math.round(fsCm * 100) / 100; e.fontSizePt = Math.round(fsCm / 2.54 * 72 * 10) / 10;
      e.color = o.fill; e.align = o.textAlign; e.spacing = o.charSpacing || 0;
    } else if (o.czKind === 'upload') {
      e.kind = im.ai ? 'ai' : 'upload';
      e.name = im.name || (im.ai ? 'ki-design' : 'upload');
      e.src = im.srcUrl || null;
      if (im.ai) { e.prompt = im.prompt || null; e.aiUrl = absUrl(im.aiUrl); }
      e.bgRemoved = !!o.czBg;
      if (im.srcW) { e.srcPx = [im.srcW, im.srcH]; e.dpi = Math.round(im.srcW / (e.w / 2.54)); }
    } else if (o.czKind === 'inspo') {
      var it = motifById(im.inspo) || {};
      e.id = im.inspo || null;
      e.kind = /^stamp-/.test(e.id || '') ? 'stamp' : (/sigil/.test(e.id || '') || /sigil/.test(it.cat || '')) ? 'sigil' : 'motif';
      e.name = it.de || it.en || e.id; e.nameEn = it.en || null;
      e.src = absUrl(it.src); e.vec = absUrl(it.vec || im.vec);
    } else if (o.czKind === 'draw') {
      e.name = 'draw';
    }
    if (im.via) e.builder = im.via;
    return e;
  }
  /* cart step (owner 20.10.2026): everything on one screen – small previews next to the summary (tap = large),
     the quantity as tiles with the price per tattoo, total + button in a fixed bar at the bottom, the delivery and
     trust lines + payment icons small below the button */
  function coTiles(s, v) {
    var base = s.variants[0].price / s.variants[0].qty;
    return s.variants.map(function (x) {
      var per = Math.round(x.price / x.qty);
      var save = Math.round((1 - per / base) * 100);
      return '<li><button type="button" class="czs-co__tile" data-qty="' + x.qty + '" aria-pressed="' + (x.qty === v.qty) + '"' + (x.available === false ? ' disabled' : '') +
        ' aria-label="' + esc(t('qty_tattoos', { count: x.qty }) + ' · ' + t('qty_per', { price: formatMoney(per) })) + '">' +
        '<b>' + x.qty + '</b><span>' + formatMoney(per) + '</span>' + (save > 0 ? '<i>' + esc(t('qty_save', { percent: save })) + '</i>' : '') + '</button></li>';
    }).join('');
  }
  function coCalc(v) { return v.qty + ' × ' + formatMoney(Math.round(v.price / v.qty)); }
  function coInfoHtml() {
    return '<div class="czs-co__info"><p>' + ICON.truck + '<span>' + esc(deliveryLine()) + '</span></p>' + coTrustHtml() + '</div>';
  }
  /* delivery time of the custom sizes: like the Sleeve Builder from the dashboard «Lieferzeiten» (shop metafield
     tattup.delivery, custom line, see cz-studio.liquid); the locale texts («ca. 4 Wochen») only when it is missing */
  function deliveryLine() {
    if (!DATA.delivery) return t('delivery');
    var d = DATA.delivery.replace(/[.\s]+$/, '');
    if (!/^de/.test(DATA.locale || '')) d = d.charAt(0).toLowerCase() + d.slice(1);   // «Made for you – delivery in …»
    return t('delivery_made') + ' – ' + d + '.';
  }
  function deliveryValue() {
    // «Lieferung in ca. 4 Wochen» → «ca. 4 Wochen» for the cart line «Lieferzeit: …»
    var v = DATA.delivery ? DATA.delivery.replace(/^\s*(lieferung|lieferzeit|delivery(\s+time)?)\s*(in|:)?\s*/i, '').replace(/[.\s]+$/, '') : '';
    return v || t('delivery_prop_value');
  }
  // «Sicher bezahlen · Von Hand geprüft» + the shop's payment icons (also under the Sleeve Builder's «Alles bereit?»)
  function coTrustHtml() {
    var tpl = document.getElementById('czs-payments');
    return '<p><span>' + ICON.lock + esc(t('trust_pay')) + '</span><span>' + ICON.check + esc(t('trust_check')) + '</span></p>' +
      (tpl ? '<div class="czs-pay czs-co__pay">' + tpl.innerHTML + '</div>' : '');
  }
  function startCheckout() {
    if (state.busy) return;
    if (!fc.getObjects().length) { toast(t('empty_design'), true); setMode('design'); return; }
    var sz = curSize(), v = curVariant();
    var zoom = esc(t('confirm_zoom'));
    var m = openModal(
      '<div class="czs-co__head"><h2>' + t('confirm_title_html') + '</h2><p>' + esc(t('confirm_text')) + '</p></div>' +
      '<div class="czs-co__body">' +
        '<div class="czs-co__sum">' +
          '<div class="czs-co__prev">' +
            '<figure class="czs-co__sheet"><button type="button" class="czs-co__well" data-zoom aria-label="' + zoom + '"><span class="czs-confirm__frame" data-prev><span class="czs-spinner"></span></span><i class="czs-co__zoom">' + ICON.expand + '</i></button><figcaption>' + esc(t('confirm_canvas', { size: sizeLabel(sz, true) })) + '</figcaption></figure>' +
            '<figure class="czs-co__skin"><button type="button" class="czs-co__photo" data-zoom aria-label="' + zoom + '"><span data-skin><span class="czs-spinner"></span></span><i class="czs-co__zoom">' + ICON.expand + '</i></button><figcaption>' + esc(t('confirm_skin')) + '</figcaption></figure>' +
          '</div>' +
          '<dl class="czs-co__facts"><dt>' + esc(t('confirm_size')) + '</dt><dd>' + esc(sizeLabel(sz, true)) + '</dd>' +
          '<dt class="czs-co__ph">' + esc(t('confirm_price')) + '</dt><dd class="czs-co__ph czs-co__price" data-cprice>' + formatMoney(v.price) + '</dd></dl>' +
          '<button type="button" class="czs-co__edit" data-back>' + ICON.edit + '<span>' + esc(t('confirm_back')) + '</span></button>' +
        '</div>' +
        '<div class="czs-co__qty"><div class="czs-co__qhead"><p class="czs-h">' + esc(t('qty_title')) + '</p><span>' + esc(t('confirm_per')) + '</span></div>' +
          '<ul class="czs-co__tiles">' + coTiles(sz, v) + '</ul><p class="czs-why">' + esc(t('qty_why')) + '</p></div>' +
      '</div>' +
      '<div class="czs-co__foot">' +
        '<div class="czs-co__buy"><div class="czs-co__total"><small>' + esc(t('total')) + '</small><b data-cprice>' + formatMoney(v.price) + '</b><span data-ccalc>' + coCalc(v) + '</span></div>' +
          '<button type="button" class="czs-btn czs-co__back" data-back>' + esc(t('confirm_back')) + '</button>' +
          '<button type="button" class="czs-cta czs-co__go" data-go>' + esc(state.editing ? t('cart_update') : t('confirm_go')) + '</button></div>' +
        coInfoHtml() +
      '</div>' +
      '<div class="czs-co__lb" data-lb hidden></div>',
      { wide: true, cls: 'czs-modal--co' });
    // the sheet in its real proportions; the skin view exactly as set up (or a focused default)
    var frame = $('[data-prev]', m);
    frame.style.aspectRatio = sz.w + ' / ' + sz.h;
    renderDesignCanvas(Math.min(60, 900 / Math.max(sz.w, sz.h)), '#ffffff').then(function (c) {
      frame.innerHTML = '<img src="' + c.toDataURL('image/png') + '" alt="">';
    });
    function noSkin() { var fig = $('[data-skin]', m); if (fig) fig.closest('figure').hidden = true; }
    skinSnapshot(900).then(function (c) {
      var fig = $('[data-skin]', m); if (!fig) return;
      if (c) fig.innerHTML = '<img src="' + c.toDataURL('image/jpeg', 0.88) + '" alt="">'; else noSkin();
    }).catch(noSkin);
    $$('[data-back]', m).forEach(function (b) { b.addEventListener('click', closeModal); });
    var lb = $('[data-lb]', m);
    m.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-zoom]')) {
        lb.innerHTML = $$('[data-prev] img, [data-skin] img', m).map(function (i) { return '<img src="' + i.src + '" alt="">'; }).join('') +
          '<button type="button" class="czs-ibtn" aria-label="' + esc(t('close')) + '">' + ICON.close + '</button>';
        if (lb.querySelector('img')) lb.hidden = false;
        return;
      }
      if (ev.target.closest('[data-lb]')) { lb.hidden = true; return; }
      var b = ev.target.closest('[data-qty]'); if (!b) return;
      setQty(+b.getAttribute('data-qty'));
      var nv = curVariant();
      $$('[data-qty]', m).forEach(function (x) { x.setAttribute('aria-pressed', +x.getAttribute('data-qty') === nv.qty ? 'true' : 'false'); });
      $$('[data-cprice]', m).forEach(function (x) { x.textContent = formatMoney(nv.price); });
      $('[data-ccalc]', m).textContent = coCalc(nv);
    });
    $('[data-go]', m).addEventListener('click', function () { addToCart(); });
    // keyboard: start on the chosen quantity (openModal would focus the first preview)
    if (!isTouch) setTimeout(function () { var q = $('.czs-co__tile[aria-pressed="true"]', m); if (q) q.focus(); }, 40);
  }
  function ctaLabel() { return t(state.editing ? 'cart_update' : 'cart'); }
  function setBusy(on) {
    state.busy = on;
    $$('[data-act="cart"]').forEach(function (b) { b.disabled = on; b.textContent = on ? t('cart_busy') : ctaLabel(); });
    var go = modalEl && modalEl.querySelector('[data-go]'); if (go) { go.disabled = on; go.textContent = on ? t('cart_busy') : (state.editing ? t('cart_update') : t('confirm_go')); }
  }
  /* everything needed to open a design again later (cart line "Edit"): stays in this browser */
  function designState() {
    var used = {};
    fc.getObjects().forEach(function (o) { var im = imgs[o.czId]; if (im) used[o.czId] = Object.assign({}, im); });
    return {
      v: 1, at: Date.now(), size: state.size, qty: state.qty, gender: state.gender, objects: snapshot(), imgs: used,
      place: JSON.parse(JSON.stringify(state.place)), spot: Object.assign({}, state.spot),
      handPreview: state.handPreview && state.handPreview.at === hIndex ? { url: state.handPreview.url, kind: state.handPreview.kind } : null,
      builder: pendingBuilder || null
    };
  }
  function applyDesignState(d) {
    imgs = {};
    Object.keys(d.imgs || {}).forEach(function (k) { imgs[k] = d.imgs[k]; });
    sizeBase = null;
    restoring = true; fc.discardActiveObject(); fc.remove.apply(fc, fc.getObjects()); restoring = false;
    if (d.size && sizeByCode(d.size)) setSize(d.size, true);
    if (d.qty) { state.qty = d.qty; qtyPick(String(d.qty)); }
    return restore(d.objects).then(function () {
      state.place = d.place || {}; state.spot = d.spot || {};
      history = [snapshot()]; hIndex = 0; syncHistoryButtons();
      state.handPreview = d.handPreview ? { url: d.handPreview.url, kind: d.handPreview.kind, at: hIndex } : null;
      renderQty(); updateEmpty(); markSkinDirty(true); autosave();
    });
  }
  function addToCart() {
    var sz = curSize(), v = curVariant();
    var designId = 'cz_' + uid();
    var summary = designSummary();
    var editing = state.editing;
    // the builder this design comes from (builder preview on the skin, or its elements) – builder statistics
    var built = state.handPreview && state.handPreview.at === hIndex ? (state.handPreview.kind || 'hand') : ((summary.elements || []).map(function (e) { return e.builder; }).filter(Boolean)[0] || null);
    var snap = designState(); // taken before the studio resets
    setBusy(true);
    var api = null; // upload client served by the studio API (Vercel), see ensureApi
    var files = {};
    var chain = Promise.resolve();
    /* no cart line without its print file (owner 28.10.2026): print, preview and skin image must be uploaded and the
       design saved first. Every upload is retried once on its own; if it still fails (network, ad blocker on the
       studio API, server error) nothing goes into the cart, the customer sees «Hochladen hat nicht geklappt» and
       the design stays as it is. */
    if (DATA.api) {
      chain = ensureApi().then(function (a) {
        if (!a) throw uploadError();
        api = a;
        return exportPrint();
      }).then(function (print) {
        return Promise.all([
          renderDesignCanvas(Math.min(60, 900 / Math.max(sz.w, sz.h)), '#ffffff').then(function (c) { return canvasBlob(c, 'image/png'); }),
          // never the customer's own body photo: the production mockup uses a studio photo
          skinSnapshot(1200, true).then(function (c) { return c ? canvasBlob(c, 'image/jpeg', 0.86) : null; }).catch(function () { return null; })
        ]).then(function (r) {
          var uploads = [['print', print, 'print.png'], ['preview', r[0], 'preview.png']];
          if (r[1]) uploads.push(['mockup', r[1], 'mockup.jpg']);
          return Promise.all(uploads.map(function (u) { return upload(api, designId, u[2], u[1]).then(function (url) { files[u[0]] = url; }); }));
        });
      }).then(function () {
        // originals: uploaded right after the customer added them (preupload, copied to this design by the
        // studio API); a file whose early upload is missing goes up now, into the design's own folder
        var ups = fc.getObjects().filter(function (o) { return o.czKind === 'upload' && imgs[o.czId]; }).map(function (o) { return o.czId; });
        return Promise.all(ups.map(preupload)).then(function () {
          var seen = [], n = 0;
          return Promise.all(ups.map(function (id) {
            var im = imgs[id];
            if (im.srcUrl || !im.file || seen.indexOf(im.file) > -1) return null;
            seen.push(im.file); var k = 'original_' + (++n);
            return upload(api, designId, 'original-' + n + '-' + (im.file.name || 'upload').replace(/[^\w.\-]+/g, '_'), im.file).then(function (url) {
              files[k] = url;
              Object.keys(imgs).forEach(function (j) { if (imgs[j].file === im.file) imgs[j].srcUrl = url; });
            });
          }));
        });
      }).then(function () {
        var m = currentMockup(true);
        summary = designSummary();   // again: now with the URLs of all originals
        if (!files.print || !files.preview) throw uploadError();
        return retryOnce(function () { return api.saveDesign({
          id: designId, size: sz.code, sizeCm: [sz.w, sz.h], productId: sz.productId, variantId: v.id, qty: v.qty,
          gender: state.gender, spot: m ? m.id : null, spotArea: m ? m.spot : null,
          // which skin view the mockup shows: a builder preview, the customer's last view or the default framing
          mockupFrom: state.handPreview && state.handPreview.at === hIndex ? (state.handPreview.kind || 'hand') : (state.skinVisited && !state.ownActive ? 'view' : 'default'),
          texts: summary.texts, fonts: summary.fonts, inspo: summary.inspo, elements: summary.elements,
          files: files, locale: DATA.locale, uploadConsentAt: store('upload-ok-at') || null,
          // logged-in customer e-mail (cz-studio.liquid), null for guests: dashboard tab «Nicht gekaufte Custom-Designs»
          customer: DATA.customer || null,
          // builder + where the visit came from (newsletter / ads / other): dashboard «Statistik › Builder»
          from: { b: built, s: VISIT.s, c: VISIT.c }
        }); }).catch(function () { throw uploadError(); });
      });
    }
    return chain.then(function () {
      // the edited line keeps its current quantity (it may have been changed in the drawer meanwhile)
      if (editing) return fetchCart().then(function (c) { var l = lineOf(c, editing.id); if (l) { editing.lineQty = l.quantity; if (l.properties && l.properties._ai_design_id) editing.aiId = l.properties._ai_design_id; } }).catch(function () {});
    }).then(function () {
      var props = {};
      props[t('delivery_prop')] = deliveryValue();
      // the theme's cart shows _customization_image as the line thumbnail
      if (files.preview || files.mockup) props._customization_image = files.preview || files.mockup;
      props._cz_design_id = designId;
      props._cz_source = 'tattup-studio';
      // AI generator design id (handoff) – an edited line keeps the one it had
      var aiId = store('ai-id') || (editing && editing.aiId);
      if (aiId) props._ai_design_id = aiId;
      if (files.print) props._cz_print = files.print;
      if (files.mockup) props._cz_mockup = files.mockup;
      if (summary.texts.length) props._cz_texts = summary.texts.join(' | ').slice(0, 250);
      return fetch(DATA.routes.cartAdd, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: editing ? Math.max(1, editing.lineQty || 1) : 1, properties: props }] })
      }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
    }).then(function () {
      // the design stays editable from the cart; updating replaces exactly the edited line
      return KV.set(CART_KEY + designId, snap).then(function () { if (editing) return removeCartDesign(editing.id); });
    }).then(function () {
      setBusy(false);
      closeModal();
      if (editing) KV.del(CART_KEY + editing.id);
      setEditing(null);
      resetDesign();
      showAdded(designId);
      refreshShopCart();
      if (built && !editing) trackBuilder('bd', built);
      return true;
    }).catch(function (err) {
      setBusy(false);
      var msg = t(err && err.czUpload ? 'upload_failed' : 'error_generic');
      // in the «Alles bereit?» window the message sits right above its buttons (a toast would cover them on phones)
      var foot = modalEl && modalEl.querySelector('.czs-co__foot');
      if (foot) {
        var p = foot.querySelector('.czs-co__err');
        if (!p) { p = document.createElement('p'); p.className = 'czs-co__err'; p.setAttribute('role', 'alert'); foot.insertBefore(p, foot.firstChild); }
        p.textContent = msg;
      } else toast(msg, true);
      return false;
    });
  }
  function uploadError() { var e = new Error('upload'); e.czUpload = true; return e; }
  function retryOnce(fn) {
    return fn().catch(function () { return new Promise(function (res) { setTimeout(res, 900); }).then(fn); });
  }
  function upload(a, id, name, blob) {
    return retryOnce(function () { return a.upload(id, name, blob).then(function (url) { if (!url) throw new Error('no url'); return url; }); })
      .catch(function () { throw uploadError(); });
  }
  /* the upload client (studio-client.js from the studio API): normally loaded with the page; if it is missing
     (slow or blocked request) it is loaded once more before giving up */
  var apiLoad = null;
  function ensureApi() {
    if (window.czsApi) return Promise.resolve(window.czsApi);
    if (!DATA.api) return Promise.resolve(null);
    if (apiLoad) return apiLoad;
    apiLoad = new Promise(function (res) {
      var s = document.createElement('script'), done = false;
      function fin() { if (done) return; done = true; clearTimeout(tm); res(window.czsApi || null); }
      var tm = setTimeout(fin, 12000);
      s.src = DATA.api.replace(/[/]$/, "") + "/studio-client.js?r=" + Date.now();
      s.async = true; s.onload = fin; s.onerror = fin;
      document.head.appendChild(s);
    }).then(function (a) { if (!a) apiLoad = null; return a; });
    return apiLoad;
  }
  /* fresh start for the next design: keeps size, model and quantity */
  function resetDesign() {
    restoring = true;
    fc.discardActiveObject();
    fc.remove.apply(fc, fc.getObjects());
    restoring = false;
    imgs = {};
    state.place = {};
    sizeBase = null;
    state.handPreview = null;
    skin.view = { zoom: 1, panX: 0, panY: 0 };
    clearDraft();
    store('ai-id', null);
    history = [snapshot()]; hIndex = 0; syncHistoryButtons();
    updateEmpty(); hideObjbar(); markSkinDirty(true);
    if (state.mode !== 'design') setMode('design');
    fc.requestRenderAll();
  }

  /* ---------- cart: the shop's own cart drawer (sections/cart-drawer.liquid, loaded by the studio layout) ---------- */
  function cartUrl(p) { var base = (DATA.routes && DATA.routes.cart) || '/cart'; return base + p; }
  function shopDrawer() { return document.querySelector('cart-drawer.js-cart-drawer, cart-drawer'); }
  function drawerOpen() { var d = shopDrawer(); return !!(d && d.hasAttribute('open')); }
  function openDrawer(opener) {
    var d = shopDrawer();
    if (d && typeof d.open === 'function') { if (!drawerOpen()) d.open(opener && opener.nodeType ? opener : null); }
    else location.href = cartUrl('');
  }
  function closeDrawer() { var d = shopDrawer(); if (d && drawerOpen() && typeof d.close === 'function') d.close(); }
  function refreshBadge(cart) {
    var n = cart ? cart.item_count : 0;
    el.badge.hidden = !n; el.badge.textContent = n > 99 ? '99+' : String(n);
    // the Sleeve Builder's cart button shows the same count
    Array.prototype.forEach.call(document.querySelectorAll('.czsl-cartbtn .czs-badge'), function (b) { b.hidden = !n; b.textContent = n > 99 ? '99+' : String(n); });
  }
  function fetchCart() { return fetch(cartUrl('.js'), { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }); }
  function lineOf(cart, id) { return (cart.items || []).filter(function (it) { return it.properties && it.properties._cz_design_id === id; })[0] || null; }
  function removeCartDesign(id) {
    return fetchCart().then(function (cart) {
      var line = lineOf(cart, id); if (!line) return;
      return fetch(cartUrl('/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.key, quantity: 0 }) });
    });
  }
  /* the drawer re-renders itself (cart-form listens to on:cart:change); then badge + stored designs follow */
  function refreshShopCart() {
    document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
    fetchCart().then(syncCart).catch(function () {});
  }
  var syncTimer;
  function syncCart(cart) {
    refreshBadge(cart);
    var ids = (cart.items || []).map(function (it) { return it.properties && it.properties._cz_design_id; }).filter(Boolean);
    // a line removed from the cart: its stored design goes too
    KV.keys().then(function (keys) {
      (keys || []).forEach(function (k) { if (typeof k === 'string' && k.indexOf(CART_KEY) === 0 && ids.indexOf(k.slice(CART_KEY.length)) < 0) KV.del(k); });
      markEditButtons(keys || []);
    });
    if (state.editing && ids.indexOf(state.editing.id) < 0) { setEditing(null); toast(t('edit_gone')); }
  }
  function scheduleSync() { clearTimeout(syncTimer); syncTimer = setTimeout(function () { fetchCart().then(syncCart).catch(function () {}); }, 250); }
  document.addEventListener('on:cart:after-merge', scheduleSync);
  document.addEventListener('on:cart-drawer:before-open', function () { KV.keys().then(markEditButtons); });
  /* "Edit" only where this browser still has the design */
  function markEditButtons(keys) {
    $$('[data-cz-edit]', document).forEach(function (a) { a.hidden = keys.indexOf(CART_KEY + a.getAttribute('data-cz-edit')) < 0; });
  }
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('[data-cz-edit]');
    if (a) { ev.preventDefault(); closeDrawer(); editCartDesign(a.getAttribute('data-cz-edit')); return; }
    /* image / title of a studio cart line (snippets/cart-item.liquid): same as "Edit" where this browser has the
       design; otherwise only that line's size (?size= in its link), like the plain link does on other pages */
    var o = ev.target.closest && ev.target.closest('[data-cz-open]'); if (!o) return;
    ev.preventDefault();
    closeDrawer();
    var id = o.getAttribute('data-cz-open');
    KV.get(CART_KEY + id).then(function (d) {
      if (d && d.objects) { editCartDesign(id); return; }
      var sz = null; try { sz = new URL(o.href, location.href).searchParams.get('size'); } catch (e) {}
      if (sz && sizeByCode(sz) && sz !== state.size) setSize(sz);
    });
  }, true);
  function setEditing(ed) {
    state.editing = ed;
    store('editing', ed ? JSON.stringify(ed) : null);
    root.classList.toggle('is-editing', !!ed);
    el.editing.hidden = !ed;
    if (!state.busy) setBusy(false);
  }
  function stopEditing(fresh) {
    setEditing(null);
    if (fresh) { resetDesign(); toast(t('edit_stopped')); }
  }
  /* open a cart line's design again: same size, quantity tier and layout; the cart button then
     replaces exactly that line */
  function editCartDesign(id) {
    stopPulse();
    return Promise.all([KV.get(CART_KEY + id), fetchCart()]).then(function (r) {
      var d = r[0], cart = r[1], line = lineOf(cart, id);
      if (!line) { toast(t('edit_gone'), true); return; }
      if (!d || !d.objects) { toast(t('edit_missing'), true); return; }
      SIZES.forEach(function (s) { s.variants.forEach(function (v) { if (v.id === line.variant_id) { d.size = s.code; d.qty = v.qty; } }); });
      // a sleeve from the Sleeve Builder opens in the builder again (button «Aktualisieren»)
      if (d.builder && d.builder.kind === 'sleeve' && DATA.sleeve && DATA.sleeve.js) { openSleeveBuilder({ edit: { id: id, lineQty: line.quantity, qty: d.qty, builder: d.builder } }); return; }
      function go() {
        if (state.tool) closeTool();
        if (state.mode !== 'design') setMode('design');
        applyDesignState(d).then(function () {
          setEditing({ id: id, lineQty: line.quantity });
          setSize(state.size, true); renderQty();
          toast(t('edit_loaded'));
        });
      }
      if (fc.getObjects().length && !(state.editing && state.editing.id === id)) {
        var m = openModal('<h2>' + esc(t('edit_replace_title')) + '</h2><p>' + esc(t('edit_replace_text')) + '</p><div class="czs-actions"><button type="button" class="czs-btn" data-x>' + esc(t('crop_cancel')) + '</button><button type="button" class="czs-btn czs-btn--accent" data-ok>' + esc(t('edit_replace_ok')) + '</button></div>');
        $('[data-ok]', m).addEventListener('click', function () { closeModal(); go(); });
      } else go();
    }).catch(function () { toast(t('error_generic'), true); });
  }

  /* after "add to cart": the studio is already fresh (upload in the spotlight once the cart closes); the
     shop's cart drawer opens with the new line, whose "Edit" button pulses until the customer acts */
  var pulseId = null, nudgeOnClose = false;
  function showAdded(id) {
    pulseId = id; nudgeOnClose = true;
    var done = false;
    function open() {
      if (done) return; done = true;
      document.removeEventListener('on:cart:after-merge', open);
      openDrawer($('.czs-cartbtn'));
      setTimeout(markPulse, 60);
    }
    document.addEventListener('on:cart:after-merge', open);
    setTimeout(open, 3500); // fallback if the drawer content arrives late
  }
  function markPulse() {
    var hit = null;
    $$('.cart-item__cz-edit', document).forEach(function (a) { var on = !!pulseId && a.getAttribute('data-cz-edit') === pulseId; a.classList.toggle('is-pulse', on); if (on) hit = a; });
    if (hit && hit.scrollIntoView) hit.scrollIntoView({ block: 'nearest' });
  }
  function stopPulse() { if (!pulseId) return; pulseId = null; markPulse(); }
  document.addEventListener('on:cart:after-merge', function () { if (pulseId) markPulse(); });
  document.addEventListener('pointerdown', function (ev) { if (pulseId && ev.target.closest && ev.target.closest('cart-drawer')) stopPulse(); }, true);
  document.addEventListener('on:cart-drawer:before-close', function () {
    stopPulse();
    if (nudgeOnClose) { nudgeOnClose = false; setTimeout(showNudge, 380); }
  });

  /* leave guard */
  window.addEventListener('beforeunload', function (ev) {
    if (!fc.getObjects().length) return;
    ev.preventDefault(); ev.returnValue = t('leave'); return t('leave');
  });

  /* ---------- Hand Tattoo Builder: separate module (assets/cz-hand.js), loaded on demand ---------- */
  var modLoading = {};
  function loadModule(cfg, globalName) {
    if (window[globalName]) return Promise.resolve(window[globalName]);
    if (modLoading[globalName]) return modLoading[globalName];
    modLoading[globalName] = new Promise(function (res, rej) {
      var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = cfg.css; document.head.appendChild(l);
      var sc = document.createElement('script'); sc.src = cfg.js;
      sc.onload = function () { res(window[globalName]); };
      sc.onerror = function () { modLoading[globalName] = null; rej(new Error(globalName)); };
      document.head.appendChild(sc);
    });
    return modLoading[globalName];
  }
  function loadHandModule() { return loadModule(DATA.hand, 'czHand'); }
  /* the Tattoo Builder button: short explanation and the choice of builder */
  function openBuilders() {
    var hasSleeve = !!(DATA.sleeve && DATA.sleeve.js);
    var card = function (act, icon, title, text, on) {
      return '<button type="button" class="czs-bcard" data-act="' + act + '"' + (on ? '' : ' disabled') + '><span class="czs-bcard__ic">' + icon + '</span><b>' + esc(title) + '</b><span>' + esc(text) + '</span><i>' + esc(t('builder_start')) + ' →</i></button>';
    };
    openModal('<h2>' + t('builder_title_html') + '</h2><p>' + esc(t('builder_intro')) + '</p><div class="czs-bcards">' +
      // order (owner 20.10.2026): hand & finger, sleeve, script
      card('hand', ICON.hand, t('builder_hand'), t('builder_hand_text'), true) +
      (hasSleeve ? card('sleeve', ICON.body, t('builder_sleeve'), t('builder_sleeve_text'), true) : '') +
      card('script', ICON.text, t('builder_script'), t('builder_script_text'), true) + '</div>', { wide: true });
  }
  var pendingBuilder = null; // Sleeve Builder state stored with the cart design (see api.cart)
  function sleeveLanding() { return ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'pages/sleeve-tattoo'; }
  function builderApi(data, kind, inspo) {
    return {
      F: F, root: root, t: t, esc: esc, icon: ICON, locale: DATA.locale, data: data, inspo: inspo || { categories: [], items: [] },
      mockups: MOCK.all, gender: state.gender || 'f', sizes: SIZES, sizeNames: SIZE_NAMES, fmtCm: fmtCm,
      prepareImage: prepareImage, toast: toast, isMobile: isMobile, lockScroll: lockScroll,
      hasDesign: function () { return fc.getObjects().length > 0; },
      apply: function (res) { res.kind = kind; applyHandSet(res); },
      ai: kind === 'sleeve' && aiUrl() ? aiForBuilder(kind) : null,
      model: MOCK.model || null, measureArm: MEASURE_ARM,
      // the Sleeve Builder's «Einpacken»: design into the studio, then straight to the checkout step (pieces, price, cart)
      checkout: function (res) { res.kind = kind; return applyHandSet(res).then(function () { startCheckout(); }); },
      money: formatMoney, qty: function () { return state.qty || DEFAULT_QTY; }, nearest: nearestVariant,
      // delivery line of the custom sizes (one central place: the delivery-date settings, see cz-studio.liquid)
      delivery: DATA.delivery || t('sleeve_eta_fallback'),
      // the sleeve landing: its FAQ, before / after, reviews and size parts are shown under the Sleeve Builder
      landing: sleeveLanding(),
      // «Kleiner starten» (owner 27.10.2026): leave the builder for the normal studio in that size (e.g. Huge = half sleeve)
      startSmall: function (code, qty, tour) { startInSize(code, qty, tour); },
      trustHtml: coTrustHtml,
      openCart: function (btn) { openDrawer(btn); }, refreshCart: function () { fetchCart().then(refreshBadge).catch(function () {}); },
      /* the Sleeve Builder's own summary: the design goes through the studio (print file, upload, cart line) without the
         customer ever seeing the studio; o = { qty, editId, lineQty, builder } */
      cart: function (res, o) {
        o = o || {};
        if (state.busy) return Promise.resolve(false);
        res.kind = kind; res.silent = true;
        if (o.editId) setEditing({ id: o.editId, lineQty: o.lineQty || 1 }); else if (state.editing) setEditing(null);
        return applyHandSet(res).then(function () {
          if (o.qty) setQty(o.qty);
          pendingBuilder = o.builder || null;
          return addToCart();
        }).then(function (ok) { pendingBuilder = null; nudgeOnClose = false; return ok; }, function () { pendingBuilder = null; return false; });
      }
    };
  }
  /* the free generations (same daily count as the studio panel) for a builder: kind tells the server which hidden rules
     to add (tattup-own-apps lib/freegen.js, 'sleeve' = full arm sleeve, tall portrait) */
  function aiForBuilder(kind) {
    var msg = function (e) { return e === 'busy' ? t('ai_busy') : e === 'ip_limit' || e === 'daily_limit' || e === 'session_limit' ? t('ai_daily') : e === 'blocked' ? t('ai_blocked') : e === 'prompt_long' ? t('ai_failed') : t('ai_failed'); };
    return {
      status: function () {
        if (AI.remaining === null) { var c = String(store('fg-left') || '').split('|'); if (c.length === 2 && c[0] === zurichDay() && c[1] !== '' && !isNaN(+c[1])) AI.remaining = +c[1]; }
        return { limit: AI.limit, remaining: AI.remaining === null ? AI.limit : AI.remaining };
      },
      lastGen: function () { return AI.lastGen || null; },
      refresh: function () { return aiFetch({ method: 'GET' }).then(function () { return { limit: AI.limit, remaining: AI.remaining === null ? AI.limit : AI.remaining }; }); },
      run: function (prompt) {
        if (AI.busy) return Promise.reject(new Error(t('ai_busy')));
        AI.busy = true; showAiWait();
        return aiFetch({ method: 'POST', body: JSON.stringify({ prompt: prompt, aspect: 'portrait', kind: kind, email: DATA.customer || undefined }) }).then(function (d) {
          AI.busy = false; hideAiWait();
          if (d.image) { AI.lastGen = d.genId || null; return d.image; } // genId = the kept generation (dashboard KI-Sleeves)
          var er = new Error(msg(d.error)); er.code = d.error || 'failed'; throw er;
        }, function () { AI.busy = false; hideAiWait(); var er = new Error(t('ai_failed')); er.code = 'failed'; throw er; });
      }
    };
  }
  function startInSize(code, qty, tour) {
    if (window.czSleeve) window.czSleeve.close();
    try { var u = new URL(location.href); u.searchParams.delete('builder'); u.searchParams.set('size', code); window.history.replaceState(null, '', u.pathname + u.search + u.hash); } catch (e) {}
    if (sizeByCode(code) && code !== state.size) setSize(code);
    if (qty && curSize().variants && curSize().variants.some(function (v) { return v.qty === qty; })) setQty(qty);
    try { root.scrollIntoView({ block: 'start' }); } catch (e) {}
    // round 2 (owner 27.10.2026): coming from the Sleeve Builder, the studio always shows its own guide
    if (tour) setTimeout(function () { startOnboarding(true); }, 200);
  }
  function openSleeveBuilder(o) {
    o = o && typeof o === 'object' ? o : {};
    if (!DATA.sleeve || !DATA.sleeve.js) return;
    if (state.tool) closeTool();
    closeModal(); closeDrawer();
    // AI sleeves the owner added in the dashboard (KI-Sleeves) come first; a slow answer never blocks the builder
    var extra = !DATA.api ? Promise.resolve([]) : Promise.race([
      fetch(DATA.api.replace(/\/$/, '') + '/api/aigen?public=1').then(function (r) { return r.json(); }),
      new Promise(function (r) { setTimeout(function () { r({}); }, 2500); })
    ]).catch(function () { return {}; });
    Promise.all([loadModule(DATA.sleeve, 'czSleeve'), extra]).then(function (res) { var mod = res[0], SL = readJSON('czsl-data') || { items: [] }; SL.items = SL.items.filter(function (it) { return !HIDDEN['sleeve-' + it.id] && !HIDDEN[it.id]; });
      var ex = res[1] || {};
      SL.items = (ex.items || []).map(function (x) { return { id: 'ki-' + x.id, de: x.name, en: x.name, src: x.src, raw: true, group: x.group || 'real' }; }).concat(SL.items);
      // the owner's own categories (dashboard KI-Sleeves) as extra chips
      SL.groups = (SL.groups || []).concat((ex.groups || []).filter(function (g) { return !(SL.groups || []).some(function (h) { return h.id === g.id; }); }));
      var A = builderApi(SL, 'sleeve'); A.edit = o.edit || null; A.backUrl = o.fromLink || o.edit ? sleeveLanding() : null; mod.open(A); if (!o.edit) trackBuilder('bo', 'sleeve'); })
      .catch(function () { toast(t('error_generic'), true); });
  }
  /* hand presets saved by the owner (tattup-own-apps /api/hand-presets); ?vorlage=<token> = the owner's edit link from the
     dashboard (kept for this tab, removed from the address) */
  var PRESET_TOKEN = (function () {
    try {
      var u = new URL(location.href), v = u.searchParams.get('vorlage');
      if (v) { sessionStorage.setItem('czh-preset-token', v); u.searchParams.delete('vorlage'); window.history.replaceState(null, '', u.pathname + u.search + u.hash); }
      return sessionStorage.getItem('czh-preset-token') || '';
    } catch (e) { return ''; }
  })();
  function loadPresets() {
    if (!DATA.api) return Promise.resolve([]);
    return fetch(DATA.api.replace(/\/$/, '') + '/api/hand-presets', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (d) { return d.presets || []; }).catch(function () { return []; });
  }
  /* the builders offer the same motifs as the studio (owner 20.10.2026): the hand stamps as builder data (their own
     default sizes), every other studio motif as the inspo list, one shared menu */
  // ?cat=<menu id> (only the ad landing pages send it): the builder opens on that category once, otherwise «Alle»
  var LINK_CAT = (function () { try { return new URLSearchParams(location.search).get('cat') || ''; } catch (e) { return ''; } })();
  function linkCat() { var c = LINK_CAT; LINK_CAT = ''; return c; }
  function allMotifs() {
    var hand = {}; HAND_SRC.items.forEach(function (it) { hand[it.id] = 1; });
    return { categories: INSPO.categories, items: INSPO.items.filter(function (it) { return !hand[it.id]; }) };
  }
  function openHandBuilder() {
    if (!DATA.hand || !DATA.hand.js) return;
    if (state.tool) closeTool();
    closeModal(); closeDrawer();
    Promise.all([loadHandModule(), loadPresets()]).then(function (res) {
      var mod = res[0];
      var a = builderApi({ categories: [], items: regroup(HAND_SRC.items) }, 'hand', allMotifs());
      a.startCat = linkCat();
      a.presets = res[1].filter(function (p) { return p.items.every(function (it) { return !HIDDEN[it.id]; }); });
      a.presetToken = PRESET_TOKEN; a.presetApi = DATA.api ? DATA.api.replace(/\/$/, '') + '/api/hand-presets' : '';
      mod.open(a);
      trackBuilder('bo', 'hand');
    }).catch(function () { toast(t('error_generic'), true); });
  }
  /* Script Builder (owner 20.10.2026): the hand builder on the man's raised forearm, Script tab preselected –
     ads link to ?builder=script */
  function openScriptBuilder(photo) {
    if (!DATA.hand || !DATA.hand.js) return;
    if (state.tool) closeTool();
    closeModal(); closeDrawer();
    loadHandModule().then(function (mod) {
      // only lettering under «Motive», already selected (owner 28.10.2026); the hand builder keeps all motifs
      var lettering = function (it) { return it.cat === 'script'; }, mot = allMotifs();
      var a = builderApi({ categories: [], items: regroup(HAND_SRC.items).filter(lettering) }, 'script', { categories: mot.categories.filter(function (c) { return c.id === 'script'; }), items: mot.items.filter(lettering) });
      linkCat(); a.mode = 'script'; a.startCat = 'script'; a.minSize = 'huge';
      // the man's raised forearm first, the woman's back to try script there too (owner 20.10.2026)
      a.photos = [{ id: 'm-armup', label: t('script_photo_arm') }, { id: 'f-fullback', label: t('script_photo_back') }];
      if (photo) a.startPhoto = photo;
      mod.open(a);
      trackBuilder('bo', 'script');
    }).catch(function () { toast(t('error_generic'), true); });
  }
  /* Script Builder link (owner 28.10.2026): first ask where the lettering goes – the woman's back or the man's forearm;
     ?photo=back / ?photo=arm skip the question (own ads per photo) */
  function openScriptChoice() {
    var pick = { back: 'f-fullback', arm: 'm-armup' }[new URLSearchParams(location.search).get('photo')];
    if (pick) { openScriptBuilder(pick); return; }
    var opts = [['f-fullback', 'script_photo_back'], ['m-armup', 'script_photo_arm']].map(function (o) {
      var mk = MOCK.all.filter(function (m) { return m.id === o[0]; })[0];
      return '<button type="button" data-sp="' + o[0] + '"><img src="' + esc(mk && mk.thumb) + '" alt=""><span>' + esc(t(o[1])) + '</span></button>';
    }).join('');
    var m = openModal('<h2>' + t('script_pick_title_html') + '</h2><p>' + esc(t('script_pick_text')) + '</p><div class="czs-gender czs-gender--script">' + opts + '</div>', { locked: true, scoped: true });
    m.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-sp]'); if (!b) return;
      closeModal();
      openScriptBuilder(b.getAttribute('data-sp'));
    });
  }
  /* the builder hands over flat items in cm on a sheet: put them on the canvas at exactly that size */
  function placeHandItem(it, kindVia) {
    var id = uid();
    var ready = it.kind === 'upload'
      ? Promise.resolve(imgs[id] = { raw: it.raw, clean: it.clean, auto: it.auto, file: it.file, srcUrl: it.srcUrl || null, ai: !!it.ai, name: it.name || null, w: it.w, h: it.h, srcW: it.srcW, srcH: it.srcH, kind: 'upload', via: kindVia })
      : loadImage(it.vec || it.src).then(function (img) {
        var k = Math.min(1, RASTER / Math.max(img.naturalWidth, img.naturalHeight));
        var w = Math.round(img.naturalWidth * k), h = Math.round(img.naturalHeight * k), c = document.createElement('canvas'); c.width = w; c.height = h;
        c.getContext('2d').drawImage(img, 0, 0, w, h);
        imgs[id] = { raw: c.toDataURL('image/png'), clean: null, w: w, h: h, kind: 'inspo', inspo: it.inspo, vec: it.vec || null, via: kindVia };
      });
    return ready.then(function () {
      var im = imgs[id], useClean = it.kind === 'upload' && !!im.clean && it.useClean !== false;
      if (it.kind === 'upload') preupload(id);
      return F.FabricImage.fromURL(useClean ? im.clean : im.raw).then(function (o) {
        o.czId = id; o.czKind = it.kind === 'upload' ? 'upload' : 'inspo'; o.czBg = useClean;
        var k = it.wCm * LOGICAL / o.width;
        o.set({ scaleX: k, scaleY: k, flipX: !!it.flipX, angle: it.angle || 0, originX: 'center', originY: 'center', left: it.x * LOGICAL, top: it.y * LOGICAL });
        decorate(o); fc.add(o);
      });
    });
  }
  function applyHandSet(res) {
    sizeBase = null;
    restoring = true;
    fc.discardActiveObject();
    fc.remove.apply(fc, fc.getObjects());
    setSize(res.size, true);
    return Promise.all(res.items.map(function (it) { return placeHandItem(it, res.kind || 'hand'); })).then(function () {
      restoring = false;
      fc.requestRenderAll();
      pushHistory();
      state.handPreview = { url: res.preview, at: hIndex, kind: res.kind || 'hand' };
      if (state.mode !== 'design') setMode('design');
      if (!res.silent) toast(t(res.kind === 'sleeve' ? 'sleeve_applied' : res.kind === 'script' ? 'script_applied' : 'hand_applied', { size: sizeLabel(null, true) }));
    }).catch(function () { restoring = false; pushHistory(); toast(t('error_generic'), true); });
  }

  /* bars of other apps fixed to the bottom of the screen (cookie banner on a first visit, Shopify's
     preview bar) would cover the tools and the buy button: the studio ends above them instead */
  var inset = -1;
  function foreign(x, y) {
    var n = document.elementFromPoint(x, y);
    // page content (theme sections) doesn't count, only bars laid over it
    return !!n && !root.contains(n) && n !== document.body && n !== document.documentElement && !(n.closest && n.closest('.shopify-section'));
  }
  /* the cookie banner (Pandectes bottom bar) comes on a first visit only after the studio is shown: making room for it
     then moved the whole tool (layout shift). Without a consent cookie its space is kept free from the start, with the
     bar's height per screen width (measured 19.10.2026, DE / EN); once the bar is there its real height counts. */
  // given up when no bar came: 6 s after the start and 2.5 s after the page load (slow phones), at the latest after 20 s
  var bannerT0 = Date.now(), bannerLoad = document.readyState === 'complete' ? bannerT0 : 0, bannerSeen = false;
  if (!bannerLoad) window.addEventListener('load', function () { bannerLoad = Date.now(); });
  function bannerAhead(vh, vw) {
    var now = Date.now();
    if (bannerSeen || now - bannerT0 > 20000 || (now - bannerT0 > 6000 && bannerLoad && now - bannerLoad > 2500)) return 0;
    var ps = window.pandectesBannerSettings, st = ps && ps.dialogs && ps.dialogs.notice && ps.dialogs.notice.style;
    if (!st || st.type !== 'bar' || st.position !== 'bottom' || (ps.visibility && ps.visibility.enabled === false)) return 0;
    if (/(^|;\s*)_pandectes_gdpr=/.test(document.cookie) || navigator.globalPrivacyControl) return 0;
    var host = document.querySelector('pandectes-cmp'), dlg = host && host.shadowRoot && host.shadowRoot.querySelector('dialog.notice');
    if (dlg && dlg.getBoundingClientRect().height > 0) { bannerSeen = true; return 0; }
    var de = DATA.locale && DATA.locale.indexOf('de') === 0;
    var h = vw < 400 ? 201 : vw < 500 ? 230 : vw < 520 ? (de ? 183 : 162) : vw < 580 ? (de ? 162 : 141) : vw < 640 ? (de ? 141 : 121) : 121;
    // the same rounding as the scan in syncBottomInset (6 px steps), so the real bar later gives the same value
    return Math.min(8 + 6 * Math.floor((h - 2) / 6), Math.round(vh * 0.6));
  }
  function syncBottomInset() {
    if (drawerOpen() || window.scrollY > 4) return; // measure only the studio at the top
    // with a dialog / the tour open only re-check while a bar covers the bottom: the cookie banner closing gives
    // the studio its full height back right away (dialog + tour live inside the studio, they never count as a bar)
    if ((modalEl || onb) && inset <= 0) return;
    var vh = window.innerHeight, vw = window.innerWidth, cover = 0;
    var xs = [vw * 0.2, vw * 0.5, vw * 0.8];
    // walk up from the bottom edge while something that isn't the studio sits on top (max. 60 % of the screen)
    for (var y = vh - 2; y > vh * 0.4; y -= 6) {
      var hidden = xs.filter(function (x) { return foreign(x, y); }).length >= 2;
      if (!hidden) break;
      cover = Math.ceil(vh - y + 6);
    }
    cover = Math.max(cover, bannerAhead(vh, vw));
    if (Math.abs(cover - inset) < 4) return;
    inset = cover;
    root.style.setProperty('--czs-inset', cover + 'px');
    if (onb) setTimeout(showOnb, 60); // the tour's spotlight follows the new layout
  }
  syncBottomInset();
  setInterval(syncBottomInset, 800);
  // closing the cookie banner (click on its buttons): give the height back right when it is gone, so it still counts
  // as a reaction to the click (no layout shift) – the 800 ms check alone came too late for that
  window.addEventListener('click', function (e) {
    var host = document.querySelector('pandectes-cmp');
    if (!host || !e.composedPath || e.composedPath().indexOf(host) < 0) return;
    var n = 0, id = setInterval(function () { var was = inset; syncBottomInset(); if (inset !== was || ++n > 40) clearInterval(id); }, 40);
  }, true);

  /* ---------- resize ---------- */
  var ro = new ResizeObserver(function () { if (state.mode === 'design') layoutPaper(); else resizeSkin(); positionObjbar(); });
  ro.observe(el.board); ro.observe(el.skinWrap);
  window.addEventListener('resize', function () { closeCtx(); });

  /* ---------- AI generator → studio handoff ----------
     The generator's "order" button opens the old size product page (/products/m-tattoo?design_url=…&design_id=…), which
     forwards here with ?size= (sections/cz-size-redirect.liquid). design_url is a same-origin app proxy path
     (/apps/tattup/design-image?src=…). URLSearchParams.get() decodes it
     ONE level, the inner src= stays encoded for the proxy (never decodeURIComponent it); only /apps/tattup/ paths are
     fetched. The params leave the URL right away, so a reload does not add the design twice. */
  var HANDOFF = (function () {
    var q = new URLSearchParams(location.search), u = q.get('design_url'), id = q.get('design_id') || '';
    if (!u && !q.has('design_id')) return null;
    try { var c = new URL(location.href); c.searchParams.delete('design_url'); c.searchParams.delete('design_id'); window.history.replaceState(null, '', c.pathname + c.search + c.hash); } catch (e) {}
    if (!u || u.indexOf('/apps/tattup/') !== 0) return null;
    return { url: u, id: id.slice(0, 120) };
  })();
  /* fresh design, size from ?size=, then the image goes onto the canvas exactly like an upload (background removal,
     resolution check); the design id travels with the cart line as _ai_design_id (stored until the design is reset) */
  function aiHandoff(h) {
    if (state.editing) setEditing(null);
    resetDesign();
    var want = new URLSearchParams(location.search).get('size');
    if (want && sizeByCode(want) && want !== state.size) setSize(want, true);
    if (h.id) store('ai-id', h.id);
    toast(t('upload_processing'));
    return fetch(h.url, { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) throw new Error('img');
      return res.blob();
    }).then(function (blob) {
      var type = blob.type || 'image/png';
      if (!/^image\//.test(type)) throw new Error('type');
      var file = new File([blob], 'ki-design.' + (type.split('/')[1] || 'png').replace('jpeg', 'jpg').replace(/\+.*$/, ''), { type: type });
      return addUpload(file, { trim: true, ai: true, aiUrl: h.url });
    }).catch(function () { toast(t('error_generic'), true); });
  }

  /* ---------- init ---------- */
  var startSize = (function () {
    var q = new URLSearchParams(location.search).get('size');
    var s = q && sizeByCode(q) ? q : store('size');
    return s && sizeByCode(s) ? s : SIZES[0].code;
  })();
  state.size = startSize;
  root.setAttribute('data-mode', 'design');
  renderSizes();
  setSize(startSize, true);
  // the UI is complete (sizes, panel, bottom inset): show it in one go – no half-built frame that then jumps (CSS .is-ready)
  syncBottomInset();
  root.classList.add('is-ready');
  loadOwnPhoto().then(function () { if (state.mode === 'skin') renderSpots(); });
  if (DATA.api) fetch(DATA.api.replace(/\/$/, '') + '/api/motifs', { headers: { Accept: 'application/json' } }).then(function (res) { return res.json(); }).then(function (d) {
    (d.hidden || []).forEach(function (id) { HIDDEN[id] = 1; }); buildInspo(); if (state.tool === 'inspo') renderInspoGrid();
  }).catch(function () {});
  loadAutosave().then(function (restored) {
    if (restored) {
      setSize(state.size, true); toast(t('restored'));
      // a link with ?size= (size cards on /pages/customizer) opens in that size: the restored design keeps its cm
      // (reduced only if it doesn't fit, with the toast)
      var wantS = new URLSearchParams(location.search).get('size');
      if (wantS && sizeByCode(wantS) && wantS !== state.size) setSize(wantS);
    }
    history = [snapshot()]; hIndex = 0; syncHistoryButtons(); updateEmpty();
    // still editing a cart line (reload): keep the update mode, the cart check below ends it if the line is gone
    var ed = null; try { ed = JSON.parse(store('editing') || 'null'); } catch (e) {}
    if (restored && ed && ed.id) setEditing(ed); else if (ed) setEditing(null);
    fetchCart().then(syncCart).catch(function () {});
    // model picker / tour / hand-offs start right away – never wait for the cookie banner (it stays answerable on top)
    var firstRun = function () {
      if (HANDOFF) {
        store('onb-done', '1');
        if (!state.gender) openGender(function () { aiHandoff(HANDOFF); }); else aiHandoff(HANDOFF);
        return;
      }
      var wantE = new URLSearchParams(location.search).get('edit');
      if (wantE) {
        try { var u = new URL(location.href); u.searchParams.delete('edit'); window.history.replaceState(null, '', u.pathname + u.search + u.hash); } catch (e) {}
        store('onb-done', '1');
        if (!state.gender) openGender(function () { editCartDesign(wantE); }); else editCartDesign(wantE);
        return;
      }
      var wantB = new URLSearchParams(location.search).get('builder'), opener = wantB === 'hand' ? openHandBuilder : wantB === 'sleeve' ? function () { openSleeveBuilder({ fromLink: true }); } : wantB === 'script' ? openScriptChoice : null;
      // the Script Builder asks back / forearm itself: no woman / man question first (ad links land right in it)
      if (opener) { if (!state.gender && wantB !== 'script') openGender(opener); else opener(); }
      else if (!state.gender) openGender(function () { startOnboarding(false); });
      else startOnboarding(false);
    };
    firstRun();
  });

  /* read-only helpers for automated QA */
  window.czsStudio = {
    version: 2,
    // QA hooks: a 600 px cut-out from the middle of the 300 DPI print file (checks print sharpness)
    printCrop: function () { return renderDesignCanvas(PRINT_PPC, null).then(function (c) { inkOnly(c); var o = document.createElement('canvas'); o.width = o.height = 600; o.getContext('2d').drawImage(c, (c.width - 600) / 2, (c.height - 600) / 2, 600, 600, 0, 0, 600, 600); return { w: c.width, h: c.height, url: o.toDataURL('image/png') }; }); },
    elements: function () { return designSummary().elements; },
    // the whole print file as it goes to production (PNG data URL) and an AI image inserted like a generated one
    printFile: function () { return exportPrint().then(function (b) { return new Promise(function (res) { var r = new FileReader(); r.onload = function () { res(r.result); }; r.readAsDataURL(b); }); }); },
    insertAi: function (url, prompt) { aiInsert(url, prompt || 'qa'); },
    // QA: put element i at the centre x/y (cm) with width w (cm) and angle a
    arrange: function (list) { var objs = fc.getObjects(); list.forEach(function (s) { var o = objs[s[0]]; if (!o) return; var k = s[3] * LOGICAL / o.width; o.set({ originX: 'center', originY: 'center', left: s[1] * LOGICAL, top: s[2] * LOGICAL, scaleX: k, scaleY: k, angle: s[4] || 0 }); o._czAuto = false; o.setCoords(); }); fc.discardActiveObject(); fc.requestRenderAll(); pushHistory(); },
    previewFile: function () { var sz = curSize(); return renderDesignCanvas(Math.min(60, 900 / Math.max(sz.w, sz.h)), '#ffffff').then(function (c) { return c.toDataURL('image/png'); }); },
    count: function () { return fc.getObjects().length; },
    kinds: function () { return fc.getObjects().map(function (o) { return o.czKind; }); },
    activeFont: function () { var o = activeText() || fc.getObjects().filter(function (x) { return x.czKind === 'text'; }).pop(); return o ? o.czFont : null; },
    bounds: function () {
      var objs = fc.getObjects(); if (!objs.length) return null;
      var inside = objs.every(function (o) { return o.getCoords().every(function (pt) { return pt.x >= -1 && pt.y >= -1 && pt.x <= LW() + 1 && pt.y <= LH() + 1; }); });
      return { inside: inside, n: objs.length, w: objs[0].getScaledWidth() / LOGICAL };
    },
    activeScreen: function () {
      var o = fc.getActiveObject() || fc.getObjects()[0]; if (!o) return null;
      var r = el.board.getBoundingClientRect(), pts = o.getCoords();
      var c = o.getCenterPoint(), s = toScreen(c.x, c.y);
      var tr = pts.reduce(function (a, p) { return p.x + -p.y > a.x + -a.y ? p : a; });
      var trs = toScreen(tr.x, tr.y);
      var top = pts.reduce(function (a, p) { return p.y < a.y ? p : a; });
      var mtr = toScreen((pts[0].x + pts[1].x) / 2, (pts[0].y + pts[1].y) / 2);
      return { x: r.left + s.x, y: r.top + s.y, trx: r.left + trs.x, try: r.top + trs.y, mtrx: r.left + mtr.x, mtry: r.top + mtr.y - 38, angle: o.angle, topY: r.top + toScreen(0, top.y).y };
    },
    placement: function () { var m = currentMockup(); return m ? Object.assign({ id: m.id }, placement(m)) : null; },
    placementScreen: function () {
      var m = currentMockup(); if (!m) return null;
      var v = viewTransform(m), pl = placement(m), r = el.skinWrap.getBoundingClientRect();
      return { x: r.left + v.ox + pl.x * v.s, y: r.top + v.oy + pl.y * v.s };
    },
    mode: function () { return state.mode; },
    skinRot: function () { var m = currentMockup(); return m ? placement(m).rot : null; },
    // skin view: rotation handle centre + cm figures on the frame (page coordinates)
    skinUI: function () {
      if (el.skinUi.hidden || state.mode !== 'skin') return null;
      var b = function (n) { var r = n.getBoundingClientRect(); return { x: r.left + r.width / 2, y: r.top + r.height / 2, w: r.width, h: r.height, text: n.textContent, visible: !n.hidden && r.width > 0 }; };
      return { handle: b(el.skinRot), w: b($('[data-sdim="w"]', el.skinUi)), h: b($('[data-sdim="h"]', el.skinUi)), sheetLabel: !!el.skinUi.querySelector('[data-sdim="s"]'), scale: b(el.skinScale), box: designBox() };
    },
    nudge: function () { return !!nudge; },
    own: function () { return OWN ? { active: !!state.ownActive && currentMockup() === OWN, ppc: OWN.ppc, w: OWN.w, h: OWN.h, masked: !!(skin.mask.own && skin.mask.own.canvas) } : null; },
    editing: function () { return state.editing ? Object.assign({}, state.editing) : null; },
    cta: function () { var b = $('.czs-cta[data-act="cart"]'); return b ? b.textContent : ''; },
    pulse: function () { return pulseId; }
  };
})();
